(function () {
  'use strict';

  const VERSION = 'ms-theme-aa-v3';
  const RUNTIME_IDENTITY = 'ms-theme-aa-v3-zoorix-cart-r1';
  const READY_CART_OFFER_LABEL = '+Kurv - Be om tilbud';
  const CUSTOMER_OUTPUT_VERSION = 'ms-customer-output-v1';
  const CUSTOMER_OUTPUT_MESSAGES = Object.freeze({
    cart: 'Kunne ikke legge varen i handlekurven. Prøv igjen.',
    load: 'Produktet kunne ikke lastes inn. Åpne produktsiden og prøv igjen.',
    network: 'Vi fikk ikke kontakt akkurat nå. Kontroller tilkoblingen og prøv igjen.',
    product: 'Produktet kan ikke bestilles akkurat nå. Kontakt oss hvis du trenger hjelp.',
    unavailable: 'Produktet er ikke tilgjengelig akkurat nå.',
    boot: 'Produktvelgeren kunne ikke starte. Last siden på nytt og prøv igjen.',
    quantity: 'Denne mengden kan ikke bestilles akkurat nå. Prøv igjen eller kontakt oss.',
    accessory: 'Vi fikk ikke klargjort tilbehøret akkurat nå. Prøv igjen, eller kontakt oss hvis problemet fortsetter.',
    stale: 'Nettbutikken er oppdatert. Siden lastes inn på nytt …',
    blocked: 'Nettbutikken er oppdatert. Last siden på nytt og prøv igjen.',
    inventory: 'Det er ikke nok varer tilgjengelig på lager.'
  });

  function installCustomerOutputContract() {
    const existing = window.MSCustomerOutput;
    if (
      existing
      && existing.version === CUSTOMER_OUTPUT_VERSION
      && typeof existing.customerMessageForError === 'function'
    ) return existing;

    const approvedMessages = new Set(Object.values(CUSTOMER_OUTPUT_MESSAGES));
    const text = (value) => String(value === undefined || value === null ? '' : value).trim();
    const inventoryMessage = (value) => {
      const raw = text(value);
      const match = raw.match(/Det er kun\s+(\d+)\s+stykk tilgjengelig på lager\.?/i)
        || raw.match(/Kun\s+(\d+)\s+varer?\s+ble\s+lagt\s+til/i)
        || raw.match(/Only\s+(\d+)\s+(?:items?|products?)\s+(?:were\s+)?added/i);
      return match ? `Det er kun ${match[1]} stykk tilgjengelig på lager.` : '';
    };
    const customerMessageForError = (error, options) => {
      const config = options && typeof options === 'object' ? options : {};
      const detail = config.detail && typeof config.detail === 'object' ? config.detail : {};
      const payload = detail.payload || error?.payload || error?.data || null;
      const candidates = [
        config.customerMessage,
        detail.customerMessage,
        error?.customerMessage,
        payload?.description,
        payload?.message,
        payload?.error,
        error?.message,
        config.raw
      ].map(text).filter(Boolean);
      const approved = candidates.find((value) => approvedMessages.has(value));
      if (approved) return approved;
      for (const value of candidates) {
        const inventory = inventoryMessage(value);
        if (inventory) return inventory;
      }

      const code = text(config.code || detail.type || error?.code || error?.msPurchaseErrorType).toLowerCase();
      const raw = `${code} ${candidates.join(' ')}`.toLowerCase();
      if (code === 'storefront_release_stale') return CUSTOMER_OUTPUT_MESSAGES.stale;
      if (code === 'storefront_release_blocked') return CUSTOMER_OUTPUT_MESSAGES.blocked;
      if (/abort|timeout|network|fetch|transport|offline|failed to fetch|load failed/.test(raw)) {
        return CUSTOMER_OUTPUT_MESSAGES.network;
      }
      if (/inventory|availability|not enough|ikke nok/.test(raw)) return CUSTOMER_OUTPUT_MESSAGES.inventory;
      if (/sold[-_ ]?out|unavailable|utsolgt|ikke tilgjengelig/.test(raw)) return CUSTOMER_OUTPUT_MESSAGES.unavailable;
      if (/dependency|accessor|tilbehør/.test(raw)) return CUSTOMER_OUTPUT_MESSAGES.accessory;
      if (/quantity|amount|mengde|derived.lines|calculator.block/.test(raw)) return CUSTOMER_OUTPUT_MESSAGES.quantity;
      if (/missing.*variant|missing.*product|missing.*coverage|product.data|variant.data|produktvariant|kunne ikke bekreftes/.test(raw)) {
        return CUSTOMER_OUTPUT_MESSAGES.product;
      }
      if (/boot|motor.*missing|family.*missing|runtime.*missing/.test(raw)) return CUSTOMER_OUTPUT_MESSAGES.boot;
      if (config.surface === 'quick-shop-load' || config.action === 'load') return CUSTOMER_OUTPUT_MESSAGES.load;
      return CUSTOMER_OUTPUT_MESSAGES.cart;
    };
    const contract = Object.freeze({
      version: CUSTOMER_OUTPUT_VERSION,
      messages: CUSTOMER_OUTPUT_MESSAGES,
      customerMessageForError
    });
    window.MSCustomerOutput = contract;
    return contract;
  }

  const CUSTOMER_OUTPUT = installCustomerOutputContract();

  function customerMessageForError(error, options) {
    return CUSTOMER_OUTPUT.customerMessageForError(error, options);
  }

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function setExpanded(trigger, expanded) {
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function firstFocusable(root) {
    return qs(focusableSelector, root);
  }

  function visibleFocusableElements(root) {
    if (!root) return [];
    return qsa(focusableSelector, root).filter(function (element) {
      if (!element || element.disabled) return false;
      if (element.closest('[hidden], [aria-hidden="true"]')) return false;
      if (typeof window.getComputedStyle === 'function') {
        const style = window.getComputedStyle(element);
        if (!style || style.display === 'none' || style.visibility === 'hidden') return false;
      }
      return element.getClientRects && element.getClientRects().length > 0;
    });
  }

  function focusElementSafely(element) {
    if (!element || typeof element.focus !== 'function') return false;
    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
    return true;
  }

  function trapFocusWithin(root, event) {
    if (!root || !event || event.key !== 'Tab') return false;
    const focusable = visibleFocusableElements(root);
    const fallback = root.matches && root.matches('[tabindex]') ? root : firstFocusable(root);

    if (!focusable.length) {
      event.preventDefault();
      focusElementSafely(fallback || root);
      return true;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (!root.contains(active)) {
      event.preventDefault();
      focusElementSafely(first);
      return true;
    }

    if (event.shiftKey && active === first) {
      event.preventDefault();
      focusElementSafely(last);
      return true;
    }

    if (!event.shiftKey && active === last) {
      event.preventDefault();
      focusElementSafely(first);
      return true;
    }

    return false;
  }

  const PURCHASE_ADD_ERROR_MESSAGE = CUSTOMER_OUTPUT.messages.cart;
  const PURCHASE_ADD_ERROR_STORAGE_KEY = 'ms_purchase_add_error_attempts_v1';
  const PURCHASE_ADD_ERROR_MARKER = 'Feilkilde MSPA_CART_ADD_FAILED';
  const PURCHASE_ADD_ERROR_TTL_MS = 30 * 60 * 1000;
  const PURCHASE_SUCCESS_TTL_MS = 30 * 1000;
  const recentPurchaseSuccesses = new Map();
  const pendingPurchaseFailures = new Map();

  function purchaseIntent(detail) {
    return detail?.intent || detail?.options?.intent || null;
  }

  function purchaseIntentId(detail) {
    const intent = purchaseIntent(detail);
    const value = intent && intent.id;
    return typeof value === 'string' && /^[A-Za-z0-9_-]{8,128}$/.test(value) ? value : '';
  }

  function prunePurchaseSuccesses(now) {
    recentPurchaseSuccesses.forEach((timestamp, key) => {
      if (now - timestamp > PURCHASE_SUCCESS_TTL_MS) recentPurchaseSuccesses.delete(key);
    });
  }

  function rememberPurchaseSuccess(detail) {
    const intentId = purchaseIntentId(detail);
    if (!intentId) return '';
    const now = Date.now ? Date.now() : new Date().getTime();
    prunePurchaseSuccesses(now);
    recentPurchaseSuccesses.set(intentId, now);
    return intentId;
  }

  function purchaseSucceededRecently(detail) {
    const intentId = purchaseIntentId(detail);
    if (!intentId) return false;
    const now = Date.now ? Date.now() : new Date().getTime();
    prunePurchaseSuccesses(now);
    const timestamp = recentPurchaseSuccesses.get(intentId);
    return Number.isFinite(timestamp) && now - timestamp <= PURCHASE_SUCCESS_TTL_MS;
  }

  function purchaseLayerErrorType(error) {
    const status = Number(error?.status || error?.response?.status || error?.payload?.status || 0);
    if (status === 429) return 'cart_rate_limited_or_challenged';
    if (status >= 500) return 'cart_server_error';
    if (status >= 400) return 'cart_rejected';
    if (error?.name === 'AbortError') return 'cart_timeout';
    return 'cart_transport_error';
  }

  function purchaseLayerPayloadMessage(error, detail) {
    const payload = detail?.payload || error?.payload || null;
    const value = payload && (payload.description || payload.message || payload.error);
    return String(value || error?.message || '').trim();
  }

  function purchaseLayerInventoryContext(error, detail) {
    const type = detail?.type || error?.msPurchaseErrorType || purchaseLayerErrorType(error);
    const status = Number(detail?.status || error?.status || error?.response?.status || error?.payload?.status || 0);
    if (type !== 'cart_rejected' && !(status >= 400 && status < 500)) return null;

    const intentItems = Array.isArray(detail?.intent?.items) ? detail.intent.items : [];
    const purchaseSurfaces = qsa('[data-mspa-product-inventory-management], [data-product-inventory-management]');
    for (const surface of purchaseSurfaces) {
      const management = String(surface.getAttribute('data-mspa-product-inventory-management') || surface.getAttribute('data-product-inventory-management') || '').trim();
      const policy = String(surface.getAttribute('data-mspa-product-inventory-policy') || surface.getAttribute('data-product-inventory-policy') || '').trim();
      const quantity = Number(surface.getAttribute('data-mspa-product-inventory-quantity') || surface.getAttribute('data-product-inventory-quantity') || '');
      if (!management || policy === 'continue' || !Number.isFinite(quantity) || quantity < 0) continue;
      const variantId = Number(surface.getAttribute('data-mspa-product-variant-id') || surface.getAttribute('data-product-variant-id') || 0);
      if (!variantId || !intentItems.length) continue;
      const requested = intentItems.reduce(function (sum, item) {
        const itemId = Number(item?.id || item?.variant_id || item?.variantId || 0);
        return itemId === variantId ? sum + Number(item?.quantity || item?.qty || 0) : sum;
      }, 0);
      if (requested > quantity) return { available: quantity, requested, variantId };
    }

    const selectedOption = qs('[data-ms-purchase-variant] option:checked[data-inventory-management]');
    const management = String(selectedOption?.getAttribute('data-inventory-management') || '').trim();
    const policy = String(selectedOption?.getAttribute('data-inventory-policy') || '').trim();
    const quantity = Number(selectedOption?.getAttribute('data-inventory-quantity') || '');
    if (management && policy !== 'continue' && Number.isFinite(quantity) && quantity >= 0) {
      const variantId = Number(selectedOption?.value || 0);
      const requested = intentItems.reduce(function (sum, item) {
        const itemId = Number(item?.id || item?.variant_id || item?.variantId || 0);
        return itemId === variantId ? sum + Number(item?.quantity || item?.qty || 0) : sum;
      }, 0);
      if (requested > quantity) return { available: quantity, requested, variantId };
    }

    return null;
  }

  function purchaseLayerCustomerMessage(error, detail) {
    const raw = purchaseLayerPayloadMessage(error, detail);
    const stockMatch = raw.match(/Kun\s+(\d+)\s+varer?\s+ble\s+lagt\s+til/i)
      || raw.match(/Only\s+(\d+)\s+(?:items?|products?)\s+(?:were\s+)?added/i);
    if (stockMatch) return `Det er kun ${stockMatch[1]} stykk tilgjengelig på lager.`;
    const inventory = purchaseLayerInventoryContext(error, detail);
    if (inventory) return `Det er kun ${inventory.available} stykk tilgjengelig på lager.`;
    if (/grunnet\s+tilgjengelighet|ikke\s+nok|not\s+enough|availability|inventory/i.test(raw)) {
      return CUSTOMER_OUTPUT.messages.inventory;
    }
    return customerMessageForError(error, {
      action: 'cart',
      customerMessage: detail?.customerMessage,
      detail,
      raw
    });
  }

  function markPurchaseLayerError(error, detail) {
    if (!error || typeof error !== 'object') return error;
    error.msPurchaseLayerError = true;
    error.msPurchaseErrorType = error.msPurchaseErrorType || detail?.type || purchaseLayerErrorType(error);
    if (detail?.status && !error.status) error.status = detail.status;
    if (detail?.payload && !error.payload) error.payload = detail.payload;
    error.customerMessage = purchaseLayerCustomerMessage(error, detail);
    return error;
  }

  function isPurchaseLayerError(value) {
    if (!value || typeof value !== 'object') return false;
    if (value.msPurchaseLayerError) return true;
    if (window.MSPurchaseMotor && typeof window.MSPurchaseMotor.isPurchaseLayerError === 'function') {
      try {
        if (window.MSPurchaseMotor.isPurchaseLayerError(value)) return true;
      } catch (error) {}
    }
    if (window.MSCalculators && typeof window.MSCalculators.isPurchaseLayerError === 'function') {
      try {
        if (window.MSCalculators.isPurchaseLayerError(value)) return true;
      } catch (error) {}
    }
    return false;
  }

  function purchaseErrorCleanUrl(rawUrl) {
    try {
      const url = new URL(rawUrl || window.location.href, window.location.origin);
      url.hash = '';
      url.search = '';
      return url.toString();
    } catch (error) {
      return String(rawUrl || window.location.href || '').split('#')[0].split('?')[0];
    }
  }

  function purchaseErrorProductTitle(detail) {
    const fromDetail = detail?.productTitle || detail?.intent?.productTitle || detail?.intent?.metadata?.productTitle || '';
    if (fromDetail) return String(fromDetail).trim();
    const heading = qs('h1, [data-product-title]');
    if (heading) {
      const attr = heading.getAttribute && heading.getAttribute('data-product-title');
      const text = attr || heading.textContent || '';
      if (text.trim()) return text.trim();
    }
    return String(document.title || '').replace(/\s+[-–]\s+Miljøstein.*$/i, '').trim();
  }

  function purchaseErrorBrowserFamily() {
    const ua = String(navigator.userAgent || '').toLowerCase();
    if (ua.includes('edg/')) return 'edge';
    if (ua.includes('chrome/') || ua.includes('crios/')) return 'chrome';
    if (ua.includes('firefox/') || ua.includes('fxios/')) return 'firefox';
    if (ua.includes('safari/') || ua.includes('version/')) return 'safari';
    return 'unknown';
  }

  function purchaseErrorEndpoint() {
    return '';
  }

  function purchaseErrorContext(detail) {
    const canonical = qs('link[rel="canonical"]');
    const rawUrl = detail?.productUrl || detail?.url || canonical?.href || window.location.href;
    return {
      productUrl: purchaseErrorCleanUrl(rawUrl),
      productTitle: purchaseErrorProductTitle(detail),
      source: detail?.source || 'purchase-layer',
      type: detail?.type || detail?.error?.msPurchaseErrorType || purchaseLayerErrorType(detail?.error),
      status: Number(detail?.status || detail?.error?.status || detail?.error?.response?.status || 0) || null
    };
  }

  function purchaseTelemetryItems(detail) {
    const intent = purchaseIntent(detail);
    const source = Array.isArray(intent?.aaLocationLines) && intent.aaLocationLines.length
      ? intent.aaLocationLines
      : Array.isArray(intent?.shippingItems) && intent.shippingItems.length
        ? intent.shippingItems
        : Array.isArray(intent?.items) ? intent.items : [];
    return source.slice(0, 16).map((item) => {
      const variantId = String(item?.variant_id || item?.variantId || item?.id || '');
      const quantity = Number(item?.quantity || item?.qty || 0);
      const sku = String(item?.sku || '').trim();
      return /^\d+$/.test(variantId) && Number.isSafeInteger(quantity) && quantity > 0
        ? { variant_id: variantId, sku: sku || null, quantity }
        : null;
    }).filter(Boolean);
  }

  function purchaseTelemetryDiagnostics(detail, values) {
    const supplied = detail && detail.diagnostics && typeof detail.diagnostics === 'object'
      ? detail.diagnostics
      : {};
    const error = detail && detail.error;
    const unknownCommit = String(error?.code || '').trim() === 'UNKNOWN_COMMIT';
    const rawType = String(
      supplied.error_type
      || detail?.type
      || error?.code
      || error?.name
      || purchaseLayerErrorType(error)
      || 'UNAVAILABLE'
    ).trim();
    const httpStatus = Number(supplied.http_status || detail?.status || error?.status || error?.response?.status || 0) || null;
    return Object.assign({
      postcode: null,
      phase: 'CART_ADD',
      outcome: 'FAILED',
      recovery: unknownCommit || rawType === 'UNKNOWN_COMMIT' ? 'UNKNOWN_COMMIT' : 'NONE',
      error_type: /^[A-Za-z0-9_:-]{1,64}$/.test(rawType) ? rawType : 'UNAVAILABLE',
      http_status: httpStatus,
      operation_id: supplied.operation_id || purchaseIntentId(detail) || null,
      warehouse_key: supplied.warehouse_key || null,
      carrier_key: supplied.carrier_key || null,
      items: Array.isArray(supplied.items) && supplied.items.length
        ? supplied.items.slice(0, 16)
        : purchaseTelemetryItems(detail),
      customer_action: 'ADD',
      customer_impact: 'BLOCKED',
      failure_reason: /^[A-Za-z0-9_:-]{1,64}$/.test(rawType) ? rawType : 'UNAVAILABLE',
      response_class: httpStatus ? `HTTP_${Math.floor(httpStatus / 100)}XX` : 'TRANSPORT_ERROR',
      terminal_outcome: 'FAILED'
    }, supplied, values || {});
  }

  function reportPurchaseTelemetry(detail, code, values, onAccepted) {
    const intent = purchaseIntent(detail);
    const surface = intent && intent.context && intent.context.quickShop === true ? 'QS' : 'QP';
    if (
      window.MSNO_AA_FK7
      && typeof window.MSNO_AA_FK7.reportFrontendError === 'function'
    ) {
      return window.MSNO_AA_FK7.reportFrontendError(
        'PRODUCT_GATE',
        code,
        surface,
        purchaseTelemetryDiagnostics(detail || {}, values),
        onAccepted
      ) !== false;
    }
    return false;
  }

  function prunePendingPurchaseFailures() {
    const now = Date.now();
    pendingPurchaseFailures.forEach((entry, key) => {
      if (now < entry.updatedAt || now - entry.updatedAt > PURCHASE_ADD_ERROR_TTL_MS) {
        pendingPurchaseFailures.delete(key);
      }
    });
  }

  function rememberPendingPurchaseFailure(detail) {
    prunePendingPurchaseFailures();
    const intentId = purchaseIntentId(detail);
    const input = purchaseTelemetryDiagnostics(detail || {});
    const operationId = String(input.operation_id || '');
    if (!intentId || !/^[A-Za-z0-9_-]{8,128}$/.test(operationId)) return;
    const diagnostics = { operation_id: operationId };
    ['phase', 'outcome', 'recovery', 'error_type', 'customer_action', 'customer_impact',
      'failure_reason', 'response_class', 'terminal_outcome', 'warehouse_key', 'carrier_key'].forEach((name) => {
      if (typeof input[name] === 'string' && /^[A-Za-z0-9_.:-]{1,64}$/.test(input[name])) {
        diagnostics[name] = input[name];
      }
    });
    if (/^\d{4}$/.test(String(input.postcode || ''))) diagnostics.postcode = String(input.postcode);
    ['http_status', 'retry_count', 'timeout_ms', 'attempt'].forEach((name) => {
      if (Number.isSafeInteger(input[name]) && input[name] >= 0) diagnostics[name] = input[name];
    });
    diagnostics.items = (Array.isArray(input.items) ? input.items : []).slice(0, 16).map((item) => {
      const variantId = String(item?.variant_id || '');
      if (!/^\d{1,32}$/.test(variantId) || !Number.isSafeInteger(item?.quantity) || item.quantity <= 0) return null;
      const sku = typeof item.sku === 'string' && /^[A-Za-z0-9_./: +()-]{1,128}$/.test(item.sku) ? item.sku : null;
      return { variant_id: variantId, sku, quantity: item.quantity };
    }).filter(Boolean);
    const key = `${operationId}|${intentId}`;
    pendingPurchaseFailures.delete(key);
    while (pendingPurchaseFailures.size >= 32) {
      pendingPurchaseFailures.delete(pendingPurchaseFailures.keys().next().value);
    }
    pendingPurchaseFailures.set(key, {
      updatedAt: Date.now(),
      detail: {
        intent: { id: intentId, context: { quickShop: purchaseIntent(detail)?.context?.quickShop === true } },
        diagnostics
      }
    });
  }

  function recoverPendingPurchaseFailure(operationId, intentId) {
    prunePendingPurchaseFailures();
    if (typeof operationId !== 'string' || !/^[A-Za-z0-9_-]{8,128}$/.test(operationId)) return false;
    const matches = Array.from(pendingPurchaseFailures.entries()).filter(([, entry]) =>
      entry.detail.diagnostics.operation_id === operationId
      && (!intentId || purchaseIntentId(entry.detail) === intentId));
    if (matches.length !== 1) return false;
    const [key, entry] = matches[0];
    return reportPurchaseTelemetry(entry.detail, 'CART_POSTWRITE_RECOVERED', {
      phase: 'CART_POSTWRITE_READBACK',
      outcome: 'RECOVERED',
      recovery: 'CART_RECONCILED',
      customer_impact: 'RECOVERED',
      terminal_outcome: 'RECOVERED'
    }, () => {
      if (pendingPurchaseFailures.get(key) === entry) pendingPurchaseFailures.delete(key);
    });
  }

  function readPurchaseErrorAttempts() {
    try {
      return JSON.parse(window.sessionStorage.getItem(PURCHASE_ADD_ERROR_STORAGE_KEY) || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function writePurchaseErrorAttempts(value) {
    try {
      window.sessionStorage.setItem(PURCHASE_ADD_ERROR_STORAGE_KEY, JSON.stringify(value || {}));
    } catch (error) {}
  }

  function registerPurchaseErrorAttempt(detail) {
    const context = purchaseErrorContext(detail);
    const key = context.productUrl || 'unknown-product';
    const now = Date.now ? Date.now() : new Date().getTime();
    const store = readPurchaseErrorAttempts();
    Object.keys(store).forEach(function (entryKey) {
      if (!store[entryKey] || now - Number(store[entryKey].updatedAt || 0) > PURCHASE_ADD_ERROR_TTL_MS) delete store[entryKey];
    });
    const entry = store[key] && now - Number(store[key].updatedAt || 0) <= PURCHASE_ADD_ERROR_TTL_MS
      ? store[key]
      : { count: 0 };
    entry.count = Number(entry.count || 0) + 1;
    entry.updatedAt = now;
    entry.productTitle = context.productTitle;
    store[key] = entry;
    writePurchaseErrorAttempts(store);
    return Object.assign({}, context, { attemptCount: entry.count, storageKey: key, timestamp: new Date(now).toISOString() });
  }

  function logPurchaseLayerError(detail, context) {
    const payload = {
      marker: PURCHASE_ADD_ERROR_MARKER,
      timestamp: context.timestamp || new Date().toISOString(),
      source: 'mspa',
      component_source: context.source,
      error_type: context.type,
      productUrl: context.productUrl,
      product_url: context.productUrl,
      productTitle: context.productTitle,
      product_title: context.productTitle,
      type: context.type,
      status: context.status,
      status_code: context.status,
      attemptCount: context.attemptCount,
      path: window.location.pathname,
      theme: window.Shopify && window.Shopify.theme ? window.Shopify.theme.id : null,
      theme_id: window.Shopify && window.Shopify.theme ? window.Shopify.theme.id : null,
      browser_family: purchaseErrorBrowserFamily()
    };
    window.MSPurchaseErrorLog = Array.isArray(window.MSPurchaseErrorLog) ? window.MSPurchaseErrorLog : [];
    window.MSPurchaseErrorLog.push(payload);
    document.dispatchEvent(new CustomEvent('ms:purchase-error:log', { detail: payload }));
    const endpoint = purchaseErrorEndpoint();
    const eventPayload = {
      source: 'mspa',
      event: 'mspa_cart_add_failed',
      severity: 'error',
      payload
    };
    const body = JSON.stringify(eventPayload);
    if (endpoint && navigator.sendBeacon) {
      try {
        if (navigator.sendBeacon(endpoint, new Blob([body], { type: 'application/json' }))) return payload;
      } catch (error) {}
    }
    if (endpoint && window.fetch) {
      try {
        window.fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
          keepalive: true,
          mode: 'cors',
          credentials: 'omit'
        }).catch(function () {});
      } catch (error) {}
    }
    return payload;
  }

  function ensurePurchaseAddErrorStyles() {
    if (document.getElementById('msPurchaseAddErrorStyles')) return;
    const style = document.createElement('style');
    style.id = 'msPurchaseAddErrorStyles';
    style.textContent = [
      '.ms-purchase-error-modal{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(17,24,17,.38);}',
      '.ms-purchase-error-modal[hidden]{display:none;}',
      '.ms-purchase-error-modal__dialog{width:min(460px,calc(100vw - 32px));border:1px solid rgba(130,42,42,.24);border-radius:8px;background:#fffdf9;box-shadow:0 24px 70px rgba(0,0,0,.22);padding:22px;color:#203024;}',
      '.ms-purchase-error-modal__title{margin:0 0 8px;font-size:18px;line-height:1.25;font-weight:800;}',
      '.ms-purchase-error-modal__text{margin:0 0 18px;font-size:15px;line-height:1.45;color:#5f2929;}',
      '.ms-purchase-error-modal__actions{display:flex;justify-content:flex-end;gap:10px;flex-wrap:wrap;}',
      '.ms-purchase-error-modal__button{min-height:42px;border:0;border-radius:8px;background:#167a18;color:#fff;font-weight:800;padding:0 18px;cursor:pointer;}',
      '.ms-purchase-error-modal__button--secondary{background:#fff;color:#203024;border:1px solid rgba(32,48,36,.28);}'
    ].join('');
    document.head.appendChild(style);
  }

  function closePurchaseAddErrorModal(intentId) {
    const modal = document.getElementById('msPurchaseAddErrorModal');
    if (!modal) return;
    if (
      intentId
      && modal.__msPurchaseErrorIntentId
      && modal.__msPurchaseErrorIntentId !== intentId
    ) return;
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    modal.__msPurchaseErrorIntentId = '';
    modal.__msPurchaseErrorDetail = null;
  }

  function showPurchaseAddErrorModal(detail) {
    if (purchaseSucceededRecently(detail || {})) {
      closePurchaseAddErrorModal(purchaseIntentId(detail || {}));
      return false;
    }
    ensurePurchaseAddErrorStyles();
    const context = registerPurchaseErrorAttempt(detail || {});
    logPurchaseLayerError(detail || {}, context);
    const errorCode = String(detail?.error?.code || '').trim() === 'UNKNOWN_COMMIT'
      ? 'UNKNOWN_COMMIT'
      : 'CART_ADD_FAILED';
    if (reportPurchaseTelemetry(detail || {}, errorCode)) rememberPendingPurchaseFailure(detail || {});
    let modal = document.getElementById('msPurchaseAddErrorModal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'msPurchaseAddErrorModal';
      modal.className = 'ms-purchase-error-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'msPurchaseAddErrorTitle');
      modal.innerHTML = [
        '<div class="ms-purchase-error-modal__dialog" role="document">',
        '<h2 class="ms-purchase-error-modal__title" id="msPurchaseAddErrorTitle" data-ms-purchase-error-title></h2>',
        '<p class="ms-purchase-error-modal__text" data-ms-purchase-error-text></p>',
        '<div class="ms-purchase-error-modal__actions">',
        '<button class="ms-purchase-error-modal__button" type="button" data-ms-purchase-error-reload>Last siden på nytt</button>',
        '</div>',
        '</div>'
      ].join('');
      modal.addEventListener('click', function (event) {
        if (event.target === modal) closePurchaseAddErrorModal();
        if (event.target.closest('[data-ms-purchase-error-reload]')) {
          closePurchaseAddErrorModal();
          window.location.reload();
        }
      });
      modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closePurchaseAddErrorModal();
        trapFocusWithin(modal, event);
      });
      document.body.appendChild(modal);
    }

    modal.__msPurchaseErrorContext = context;
    modal.__msPurchaseErrorIntentId = purchaseIntentId(detail || {});
    modal.__msPurchaseErrorDetail = detail || {};
    const title = qs('[data-ms-purchase-error-title]', modal);
    const text = qs('[data-ms-purchase-error-text]', modal);
    const reload = qs('[data-ms-purchase-error-reload]', modal);
    if (title) title.textContent = 'Kunne ikke legge i handlekurven';
    if (text) text.textContent = purchaseLayerCustomerMessage(detail?.error, detail);

    modal.removeAttribute('hidden');
    modal.removeAttribute('aria-hidden');
    window.setTimeout(function () {
      focusElementSafely(reload);
    }, 0);
    return true;
  }

  function handlePurchaseLayerError(error, detail) {
    markPurchaseLayerError(error, detail);
    const customerMessage = error.customerMessage || purchaseLayerCustomerMessage(error, detail);
    if (!error.msPurchaseLayerNotified) {
      error.msPurchaseLayerNotified = true;
      document.dispatchEvent(new CustomEvent('ms:purchase:add-error', {
        detail: Object.assign({}, detail || {}, {
          error,
          type: error.msPurchaseErrorType || purchaseLayerErrorType(error),
          customerMessage
        })
      }));
    } else {
      showPurchaseAddErrorModal(Object.assign({}, detail || {}, {
        error,
        type: error.msPurchaseErrorType || purchaseLayerErrorType(error),
        customerMessage
      }));
    }
    return error;
  }

  document.addEventListener('ms:purchase:add-error', function (event) {
    showPurchaseAddErrorModal(event.detail || {});
  });

  function handlePurchaseSuccess(detail, recovery) {
    const intentId = rememberPurchaseSuccess(detail || {});
    const diagnostics = detail && detail.diagnostics;
    if (
      recovery === 'CART_RECONCILED'
      && detail.source === 'mspa-cart-intent'
      && intentId
      && diagnostics
      && diagnostics.phase === 'CART_POSTWRITE_READBACK'
      && diagnostics.outcome === 'RECOVERED'
      && diagnostics.recovery === 'CART_RECONCILED'
    ) {
      recoverPendingPurchaseFailure(diagnostics.operation_id, intentId);
    }
    const modal = document.getElementById('msPurchaseAddErrorModal');
    if (
      !modal
      || modal.hasAttribute('hidden')
      || !intentId
      || modal.__msPurchaseErrorIntentId !== intentId
    ) return;
    closePurchaseAddErrorModal(intentId);
  }

  document.addEventListener('ms:calculator-cart:success', function (event) {
    handlePurchaseSuccess(event.detail || {}, 'SUCCESS_EVENT_CONFIRMED');
  });
  document.addEventListener('ms:calculator:add-success', function (event) {
    handlePurchaseSuccess(event.detail || {}, 'SUCCESS_EVENT_CONFIRMED');
  });
  document.addEventListener('ms:purchase:add-recovered', function (event) {
    handlePurchaseSuccess(event.detail || {}, 'CART_RECONCILED');
  });
  document.addEventListener('aa:cart-reconciled', function (event) {
    const operationId = String(event?.detail?.operation_id || '');
    if (event?.detail?.schema === 'aa-cart-reconciled-v2' && event.detail.outcome === 'RECOVERED') {
      recoverPendingPurchaseFailure(operationId);
    }
    const modal = document.getElementById('msPurchaseAddErrorModal');
    const diagnostics = modal && modal.__msPurchaseErrorDetail
      && modal.__msPurchaseErrorDetail.diagnostics;
    if (
      !modal
      || modal.hasAttribute('hidden')
      || !operationId
      || !diagnostics
      || diagnostics.operation_id !== operationId
    ) return;
    closePurchaseAddErrorModal(modal.__msPurchaseErrorIntentId || '');
  });

  function scrollToElementWithHeaderOffset(target) {
    if (!target) return;
    const header = qs('[data-sticky-header]');
    const headerOffset = header ? Math.min(header.getBoundingClientRect().height, 180) : 0;
    const targetTop = target.getBoundingClientRect().top + window.scrollY - headerOffset - 16;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: reducedMotion ? 'auto' : 'smooth'
    });
  }

  let mediaModalScrollY = 0;
  let mediaModalBodyStyles = null;

  function lockMediaModalScroll() {
    if (mediaModalBodyStyles) return;
    mediaModalScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    mediaModalBodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflow: document.body.style.overflow
    };
    document.body.classList.add('is-media-modal-open');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${mediaModalScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function unlockMediaModalScroll() {
    if (!mediaModalBodyStyles) {
      document.body.classList.remove('is-media-modal-open');
      return;
    }
    const restoreScrollY = mediaModalScrollY;
    document.body.classList.remove('is-media-modal-open');
    document.body.style.position = mediaModalBodyStyles.position;
    document.body.style.top = mediaModalBodyStyles.top;
    document.body.style.left = mediaModalBodyStyles.left;
    document.body.style.right = mediaModalBodyStyles.right;
    document.body.style.width = mediaModalBodyStyles.width;
    document.body.style.overflow = mediaModalBodyStyles.overflow;
    mediaModalBodyStyles = null;
    window.scrollTo(0, restoreScrollY);
  }

  function closeProductMediaModals() {
    let closedMediaModal = false;
    qsa('[data-product-media-modal]:not([hidden])').forEach(function (modal) {
      modal.setAttribute('hidden', '');
      modal.classList.remove('is-zoomed');
      const image = qs('[data-product-media-modal-image]', modal);
      if (image) {
        image.style.removeProperty('transform');
        image.style.removeProperty('transform-origin');
      }
      closedMediaModal = true;
    });
    if (closedMediaModal) unlockMediaModalScroll();
    return closedMediaModal;
  }

  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    const trigger = qs('[data-drawer-open="' + id + '"]');
    const backdrop = qs('[data-drawer-backdrop="' + id + '"]');

    drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    drawer.removeAttribute('hidden');
    if (backdrop) backdrop.removeAttribute('hidden');
    document.body.classList.add('is-drawer-open');
    setExpanded(trigger, true);

    window.setTimeout(function () {
      const focusTarget = firstFocusable(drawer) || drawer;
      focusTarget.focus({ preventScroll: true });
    }, 40);
  }

  function closeDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    const trigger = qs('[data-drawer-open="' + id + '"]');
    const backdrop = qs('[data-drawer-backdrop="' + id + '"]');

    drawer.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.classList.remove('is-drawer-open');
    setExpanded(trigger, false);

    window.setTimeout(function () {
      drawer.setAttribute('hidden', '');
      if (backdrop) backdrop.setAttribute('hidden', '');
      if (trigger) trigger.focus({ preventScroll: true });
    }, 220);
  }

  function bindDrawers(root) {
    qsa('[data-drawer-open]', root).forEach(function (button) {
      if (button.dataset.msDrawerBound === 'true') return;
      button.dataset.msDrawerBound = 'true';
      button.addEventListener('click', function () {
        openDrawer(button.getAttribute('data-drawer-open'));
      });
    });

    qsa('[data-drawer-close]', root).forEach(function (button) {
      if (button.dataset.msDrawerBound === 'true') return;
      button.dataset.msDrawerBound = 'true';
      button.addEventListener('click', function () {
        closeDrawer(button.getAttribute('data-drawer-close'));
      });
    });

    qsa('[data-drawer-backdrop]', root).forEach(function (backdrop) {
      if (backdrop.dataset.msDrawerBound === 'true') return;
      backdrop.dataset.msDrawerBound = 'true';
      backdrop.addEventListener('click', function () {
        closeDrawer(backdrop.getAttribute('data-drawer-backdrop'));
      });
    });

    qsa('.drawer', root).forEach(function (drawer) {
      if (drawer.dataset.msDrawerFocusBound === 'true') return;
      drawer.dataset.msDrawerFocusBound = 'true';
      drawer.addEventListener('keydown', function (event) {
        if (!drawer.classList.contains('is-open') || drawer.hasAttribute('hidden')) return;
        if (event.key === 'Tab') {
          trapFocusWithin(drawer, event);
          return;
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDrawer(drawer.id);
        }
      });
    });
  }

  function bindGallery(root) {
    qsa('[data-product-gallery]', root).forEach(function (gallery) {
      if (gallery.dataset.msGalleryBound === 'true') return;
      gallery.dataset.msGalleryBound = 'true';

      const main = qs('[data-product-gallery-main]', gallery) || qs('.product-gallery__main img', gallery);
      if (!main) return;
      const frame = qs('[data-product-gallery-frame]', gallery) || main.parentElement;
      const thumbs = qsa('[data-product-gallery-thumb]', gallery);
      const modal = qs('[data-product-media-modal]', gallery);
      const modalImage = qs('[data-product-media-modal-image]', gallery);
      const zoomButton = qs('[data-product-gallery-zoom]', gallery);
      const galleryPrevButton = qs('[data-product-gallery-prev]', gallery);
      const galleryNextButton = qs('[data-product-gallery-next]', gallery);
      const galleryStatus = qs('[data-product-gallery-status]', gallery);
      const closeButton = qs('[data-product-media-modal-close]', gallery);
      const prevButton = qs('[data-product-media-modal-prev]', gallery);
      const nextButton = qs('[data-product-media-modal-next]', gallery);
      const modalStatus = qs('[data-product-media-modal-status]', gallery);
      const visualProduct = gallery.closest('.product--visual-commerce');
      const storySections = visualProduct ? qsa('[data-product-story-media-index]', visualProduct) : [];
      const desktopGallery = window.matchMedia('(min-width: 720px)');

      if (modal && modal.parentElement !== document.body) {
        modal.setAttribute('data-product-media-modal-portal', '');
        document.body.appendChild(modal);
      }

      let currentIndex = Math.max(0, thumbs.findIndex(function (thumb) {
        return thumb.getAttribute('aria-current') === 'true';
      }));
      let scrollTicking = false;
      let scrollSwitchTimer = null;
      let switchingTimer = null;
      let manualGalleryLockUntil = 0;
      let modalScale = 1;
      let modalTranslateX = 0;
      let modalTranslateY = 0;
      let modalGesture = null;
      let modalLastTap = 0;

      function clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
      }

      function itemFromIndex(index) {
        const thumb = thumbs[index];
        if (!thumb) {
        return {
          src: main.currentSrc || main.src,
          srcset: main.getAttribute('srcset') || '',
          sizes: main.getAttribute('sizes') || '',
          modalSrc: main.currentSrc || main.src,
          modalSrcset: '',
          modalSizes: '',
          alt: main.getAttribute('alt') || '',
          shape: frame ? frame.getAttribute('data-media-shape') || 'normal' : 'normal',
          aspect: frame ? frame.getAttribute('data-media-aspect') || '' : '',
            focalPoint: frame ? frame.getAttribute('data-focal-point') || main.style.objectPosition || '' : ''
          };
        }
        const thumbImage = qs('img', thumb);
        return {
          src: thumb.getAttribute('data-image-src'),
          srcset: thumb.getAttribute('data-image-srcset') || '',
          sizes: thumb.getAttribute('data-image-sizes') || '',
          modalSrc: thumb.getAttribute('data-modal-src') || thumb.getAttribute('data-image-src'),
          modalSrcset: thumb.getAttribute('data-modal-srcset') || '',
          modalSizes: thumb.getAttribute('data-modal-sizes') || '',
          alt: thumb.getAttribute('data-image-alt') || '',
          shape: thumb.getAttribute('data-media-shape') || 'normal',
          aspect: thumb.getAttribute('data-media-aspect') || '',
          focalPoint: thumb.getAttribute('data-focal-point') || (thumbImage ? thumbImage.style.objectPosition : '') || ''
        };
      }

      function finishImageSwitch() {
        if (frame) frame.classList.remove('is-switching');
      }

      function applyMediaShape(item) {
        if (!frame || !item) return;
        const shape = ['portrait', 'landscape'].includes(item.shape) ? item.shape : 'normal';
        frame.classList.remove(
          'product-gallery__main--portrait',
          'product-gallery__main--landscape',
          'product-gallery__main--normal'
        );
        frame.classList.add(`product-gallery__main--${shape}`);
        frame.setAttribute('data-media-shape', shape);
        if (item.aspect) frame.setAttribute('data-media-aspect', item.aspect);
        if (item.focalPoint) {
          main.style.objectPosition = item.focalPoint;
          if (modalImage) modalImage.style.objectPosition = item.focalPoint;
        } else {
          main.style.removeProperty('object-position');
          if (modalImage) modalImage.style.removeProperty('object-position');
        }
      }

      function updateStatus() {
        const total = Math.max(thumbs.length, 1);
        const text = `${currentIndex + 1} / ${total}`;
        if (galleryStatus) galleryStatus.textContent = text;
        if (modalStatus) modalStatus.textContent = text;
      }

      function preloadNextImage() {
        if (thumbs.length < 2) return;
        const next = itemFromIndex((currentIndex + 1) % thumbs.length);
        if (!next || !next.src) return;
        const image = new Image();
        if (next.sizes) image.sizes = next.sizes;
        if (next.srcset) image.srcset = next.srcset;
        image.src = next.src;
      }

      function preloadModalNeighbors() {
        if (thumbs.length < 2) return;
        [-1, 1].forEach(function (step) {
          const item = itemFromIndex((currentIndex + step + thumbs.length) % thumbs.length);
          if (!item || !item.modalSrc) return;
          const image = new Image();
          if (item.modalSizes) image.sizes = item.modalSizes;
          if (item.modalSrcset) image.srcset = item.modalSrcset;
          image.src = item.modalSrc;
        });
      }

      function applyModalTransform() {
        if (!modalImage) return;
        modalImage.style.transform = `translate3d(${modalTranslateX}px, ${modalTranslateY}px, 0) scale(${modalScale})`;
        if (modal) modal.classList.toggle('is-zoomed', modalScale > 1.02);
      }

      function resetModalZoom() {
        modalScale = 1;
        modalTranslateX = 0;
        modalTranslateY = 0;
        modalGesture = null;
        applyModalTransform();
      }

      function setModalZoom(scale, originEvent) {
        modalScale = clamp(scale, 1, 3.2);
        if (modalScale <= 1.02) {
          modalScale = 1;
          modalTranslateX = 0;
          modalTranslateY = 0;
        } else if (originEvent && modalImage) {
          const rect = modalImage.getBoundingClientRect();
          const x = ((originEvent.clientX - rect.left) / Math.max(rect.width, 1)) * 100;
          const y = ((originEvent.clientY - rect.top) / Math.max(rect.height, 1)) * 100;
          modalImage.style.transformOrigin = `${clamp(x, 0, 100)}% ${clamp(y, 0, 100)}%`;
        }
        applyModalTransform();
      }

      function distanceBetweenTouches(touches) {
        if (!touches || touches.length < 2) return 0;
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      function bindModalGestures() {
        if (!modalImage || modalImage.dataset.msModalGestureBound === 'true') return;
        modalImage.dataset.msModalGestureBound = 'true';

        modalImage.addEventListener('click', function (event) {
          if (!modal || modal.hasAttribute('hidden')) return;
          const now = Date.now();
          if (now - modalLastTap < 280) {
            event.preventDefault();
            setModalZoom(modalScale > 1.02 ? 1 : 2.25, event);
          }
          modalLastTap = now;
        });

        modalImage.addEventListener('touchstart', function (event) {
          if (!modal || modal.hasAttribute('hidden')) return;
          if (event.touches.length === 2) {
            modalGesture = {
              type: 'pinch',
              distance: distanceBetweenTouches(event.touches),
              scale: modalScale
            };
            return;
          }
          const touch = event.touches && event.touches[0];
          if (!touch) return;
          modalGesture = {
            type: modalScale > 1.02 ? 'pan' : 'swipe',
            startX: touch.clientX,
            startY: touch.clientY,
            lastX: touch.clientX,
            lastY: touch.clientY,
            translateX: modalTranslateX,
            translateY: modalTranslateY
          };
        }, { passive: true });

        modalImage.addEventListener('touchmove', function (event) {
          if (!modalGesture || !modal || modal.hasAttribute('hidden')) return;
          if (modalGesture.type === 'pinch' && event.touches.length === 2) {
            event.preventDefault();
            const nextDistance = distanceBetweenTouches(event.touches);
            if (modalGesture.distance > 0) {
              setModalZoom(modalGesture.scale * (nextDistance / modalGesture.distance));
            }
            return;
          }
          if (modalGesture.type !== 'pan') return;
          const touch = event.touches && event.touches[0];
          if (!touch) return;
          event.preventDefault();
          modalTranslateX = modalGesture.translateX + (touch.clientX - modalGesture.startX);
          modalTranslateY = modalGesture.translateY + (touch.clientY - modalGesture.startY);
          modalGesture.lastX = touch.clientX;
          modalGesture.lastY = touch.clientY;
          applyModalTransform();
        }, { passive: false });

        modalImage.addEventListener('touchend', function (event) {
          if (!modalGesture) return;
          const gesture = modalGesture;
          modalGesture = null;
          if (gesture.type !== 'swipe') return;
          const touch = event.changedTouches && event.changedTouches[0];
          if (!touch) return;
          const dx = touch.clientX - gesture.startX;
          const dy = touch.clientY - gesture.startY;
          if (Math.abs(dy) > 90 && Math.abs(dy) > Math.abs(dx) * 1.4) {
            closeMediaModal();
            return;
          }
          if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.25) return;
          stepMediaModal(dx < 0 ? 1 : -1);
        }, { passive: true });

        modalImage.addEventListener('dblclick', function (event) {
          event.preventDefault();
          setModalZoom(modalScale > 1.02 ? 1 : 2.25, event);
        });
      }

      function setActiveImage(index, options) {
        const config = options || {};
        const nextIndex = clamp(index, 0, Math.max(thumbs.length - 1, 0));
        if (!config.force && nextIndex === currentIndex) return;
        if (config.force) window.clearTimeout(scrollSwitchTimer);
        currentIndex = nextIndex;
        const item = itemFromIndex(currentIndex);
        if (!item.src) return;
        applyMediaShape(item);
        if (frame) frame.classList.add('is-switching');
        window.clearTimeout(switchingTimer);
        if (item.sizes) main.setAttribute('sizes', item.sizes);
        else main.removeAttribute('sizes');
        if (item.srcset) main.setAttribute('srcset', item.srcset);
        else main.removeAttribute('srcset');
        main.setAttribute('src', item.src);
        main.setAttribute('alt', item.alt);
        switchingTimer = window.setTimeout(finishImageSwitch, 360);
        thumbs.forEach(function (thumb, thumbIndex) {
          thumb.setAttribute('aria-current', thumbIndex === currentIndex ? 'true' : 'false');
        });
        const activeThumb = thumbs[currentIndex];
        if (activeThumb && typeof activeThumb.scrollIntoView === 'function' && config.force) {
          activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
        updateStatus();
        preloadNextImage();
        if (typeof main.decode === 'function') {
          main.decode().catch(function () {}).finally(finishImageSwitch);
        } else {
          switchingTimer = window.setTimeout(finishImageSwitch, 180);
        }
      }

      function indexFromScroll() {
        if (!visualProduct || !thumbs.length) return currentIndex;
        const storyIndex = indexFromStory();
        if (storyIndex != null) return storyIndex;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        const heroRect = gallery.getBoundingClientRect();
        if (heroRect.top > -viewportHeight * 0.28 && heroRect.bottom > viewportHeight * 0.48) {
          return 0;
        }
        return currentIndex;
      }

      function indexFromStory() {
        if (!storySections.length) return null;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        const anchor = viewportHeight * 0.42;
        let best = null;
        let bestDistance = Infinity;
        storySections.forEach(function (section) {
          if (section.tagName === 'DETAILS' && section.open !== true) return;
          const rect = section.getBoundingClientRect();
          if (rect.height < viewportHeight * 0.14) return;
          if (rect.bottom < 0 || rect.top > viewportHeight) return;
          const distance = Math.abs(rect.top - anchor);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = section;
          }
        });
        if (!best) return null;
        const index = Number(best.getAttribute('data-product-story-media-index'));
        return Number.isFinite(index) ? clamp(Math.round(index), 0, thumbs.length - 1) : null;
      }

      function syncImageToScroll() {
        scrollTicking = false;
        if (!visualProduct || thumbs.length < 2 || !desktopGallery.matches) return;
        if (Date.now() < manualGalleryLockUntil) return;
        const nextIndex = indexFromScroll();
        if (nextIndex === currentIndex) {
          window.clearTimeout(scrollSwitchTimer);
          return;
        }
        window.clearTimeout(scrollSwitchTimer);
        scrollSwitchTimer = window.setTimeout(function () {
          if (Date.now() < manualGalleryLockUntil) return;
          setActiveImage(nextIndex, { fromScroll: true });
        }, 130);
      }

      function requestScrollSync() {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(syncImageToScroll);
      }

      function openMediaModal(index) {
        if (!modal || !modalImage) return;
        setActiveImage(index, { force: true });
        const item = itemFromIndex(currentIndex);
        resetModalZoom();
        if (item.modalSizes) modalImage.setAttribute('sizes', item.modalSizes);
        else modalImage.removeAttribute('sizes');
        if (item.modalSrcset) modalImage.setAttribute('srcset', item.modalSrcset);
        else modalImage.removeAttribute('srcset');
        modalImage.setAttribute('src', item.modalSrc || item.src);
        modalImage.setAttribute('alt', item.alt);
        modal.removeAttribute('hidden');
        lockMediaModalScroll();
        bindModalGestures();
        preloadModalNeighbors();
        if (closeButton) closeButton.focus({ preventScroll: true });
      }

      function closeMediaModal() {
        if (!modal) return;
        modal.setAttribute('hidden', '');
        unlockMediaModalScroll();
        resetModalZoom();
        if (zoomButton) zoomButton.focus({ preventScroll: true });
      }

      function stepMediaModal(step) {
        if (!thumbs.length) return;
        const nextIndex = (currentIndex + step + thumbs.length) % thumbs.length;
        setActiveImage(nextIndex, { force: true });
        const item = itemFromIndex(currentIndex);
        resetModalZoom();
        if (modalImage) {
          if (item.modalSizes) modalImage.setAttribute('sizes', item.modalSizes);
          else modalImage.removeAttribute('sizes');
          if (item.modalSrcset) modalImage.setAttribute('srcset', item.modalSrcset);
          else modalImage.removeAttribute('srcset');
          modalImage.setAttribute('src', item.modalSrc || item.src);
          modalImage.setAttribute('alt', item.alt);
        }
        preloadModalNeighbors();
      }

      function stepGallery(step) {
        if (!thumbs.length) return;
        const nextIndex = (currentIndex + step + thumbs.length) % thumbs.length;
        setActiveImage(nextIndex, { force: true });
        manualGalleryLockUntil = Date.now() + 1200;
      }

      function bindSwipe(target, callback) {
        if (!target) return;
        let startX = 0;
        let startY = 0;
        let active = false;
        target.addEventListener('touchstart', function (event) {
          const touch = event.touches && event.touches[0];
          if (!touch) return;
          startX = touch.clientX;
          startY = touch.clientY;
          active = true;
        }, { passive: true });
        target.addEventListener('touchend', function (event) {
          if (!active) return;
          active = false;
          const touch = event.changedTouches && event.changedTouches[0];
          if (!touch) return;
          const dx = touch.clientX - startX;
          const dy = touch.clientY - startY;
          if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
          callback(dx < 0 ? 1 : -1);
        }, { passive: true });
      }

      thumbs.forEach(function (button, index) {
        button.addEventListener('click', function () {
          setActiveImage(index, { force: true });
          manualGalleryLockUntil = Date.now() + 1200;
        });
      });

      if (visualProduct && thumbs.length > 1) {
        window.addEventListener('scroll', requestScrollSync, { passive: true });
        window.addEventListener('resize', requestScrollSync, { passive: true });
        if (typeof desktopGallery.addEventListener === 'function') {
          desktopGallery.addEventListener('change', requestScrollSync);
        }
        syncImageToScroll();
      }

      if (zoomButton) {
        zoomButton.addEventListener('click', function () {
          openMediaModal(currentIndex);
        });
      }

      if (frame) {
        frame.addEventListener('click', function (event) {
          if (event.target.closest('button')) return;
          openMediaModal(currentIndex);
        });
      }

      if (galleryPrevButton) galleryPrevButton.addEventListener('click', function () { stepGallery(-1); });
      if (galleryNextButton) galleryNextButton.addEventListener('click', function () { stepGallery(1); });
      if (closeButton) closeButton.addEventListener('click', closeMediaModal);
      if (prevButton) prevButton.addEventListener('click', function () { stepMediaModal(-1); });
      if (nextButton) nextButton.addEventListener('click', function () { stepMediaModal(1); });
      if (modal) {
        modal.addEventListener('click', function (event) {
          if (event.target === modal) closeMediaModal();
        });
      }
      document.addEventListener('keydown', function (event) {
        if (!modal || modal.hasAttribute('hidden')) return;
        if (event.key === 'Tab') {
          trapFocusWithin(modal, event);
          return;
        }
        if (event.key === 'Escape') closeMediaModal();
        if (event.key === 'ArrowLeft') stepMediaModal(-1);
        if (event.key === 'ArrowRight') stepMediaModal(1);
      });
      bindSwipe(frame, stepGallery);
      updateStatus();
    });
  }

  let stickyHeaderController = null;

  function bindStickyHeader() {
    const header = qs('[data-sticky-header]');
    if (stickyHeaderController && stickyHeaderController.header === header && header && header.isConnected) return;
    if (stickyHeaderController) {
      stickyHeaderController.destroy();
      stickyHeaderController = null;
    }
    if (!header) return;
    const listeners = [];
    let destroyed = false;
    let updateFrame = null;
    let sizeObserver = null;
    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      listeners.push(function () { target.removeEventListener(type, handler, options); });
    }

    let navHidden = header.classList.contains('site-header--nav-hidden');
    const headerSection = header.closest('.shopify-section-group-header-group');
    let reservedHeaderHeight = 0;
    let measuringExpandedHeader = false;

    function syncHeaderFlowSpace(forceExpandedMeasure) {
      if (destroyed || !headerSection || !header.isConnected || measuringExpandedHeader) return;
      const hadNavHidden = header.classList.contains('site-header--nav-hidden');
      const hadMobileCompact = header.classList.contains('site-header--mobile-compact');
      const compact = hadNavHidden || hadMobileCompact;
      if (compact && !forceExpandedMeasure) return;

      const properties = ['position', 'top', 'left', 'right', 'width'];
      const savedStyles = compact ? properties.map(function (name) {
        return {
          name: name,
          value: header.style.getPropertyValue(name),
          priority: header.style.getPropertyPriority(name)
        };
      }) : [];
      let height = 0;
      measuringExpandedHeader = true;
      try {
        if (compact) {
          // Measure the expanded shape without returning the header to document flow.
          // Restore the original shape synchronously, before the next paint.
          const sectionRect = headerSection.getBoundingClientRect();
          if (!(sectionRect.width > 0)) return;
          header.style.setProperty('position', 'fixed');
          header.style.setProperty('top', '0px');
          header.style.setProperty('left', sectionRect.left + 'px');
          header.style.setProperty('right', 'auto');
          header.style.setProperty('width', sectionRect.width + 'px');
          header.classList.remove('site-header--nav-hidden', 'site-header--mobile-compact');
        }
        height = header.getBoundingClientRect().height;
      } finally {
        if (compact) {
          header.classList.toggle('site-header--nav-hidden', hadNavHidden);
          header.classList.toggle('site-header--mobile-compact', hadMobileCompact);
          savedStyles.forEach(function (entry) {
            if (entry.value) header.style.setProperty(entry.name, entry.value, entry.priority);
            else header.style.removeProperty(entry.name);
          });
        }
        measuringExpandedHeader = false;
      }
      if (height > 0 && Math.abs(height - reservedHeaderHeight) > 0.25) {
        reservedHeaderHeight = height;
        headerSection.style.setProperty('--ms-header-flow-height', height + 'px');
        headerSection.setAttribute('data-ms-header-flow-space', '');
      }
    }

    const update = function () {
      if (destroyed || !header.isConnected) return;
      syncHeaderFlowSpace(false);
      const y = window.scrollY || 0;
      const mobileHeader = !window.matchMedia('(min-width: 720px)').matches;
      const drawerOpen = document.body.classList.contains('is-drawer-open')
        || document.body.classList.contains('ms-premium-nav-open')
        || document.body.classList.contains('ms-premium-mega-open');
      // Compact headers retain their search row. Keep the fixed scroll state
      // while searching so removing it cannot put the header above the viewport.
      const shouldCompact = !drawerOpen && y > 96;
      const shouldExpand = drawerOpen || y < 48;
      const previousCompact = header.classList.contains('site-header--mobile-compact');
      const previousNavHidden = header.classList.contains('site-header--nav-hidden');

      header.classList.toggle('site-header--mobile-compact', mobileHeader && shouldCompact);

      if (shouldExpand) {
        navHidden = false;
        header.classList.remove('site-header--nav-hidden');
      } else if (shouldCompact && !navHidden) {
        navHidden = true;
        header.classList.add('site-header--nav-hidden');
      }
      if (previousCompact !== header.classList.contains('site-header--mobile-compact')
        || previousNavHidden !== header.classList.contains('site-header--nav-hidden')) {
        // Search must measure after the fixed/compact geometry has been applied.
        document.dispatchEvent(new CustomEvent('ms:header-layout-change'));
      }

    };

    function requestUpdate() {
      if (destroyed || updateFrame !== null) return;
      updateFrame = window.requestAnimationFrame(function () {
        updateFrame = null;
        update();
      });
    }
    listen(document, 'ms:navigation-change', update);
    listen(document, 'ms:search-change', update);
    listen(header, 'focusin', requestUpdate);
    listen(header, 'focusout', requestUpdate);
    listen(window, 'scroll', requestUpdate, { passive: true });

    listen(window, 'resize', function () {
      syncHeaderFlowSpace(true);
      update();
    }, { passive: true });
    listen(header, 'load', function (event) {
      if (event.target && event.target.matches && event.target.matches('.site-header__logo img')) {
        syncHeaderFlowSpace(true);
      }
    }, true);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        syncHeaderFlowSpace(true);
      }).catch(function () {});
    }
    if ('ResizeObserver' in window) {
      sizeObserver = new ResizeObserver(function () {
        if (!header.isConnected) {
          sizeObserver.disconnect();
          return;
        }
        syncHeaderFlowSpace(false);
      });
      sizeObserver.observe(header);
    }
    syncHeaderFlowSpace(true);
    update();
    stickyHeaderController = {
      header: header,
      destroy: function () {
        if (destroyed) return;
        destroyed = true;
        if (updateFrame !== null) window.cancelAnimationFrame(updateFrame);
        if (sizeObserver) sizeObserver.disconnect();
        listeners.forEach(function (remove) { remove(); });
        header.classList.remove('site-header--nav-hidden', 'site-header--mobile-compact');
        if (headerSection) {
          headerSection.style.removeProperty('--ms-header-flow-height');
          headerSection.removeAttribute('data-ms-header-flow-space');
        }
      }
    };
  }

  function createHeroHelpRotator(guide, trigger) {
    const panel = qs('[data-ms-hero-help-rotator]');
    const track = panel ? qs('[data-ms-hero-help-track]', panel) : null;
    if (!panel || !track) return null;
    if (panel._msHeroHelpRotator) return panel._msHeroHelpRotator;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let rotateTimer = 0;
    let pulseTimer = 0;
    let helpCard = null;
    const listeners = [];
    function listen(target, type, handler) {
      target.addEventListener(type, handler);
      listeners.push(function () { target.removeEventListener(type, handler); });
    }
    let paused = false;
    let activeIndex = 0;

    function readText(selector, fallback) {
      const node = qs(selector, guide);
      const text = node ? node.textContent.trim() : '';
      return text || fallback;
    }

    function readBodyText() {
      const bodyNode = qs('[data-customer-help-body]', guide);
      if (bodyNode) return bodyNode.textContent.trim();
      const paragraphs = qsa('p', guide).filter(function (paragraph) {
        return !paragraph.classList.contains('customer-help-popover__eyebrow');
      });
      return paragraphs[0] ? paragraphs[0].textContent.trim() : '';
    }

    function buildHelpCard() {
      if (qs('[data-ms-hero-help-card="help"]', track)) return;

      const eyebrow = readText('.customer-help-popover__eyebrow', 'Kundehjelp');
      const heading = readText('h2', 'Kundehjelp åpen 09-23');
      const body = readBodyText();
      const steps = qsa('ol li', guide).map(function (item) {
        return item.textContent.trim();
      }).filter(Boolean);

      const card = document.createElement('div');
      card.className = 'ms-commerce-hero__panel-card ms-commerce-hero__panel-card--help';
      card.setAttribute('data-ms-hero-help-card', 'help');

      const eyebrowNode = document.createElement('p');
      eyebrowNode.textContent = eyebrow;
      card.appendChild(eyebrowNode);

      const headingNode = document.createElement('strong');
      headingNode.textContent = heading;
      card.appendChild(headingNode);

      if (body) {
        const bodyNode = document.createElement('span');
        bodyNode.textContent = body;
        card.appendChild(bodyNode);
      }

      if (steps.length) {
        const list = document.createElement('ol');
        steps.forEach(function (step, index) {
          const item = document.createElement('li');
          item.setAttribute('data-step', String(index + 1));
          item.textContent = step;
          list.appendChild(item);
        });
        card.appendChild(list);
      }

      helpCard = card;
      listen(card, 'click', function () {
        trigger.click();
      });

      track.appendChild(card);
    }

    function cards() {
      return qsa('[data-ms-hero-help-card]', track);
    }

    function isVisible() {
      if (!panel.getClientRects().length) return false;
      return window.getComputedStyle(panel).display !== 'none';
    }

    function showCard(index) {
      const items = cards();
      if (!items.length) return;
      activeIndex = ((index % items.length) + items.length) % items.length;
      items.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === activeIndex);
      });
    }

    function showHelp(auto) {
      const items = cards();
      const helpIndex = items.findIndex(function (item) {
        return item.getAttribute('data-ms-hero-help-card') === 'help';
      });
      if (helpIndex < 0 || !isVisible()) return false;
      showCard(helpIndex);
      if (auto) {
        trigger.classList.add('is-help-pulse');
        window.clearTimeout(pulseTimer);
        pulseTimer = window.setTimeout(function () {
          trigger.classList.remove('is-help-pulse');
        }, 1400);
      }
      return true;
    }

    function startRotation() {
      window.clearInterval(rotateTimer);
      if (reducedMotion || cards().length < 2) return;
      rotateTimer = window.setInterval(function () {
        if (paused || !isVisible()) return;
        showCard(activeIndex + 1);
      }, 8000);
    }

    buildHelpCard();
    showCard(0);
    startRotation();

    listen(panel, 'mouseenter', function () {
      paused = true;
    });
    listen(panel, 'mouseleave', function () {
      paused = false;
    });
    listen(panel, 'focusin', function () {
      paused = true;
    });
    listen(panel, 'focusout', function () {
      paused = false;
    });

    panel._msHeroHelpRotator = {
      canShow: isVisible,
      showHelp: showHelp,
      destroy: function () {
        window.clearInterval(rotateTimer);
        window.clearTimeout(pulseTimer);
        listeners.forEach(function (remove) { remove(); });
        if (helpCard) helpCard.remove();
        delete panel._msHeroHelpRotator;
      }
    };

    return panel._msHeroHelpRotator;
  }

  const customerHelpControllers = new Map();

  function bindCustomerHelpGuide(root) {
    customerHelpControllers.forEach(function (controller, guide) {
      if (!guide.isConnected) controller.destroy();
    });
    qsa('[data-customer-help-guide]:not([data-customer-help-bound])', root).forEach(function (guide) {
      const header = guide.closest('[data-sticky-header]') || qs('[data-sticky-header]');
      const trigger = header ? qs('[data-customer-help-trigger]', header) : qs('[data-customer-help-trigger]');
      const closeButton = qs('[data-customer-help-close]', guide);
      const faqLink = qs('[data-customer-help-faq]', guide);
      if (!trigger) return;

      guide.setAttribute('data-customer-help-bound', 'true');
      const listeners = [];
      const timers = new Set();
      let destroyed = false;
      let openFrame = null;
      function listen(target, type, handler, options) {
        target.addEventListener(type, handler, options);
        listeners.push(function () { target.removeEventListener(type, handler, options); });
      }
      function later(callback, delay) {
        if (destroyed) return 0;
        const timer = window.setTimeout(function () {
          timers.delete(timer);
          if (!destroyed) callback();
        }, delay);
        timers.add(timer);
        return timer;
      }
      function cancelLater(timer) {
        window.clearTimeout(timer);
        timers.delete(timer);
      }

      const introSessionKey = 'ms_customer_help_auto_intro_seen';
      let closeTimer = 0;
      let hideTimer = 0;
      let autoIntroTimer = 0;
      let autoCloseTimer = 0;
      let autoClosePollTimer = 0;
      let openStatusTimer = 0;
      let postcodeStatusAutoCloseTimer = 0;
      const headingNode = qs('[data-customer-help-heading]', trigger);
      const sublineNode = qs('span', trigger);
      const sourceNode = qs('.customer-help-popover__source', guide);
      const postcodeStepNode = qs('.customer-help-popover__body ol li', guide);
      const defaultHeading = headingNode ? headingNode.textContent : '';
      const defaultSubline = sublineNode ? sublineNode.textContent : '';
      const defaultSource = sourceNode ? sourceNode.textContent : '';
      const openHeading = trigger.getAttribute('data-customer-help-open-heading') || defaultHeading || 'Kundehjelp åpen';
      const helpTimezone = trigger.getAttribute('data-customer-help-timezone') || 'Europe/Oslo';
      const openStart = trigger.getAttribute('data-customer-help-open-start') || '09:00';
      const openEnd = trigger.getAttribute('data-customer-help-open-end') || '23:00';
      const heroHelpRotator = createHeroHelpRotator(guide, trigger);
      const customerHelpMobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
      const postcodeStatusAutoCloseMs = 6000;

      function now() {
        return Date.now ? Date.now() : new Date().getTime();
      }

      function introStorageAllowed() {
        try {
          const privacy = window.Shopify && window.Shopify.customerPrivacy;
          return !!(privacy && typeof privacy.preferencesProcessingAllowed === 'function' && privacy.preferencesProcessingAllowed());
        } catch (error) {
          return false;
        }
      }

      function syncIntroStorageConsent() {
        try {
          if (!introStorageAllowed()) {
            window.sessionStorage.removeItem(introSessionKey);
          } else if (guide.getAttribute('data-auto-intro-seen') === 'true') {
            window.sessionStorage.setItem(introSessionKey, '1');
          }
        } catch (error) {}
      }

      function introSeenThisSession() {
        if (introStorageAllowed()) {
          try {
            if (window.sessionStorage.getItem(introSessionKey) === '1') return true;
          } catch (error) {}
        }
        return guide.getAttribute('data-auto-intro-seen') === 'true';
      }

      function markAutoIntroSeen() {
        guide.setAttribute('data-auto-intro-seen', 'true');
        syncIntroStorageConsent();
      }

      listen(document, 'visitorConsentCollected', syncIntroStorageConsent);
      syncIntroStorageConsent();

      function customerHelpIsMobileSurface() {
        return customerHelpMobileQuery ? customerHelpMobileQuery.matches : window.innerWidth < 750;
      }

      function syncCustomerHelpA11yState(isOpen) {
        customerHelpIsMobileSurface();
        guide.setAttribute('aria-modal', 'false');
        guide.removeAttribute('data-customer-help-mobile-surface');
      }

      function setCustomerHelpOpenState(isOpen) {
        if (document.body) document.body.classList.toggle('is-customer-help-open', !!isOpen);
        syncCustomerHelpA11yState(isOpen);
      }

      function minutesFromTime(value, fallback) {
        const match = String(value || '').match(/^(\d{1,2})(?::?(\d{2}))?$/);
        if (!match) return fallback;
        const hours = Math.max(0, Math.min(23, Number(match[1]) || 0));
        const minutes = Math.max(0, Math.min(59, Number(match[2]) || 0));
        return (hours * 60) + minutes;
      }

      function osloMinutes() {
        try {
          const parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: helpTimezone,
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          }).formatToParts(new Date());
          const hour = Number((parts.find(function (part) { return part.type === 'hour'; }) || {}).value || 0);
          const minute = Number((parts.find(function (part) { return part.type === 'minute'; }) || {}).value || 0);
          return (hour * 60) + minute;
        } catch (error) {
          const fallbackNow = new Date();
          return (fallbackNow.getHours() * 60) + fallbackNow.getMinutes();
        }
      }

      function isHelpOpenNow() {
        const start = minutesFromTime(openStart, 9 * 60);
        const end = minutesFromTime(openEnd, 23 * 60);
        const current = osloMinutes();
        if (start === end) return true;
        if (start < end) return current >= start && current < end;
        return current >= start || current < end;
      }

      function updateHelpOpenStatus() {
        if (destroyed || !guide.isConnected) return;
        const isOpen = isHelpOpenNow();
        trigger.classList.toggle('is-open-now', isOpen);
        trigger.setAttribute('data-customer-help-open-now', isOpen ? 'true' : 'false');
        if (headingNode) {
          headingNode.textContent = isOpen ? openHeading : defaultHeading;
        }
        if (sublineNode) {
          sublineNode.textContent = defaultSubline;
        }
        cancelLater(openStatusTimer);
        openStatusTimer = later(updateHelpOpenStatus, 60 * 1000);
      }

      function isConsentInteraction(target, event) {
        const nodes = [];
        if (event && typeof event.composedPath === 'function') {
          event.composedPath().forEach(function (node) {
            if (node && node.nodeType === 1 && node !== document.documentElement && node !== document.body) nodes.push(node);
          });
        }
        let node = target && target.nodeType === 1 ? target : target && target.parentElement;
        while (node && node !== document.documentElement) {
          if (node !== document.body) nodes.push(node);
          node = node.parentElement;
        }

        return nodes.some(function (candidate) {
          if (!candidate || candidate.nodeType !== 1) return false;
          if (candidate.closest && candidate.closest('pandectes-cmp')) {
            return true;
          }
          if (candidate.matches && candidate.matches('[id*="pandectes" i], [class*="pandectes" i], [id*="cookie" i], [class*="cookie" i], [id*="consent" i], [class*="consent" i]')) {
            return true;
          }
          const text = [
            candidate.localName,
            candidate.tagName,
            candidate.id,
            typeof candidate.className === 'string' ? candidate.className : '',
            candidate.getAttribute ? candidate.getAttribute('aria-label') : '',
            candidate.getAttribute ? candidate.getAttribute('data-pandectes') : '',
            candidate.getAttribute ? candidate.getAttribute('data-consent') : ''
          ].join(' ').toLowerCase();
          return text.indexOf('pandectes') >= 0 || text.indexOf('cookie') >= 0 || text.indexOf('consent') >= 0 || text.indexOf('personvern') >= 0;
        });
      }

      function clearAutoTimers() {
        cancelLater(autoIntroTimer);
        cancelLater(autoCloseTimer);
        cancelLater(autoClosePollTimer);
      }

      function setCustomerHelpSource(value) {
        if (!sourceNode) return;
        sourceNode.textContent = value || defaultSource || 'Fra Kundehjelp-knappen';
      }

      function setCustomerHelpPostcodeStepComplete(isComplete) {
        if (!postcodeStepNode) return;
        postcodeStepNode.classList.toggle('is-complete', !!isComplete);
        if (isComplete) {
          postcodeStepNode.setAttribute('data-customer-help-step-state', 'complete');
        } else {
          postcodeStepNode.removeAttribute('data-customer-help-step-state');
        }
      }

      function customerHelpCleanPostcode(value) {
        return String(value || '').replace(/\D/g, '').slice(0, 4);
      }

      function customerHelpStoredPostcode() {
        return '';
      }

      function customerHelpHasSpecialPostcodeMessage() {
        return qsa('[data-ms-postcode-variant-gate="true"]').some(function (surface) {
          const text = String(surface.textContent || '').toLowerCase();
          return text.indexOf('riktig produkt for ditt postnummer') >= 0
            || !!qs('[data-ms-postcode-variant-gate-confirm]', surface);
        });
      }

      function customerHelpPageAcceptsStoredPostcode(postcode) {
        if (!postcode || customerHelpHasSpecialPostcodeMessage()) return false;
        const productSurface = qs('[data-ms-postcode-variant-gate="true"]:not([data-quick-shop-root] [data-ms-postcode-variant-gate])');
        if (!productSurface) return false;
        const text = String(productSurface.textContent || '');
        return productSurface.getAttribute('data-ms-postcode-gate-state') === 'unlocked'
          || text.indexOf('Vi kan levere til postnr. ' + postcode) >= 0
          || text.indexOf('postnr. ' + postcode) >= 0;
      }

      function syncCustomerHelpStoredPostcodeStatus() {
        const postcode = customerHelpStoredPostcode();
        if (!customerHelpPageAcceptsStoredPostcode(postcode)) return;
        renderCustomerHelpPostcodeStatus({
          tone: 'success',
          title: 'Vi kan levere rett hjem til ' + postcode,
          text: 'Punkt 1 er utført. Legg varene i handlekurven, så viser vi totalpris med frakt og dagens rabatt.'
        });
        setCustomerHelpSource('Fra postnummersjekk');
      }

      function customerHelpConsentBannerVisible() {
        return qsa('pandectes-cmp, [id*="pandectes" i], [class*="pandectes" i], [id*="cookie" i], [class*="cookie" i], [id*="consent" i], [class*="consent" i]').some(function (element) {
          if (!element || !element.getBoundingClientRect) return false;
          const rect = element.getBoundingClientRect();
          if (rect.width < 220 || rect.height < 48 || rect.bottom <= 0 || rect.top >= window.innerHeight) return false;
          const style = window.getComputedStyle ? window.getComputedStyle(element) : null;
          if (style && (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity || 1) < 0.05)) return false;
          if (element.matches && element.matches('pandectes-cmp')) return true;
          if (style && !['fixed', 'sticky'].includes(style.position)) return false;
          const text = [
            element.id,
            typeof element.className === 'string' ? element.className : '',
            element.getAttribute ? element.getAttribute('aria-label') : '',
            element.textContent || ''
          ].join(' ').toLowerCase();
          return text.indexOf('pandectes') >= 0
            || text.indexOf('cookie') >= 0
            || text.indexOf('samtykke') >= 0
            || text.indexOf('informasjonskaps') >= 0
            || text.indexOf('personvern') >= 0;
        });
      }

      function customerHelpAutoBlocked() {
        return document.body.classList.contains('is-drawer-open')
          || document.body.classList.contains('ms-premium-nav-open')
          || !!qs('[data-product-media-modal]:not([hidden])')
          || !!qs('[data-ms-quickshop-modal]:not([hidden])')
          || !!qs('[data-fk7-drawer].is-open, [data-cart-drawer].is-open, .fk7-drawer.is-open');
      }

      function customerHelpPostcodeStatusNode() {
        let node = qs('[data-customer-help-postcode-status]', guide);
        if (node) return node;
        node = document.createElement('div');
        node.className = 'customer-help-popover__postcode-status';
        node.setAttribute('data-customer-help-postcode-status', '');
        node.setAttribute('role', 'status');
        node.setAttribute('aria-live', 'polite');
        node.hidden = true;

        const title = document.createElement('strong');
        title.setAttribute('data-customer-help-postcode-status-title', '');
        const text = document.createElement('span');
        text.setAttribute('data-customer-help-postcode-status-text', '');
        node.appendChild(title);
        node.appendChild(text);

        const heading = qs('h2', guide);
        if (heading && heading.parentNode) {
          heading.parentNode.insertBefore(node, heading);
        } else {
          guide.insertBefore(node, guide.firstChild);
        }
        return node;
      }

      function clearCustomerHelpPostcodeAutoClose() {
        cancelLater(postcodeStatusAutoCloseTimer);
        postcodeStatusAutoCloseTimer = 0;
        guide.removeAttribute('data-ms-postcode-status-auto');
        guide.removeAttribute('data-ms-postcode-status-interacted');
      }

      function markCustomerHelpPostcodeInteraction() {
        if (guide.getAttribute('data-ms-postcode-status-auto') !== 'true') return;
        guide.setAttribute('data-ms-postcode-status-interacted', 'true');
        cancelLater(postcodeStatusAutoCloseTimer);
        postcodeStatusAutoCloseTimer = 0;
      }

      function hideCustomerHelpPostcodeStatus() {
        const node = qs('[data-customer-help-postcode-status]', guide);
        if (node) {
          node.hidden = true;
          node.removeAttribute('data-tone');
          const title = qs('[data-customer-help-postcode-status-title]', node);
          const text = qs('[data-customer-help-postcode-status-text]', node);
          if (title) title.textContent = '';
          if (text) text.textContent = '';
        }
        clearCustomerHelpPostcodeAutoClose();
        setCustomerHelpSource('');
        setCustomerHelpPostcodeStepComplete(false);
      }

      function renderCustomerHelpPostcodeStatus(detail) {
        const node = customerHelpPostcodeStatusNode();
        const title = qs('[data-customer-help-postcode-status-title]', node);
        const text = qs('[data-customer-help-postcode-status-text]', node);
        const tone = String(detail && detail.tone ? detail.tone : 'success').trim();
        if (title) title.textContent = String(detail && detail.title ? detail.title : '').trim();
        if (text) {
          text.textContent = String(detail && detail.text ? detail.text : '').trim();
          text.hidden = !text.textContent;
        }
        node.hidden = false;
        node.setAttribute('data-tone', tone || 'success');
        setCustomerHelpPostcodeStepComplete(true);
      }

      function scheduleCustomerHelpPostcodeAutoClose() {
        clearCustomerHelpPostcodeAutoClose();
        guide.setAttribute('data-ms-postcode-status-auto', 'true');
        postcodeStatusAutoCloseTimer = later(function () {
          if (
            guide.getAttribute('data-ms-postcode-status-auto') === 'true'
            && guide.classList.contains('is-open')
          ) {
            hide(false);
          }
        }, postcodeStatusAutoCloseMs);
      }

      function showCustomerHelpPostcodeStatus(detail) {
        if (!detail || detail.suppressAutoOpen) return;
        const alreadyOpen = guide.classList.contains('is-open') && !guide.hasAttribute('hidden');
        if (!alreadyOpen && customerHelpAutoBlocked()) return;

        renderCustomerHelpPostcodeStatus(detail);
        setCustomerHelpSource('Fra postnummersjekk');

        if (alreadyOpen) {
          markCustomerHelpPostcodeInteraction();
          return;
        }
        show(false, { skipStoredPostcodeSync: true });
        scheduleCustomerHelpPostcodeAutoClose();
      }

      function scheduleAutoCloseAfterConsent() {
        cancelLater(autoCloseTimer);
        cancelLater(autoClosePollTimer);
        const waitForConsentToClose = function () {
          if (guide.getAttribute('data-ms-auto-intro') !== 'true') return;
          if (!guide.classList.contains('is-open')) {
            if (!guide.hasAttribute('hidden')) {
              autoClosePollTimer = later(waitForConsentToClose, 80);
            }
            return;
          }
          if (customerHelpConsentBannerVisible()) {
            autoClosePollTimer = later(waitForConsentToClose, 450);
            return;
          }
          autoCloseTimer = later(function () {
            if (guide.getAttribute('data-ms-auto-intro') === 'true' && guide.classList.contains('is-open')) {
              hide(true);
            }
          }, 3000);
        };
        waitForConsentToClose();
      }

      function hide(dock) {
        cancelLater(closeTimer);
        cancelLater(hideTimer);
        clearAutoTimers();
        clearCustomerHelpPostcodeAutoClose();
        setCustomerHelpSource('');
        guide.removeAttribute('data-ms-auto-intro');
        if (guide.hasAttribute('hidden')) {
          setCustomerHelpOpenState(false);
          return;
        }
        setCustomerHelpOpenState(false);

        if (dock) {
          guide.classList.add('is-docking');
          trigger.classList.add('is-help-pulse');
          hideTimer = later(function () {
            guide.classList.remove('is-open', 'is-docking');
            guide.setAttribute('hidden', '');
            trigger.setAttribute('aria-expanded', 'false');
            later(function () {
              trigger.classList.remove('is-help-pulse');
            }, 1100);
          }, 560);
          return;
        }

        guide.classList.remove('is-open', 'is-docking');
        guide.setAttribute('hidden', '');
        trigger.setAttribute('aria-expanded', 'false');
      }

      function show(auto, options) {
        if (destroyed || !guide.isConnected) return;
        cancelLater(closeTimer);
        cancelLater(hideTimer);
        cancelLater(autoCloseTimer);
        cancelLater(autoClosePollTimer);
        if (auto) {
          guide.setAttribute('data-ms-auto-intro', 'true');
          markAutoIntroSeen();
        } else {
          guide.removeAttribute('data-ms-auto-intro');
        }
        guide.classList.remove('is-docking');
        guide.removeAttribute('hidden');
        setCustomerHelpOpenState(true);
        trigger.setAttribute('aria-expanded', 'true');
        if (openFrame !== null) window.cancelAnimationFrame(openFrame);
        openFrame = window.requestAnimationFrame(function () {
          openFrame = null;
          if (!destroyed && guide.isConnected && !guide.hidden) guide.classList.add('is-open');
        });
        if (!auto && !(options && options.skipStoredPostcodeSync)) syncCustomerHelpStoredPostcodeStatus();
      }

      listen(trigger, 'click', function () {
        if (guide.classList.contains('is-open')) {
          hide(false);
        } else {
          setCustomerHelpSource('');
          show(false);
        }
      });

      if (closeButton) {
        listen(closeButton, 'click', function () {
          hide(false);
          trigger.focus({ preventScroll: true });
        });
      }

      if (faqLink) {
        listen(faqLink, 'click', function (event) {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const search = qs('[data-ms-faq] [data-faq-search]');
          if (!search || !search.getClientRects().length || faqLink.target === '_blank' || window.location.pathname.replace(/\/$/, '') !== faqLink.pathname.replace(/\/$/, '')) return;
          event.preventDefault();
          hide(false);
          focusElementSafely(search);
          scrollToElementWithHeaderOffset(search);
        });
      }

      listen(window, 'msDeliveryStatusUpdated', updateHelpOpenStatus);
      listen(document, 'ms:customer-help:postcode-status', function (event) {
        showCustomerHelpPostcodeStatus(event.detail || {});
      });
      listen(document, 'ms:customer-help:postcode-status-clear', hideCustomerHelpPostcodeStatus);

      function onHelpBreakpoint() {
        syncCustomerHelpA11yState(guide.classList.contains('is-open'));
      }
      if (customerHelpMobileQuery && typeof customerHelpMobileQuery.addEventListener === 'function') {
        listen(customerHelpMobileQuery, 'change', onHelpBreakpoint);
      } else if (customerHelpMobileQuery && typeof customerHelpMobileQuery.addListener === 'function') {
        customerHelpMobileQuery.addListener(onHelpBreakpoint);
        listeners.push(function () { customerHelpMobileQuery.removeListener(onHelpBreakpoint); });
      }

      listen(document, 'keydown', function (event) {
        if (
          event.key === 'Tab'
          && guide.classList.contains('is-open')
          && (guide.getAttribute('aria-modal') === 'true' || guide.hasAttribute('data-customer-help-mobile-surface'))
        ) {
          trapFocusWithin(guide, event);
          return;
        }
        if (event.key === 'Escape' && guide.classList.contains('is-open')) {
          hide(false);
          trigger.focus({ preventScroll: true });
        }
      }, true);

      listen(document, 'click', function (event) {
        if (!guide.classList.contains('is-open')) return;
        if (guide.contains(event.target) || trigger.contains(event.target)) return;
        if (isConsentInteraction(event.target, event)) return;
        hide(false);
      }, true);

      if (guide.getAttribute('data-auto-open') === 'true' && !introSeenThisSession()) {
        autoIntroTimer = later(function () {
          if (introSeenThisSession() || customerHelpAutoBlocked()) return;
          show(true);
          scheduleAutoCloseAfterConsent();
        }, 700);
      }

      customerHelpControllers.set(guide, {
        destroy: function () {
          if (destroyed) return;
          hide(false);
          destroyed = true;
          timers.forEach(function (timer) { window.clearTimeout(timer); });
          timers.clear();
          if (openFrame !== null) window.cancelAnimationFrame(openFrame);
          listeners.forEach(function (remove) { remove(); });
          if (heroHelpRotator && heroHelpRotator.destroy) heroHelpRotator.destroy();
          guide.removeAttribute('data-customer-help-bound');
          trigger.classList.remove('is-help-pulse');
          customerHelpControllers.delete(guide);
        }
      });
      updateHelpOpenStatus();
    });
  }


  let productMediaObserver = null;

  function bindProductMediaReveal(root) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const supportsObserver = 'IntersectionObserver' in window;

    qsa('.product__media', root).forEach(function (media) {
      if (media.dataset.msRevealBound === 'true') return;
      media.dataset.msRevealBound = 'true';

      if (reducedMotion || !supportsObserver) {
        media.classList.add('is-in-view');
        return;
      }

      media.classList.add('product__media--observe');
      if (!productMediaObserver) {
        productMediaObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in-view');
            productMediaObserver.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.18 });
      }

      productMediaObserver.observe(media);
    });
  }

  function bindFilterToggle(root) {
    qsa('[data-filter-toggle]', root).forEach(function (button) {
      if (button.dataset.msFilterBound === 'true') return;
      button.dataset.msFilterBound = 'true';
      button.addEventListener('click', function () {
        const panel = qs(button.getAttribute('data-filter-toggle'));
        if (!panel) return;
        const isHidden = panel.hasAttribute('hidden');
        panel.toggleAttribute('hidden', !isHidden);
        button.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
      });
    });
  }

  function bindProductDescriptionAccordions(root) {
    qsa('[data-product-description-accordion]', root).forEach(function (container) {
      if (container.dataset.msProductDescriptionBound === 'true') return;
      const source = qs('[data-product-description-source]', container);
      if (!source) return;

      container.dataset.msProductDescriptionBound = 'true';
      const mapOwner = container.closest('[data-product-story-media-map]');
      const mediaMap = (mapOwner && mapOwner.getAttribute('data-product-story-media-map') || '')
        .split(',')
        .map(function (value) { return Number(value.trim()); })
        .filter(function (value) { return Number.isFinite(value); });

      function cleanText(value) {
        return String(value || '').replace(/\s+/g, ' ').trim();
      }

      function sectionText(nodes) {
        return cleanText(nodes.map(function (node) { return node.textContent || ''; }).join(' '));
      }

      function teaserFrom(nodes, fallback) {
        const text = sectionText(nodes) || fallback || '';
        return text.length > 128 ? text.slice(0, 125).trim() + '...' : text;
      }

      function mediaIndexFor(index) {
        return Number.isFinite(mediaMap[index]) ? mediaMap[index] : index;
      }

      function createCard(title, teaser, nodes, index, intro, mode) {
        const isAccordion = mode === 'accordion';
        const card = document.createElement(isAccordion ? 'details' : 'article');
        card.className = 'category-card' + (intro ? ' category-card-intro' : '') + (isAccordion ? '' : ' category-card--open-section');
        if (isAccordion) card.open = false;
        card.setAttribute('data-product-story-media-index', String(mediaIndexFor(index)));

        const summary = document.createElement(isAccordion ? 'summary' : 'div');
        if (!isAccordion) summary.className = 'category-card__header';
        const wrap = document.createElement('span');
        wrap.className = 'category-summary-wrap';

        const titleNode = document.createElement('span');
        titleNode.className = 'category-summary-title';
        titleNode.textContent = title || container.getAttribute('data-description-label') || 'Beskrivelse';
        wrap.appendChild(titleNode);

        const teaserNode = document.createElement('span');
        teaserNode.className = 'category-summary-teaser';
        teaserNode.textContent = teaser || container.getAttribute('data-description-teaser') || '';
        wrap.appendChild(teaserNode);

        summary.appendChild(wrap);
        if (isAccordion) {
          const icon = document.createElement('span');
          icon.className = 'category-toggle-icon';
          icon.setAttribute('aria-hidden', 'true');
          summary.appendChild(icon);
        }

        const panel = document.createElement('div');
        panel.className = 'category-panel rte';
        nodes.forEach(function (node) { panel.appendChild(node); });

        card.appendChild(summary);
        card.appendChild(panel);
        return card;
      }

      const childNodes = Array.prototype.slice.call(source.childNodes);
      const sections = [];
      let current = null;

      childNodes.forEach(function (node) {
        const tagName = node.nodeType === 1 ? String(node.tagName || '') : '';
        const isHeading = /^H[26]$/.test(tagName);
        if (isHeading) {
          current = {
            title: cleanText(node.textContent),
            nodes: [],
            mode: tagName === 'H6' ? 'accordion' : 'open'
          };
          sections.push(current);
          node.remove();
          return;
        }
        const hasContent = node.nodeType === 1 || cleanText(node.textContent);
        if (!hasContent) return;
        if (!current) {
          current = {
            title: container.getAttribute('data-description-label') || 'Beskrivelse',
            nodes: [],
            mode: 'open'
          };
          sections.push(current);
        }
        current.nodes.push(node);
      });

      const cards = document.createElement('section');
      cards.className = 'category-cards product-story-cards product-story-cards--mixed';
      cards.setAttribute('aria-label', container.getAttribute('data-description-label') || 'Produktbeskrivelse');

      sections
        .filter(function (section) { return section.title || sectionText(section.nodes); })
        .forEach(function (section, index) {
          cards.appendChild(createCard(section.title, teaserFrom(section.nodes, section.title), section.nodes, index, index === 0, section.mode || 'open'));
        });

      const metaTemplate = qs('template[data-product-description-meta]', container);
      if (metaTemplate && metaTemplate.content && cleanText(metaTemplate.content.textContent)) {
        cards.appendChild(createCard(
          container.getAttribute('data-details-label') || 'Detaljer',
          container.getAttribute('data-details-teaser') || '',
          Array.prototype.slice.call(metaTemplate.content.cloneNode(true).childNodes),
          sections.length,
          false,
          'accordion'
        ));
      }

      if (!cards.children.length) return;
      source.hidden = true;
      source.setAttribute('aria-hidden', 'true');
      container.appendChild(cards);
    });
  }

  function bindExclusiveDetails(root) {
    function setupGroup(group, selector) {
      if (!group || group.dataset.msExclusiveDetailsBound === 'true') return;
      const details = qsa(selector, group).filter(function (item) {
        return item.tagName === 'DETAILS';
      });
      if (!details.length) return;

      group.dataset.msExclusiveDetailsBound = 'true';
      const allowAllClosed = group.classList.contains('product-story-cards--mixed');
      let openDetail = details.find(function (item) { return item.open; }) || (allowAllClosed ? null : details[0]);
      if (openDetail) {
        details.forEach(function (item) {
          item.open = item === openDetail;
        });
      }

      details.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          details.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    }

    qsa('.apple-desc-wrapper--ultra .apple-desc-cards', root).forEach(function (group) {
      setupGroup(group, ':scope > .apple-card > details');
    });

    qsa('.category-cards', root).forEach(function (group) {
      setupGroup(group, ':scope > .category-card, :scope > .variant-card');
    });

    qsa('.category-cards .variant-cards', root).forEach(function (group) {
      setupGroup(group, ':scope > .variant-card');
    });
  }

  const QUICK_SHOP_REUSABLE_SCRIPT_NAMES = [
    'ms-calculator-core',
    'mspa-bag-selection',
    'mspa-eccogravel',
    'mspa-flateprodukter',
    'mspa-pallevarer',
    'mspa-granitt-kantstein',
    'mspa-pick-mix',
    'mspa-miniblokk',
    'mspa-megawall',
    'mspa-boston',
    'mspa-megasmart',
    'mspa-megastone-150',
    'mspa-train',
    'mspa-granittmur',
    'mspa-kubbemur',
    'mspa-troja-sirkel'
  ];

  const loadedQuickShopScripts = new Set(qsa('script[src]').map(function (script) {
    return script.src;
  }));
  const quickShopNativeFetch = typeof window.fetch === 'function' ? window.fetch.bind(window) : null;
  let quickShopReturnFocusTarget = null;
  let quickShopCartMode = null;
  let quickShopActionObserver = null;
  let quickShopActionsNode = null;
  let quickShopRecentCalculatorInteraction = 0;
  let quickShopLastFlowKey = '';
  let quickShopFlowScrollTimer = 0;
  let quickShopCalculationTimer = 0;
  let quickShopLoadToken = 0;
  let quickShopActiveLoad = null;
  const quickShopHtmlCache = new Map();
  const quickShopPreloadState = {
    queue: [],
    queued: new Set(),
    active: 0,
    total: 0,
    maxTotal: 0,
    observer: null,
    scheduled: false
  };
  const quickShopWarmedScripts = new Set();

  function canReuseQuickShopScript(src) {
    const value = String(src || '');
    return QUICK_SHOP_REUSABLE_SCRIPT_NAMES.some(function (name) {
      return value.indexOf('/' + name + '.') !== -1 || value.indexOf('/' + name + '?') !== -1;
    });
  }

  function bindPredictiveSearch(root) {
    if (window.MSSmartSearch) window.MSSmartSearch.bind(root);
  }

  function quickShopRoot() {
    return qs('[data-quick-shop-root]');
  }

  function quickShopContent() {
    const root = quickShopRoot();
    return root ? qs('[data-quick-shop-content]', root) : null;
  }

  function quickShopStatus() {
    const root = quickShopRoot();
    return root ? qs('[data-quick-shop-status]', root) : null;
  }

  function rememberQuickShopTrigger(trigger) {
    if (!trigger || typeof trigger.focus !== 'function') return;
    if (trigger.closest && trigger.closest('[data-quick-shop-root]') && quickShopReturnFocusTarget) return;
    quickShopReturnFocusTarget = trigger;
  }

  function restoreQuickShopFocus(target) {
    if (!target || !target.isConnected || typeof target.focus !== 'function') return;
    if (target.disabled || target.hidden || target.closest('[hidden], [aria-hidden="true"]')) return;
    window.setTimeout(function () {
      try {
        target.focus({ preventScroll: true });
      } catch (error) {
        target.focus();
      }
    }, 0);
  }

  function setQuickShopStatus(message, isVisible) {
    const status = quickShopStatus();
    if (!status) return;
    status.textContent = message || '';
    status.toggleAttribute('hidden', !isVisible);
  }

  function quickShopResetButton() {
    const root = quickShopRoot();
    return root ? qs('[data-quick-shop-reset]', root) : null;
  }

  function quickShopFindResetSource() {
    return null;
  }

  function quickShopUpdateResetButton() {
    const button = quickShopResetButton();
    if (!button) return;
    button.hidden = true;
    button.setAttribute('aria-hidden', 'true');
  }

  function quickShopResetCalculator() {
    const source = quickShopFindResetSource();
    const content = quickShopContent();
    if (source && typeof source.click === 'function') {
      source.click();
    } else if (content) {
      const host = qs('[data-ms-calculator-host]', content) || content;
      host.dispatchEvent(new CustomEvent('ms:calculator:reset', { bubbles: true }));
    }
    quickShopCartMode = null;
    quickShopRecentCalculatorInteraction = 0;
    window.setTimeout(function () {
      quickShopRefreshActions();
      quickShopUpdateScrollCue();
      quickShopUpdateResetButton();
    }, 80);
  }

  const QUICK_SHOP_ADD_SOURCE_SELECTOR = [
    '[data-add-to-cart]'
  ].join(',');

  function quickShopRoute(key, fallback) {
    const routes = (window.MSTheme && window.MSTheme.routes) || {};
    const value = routes[key] || fallback;
    return /\.js($|\?)/.test(value) ? value : `${value}.js`;
  }

  function quickShopCartPageUrl() {
    const route = (window.MSTheme && window.MSTheme.routes && window.MSTheme.routes.cart) || '/cart';
    return String(route || '/cart').replace(/\.js($|\?)/, '$1');
  }


  let aaCartOperationSequence = 0;

  function aaCreateCartOperationId() {
    aaCartOperationSequence += 1;
    return `MSNOAAFK7CartOperation-${Date.now()}-${aaCartOperationSequence}`;
  }

  function aaBeginCartOperation(source, requestedOperationId) {
    const operationId = requestedOperationId || aaCreateCartOperationId();
    quickShopRequestCartOpen(source, operationId);
    return operationId;
  }

  function aaControlledCartOperationStatus(value) {
    const viewOnly = Boolean(value && value.msControlledCartStop === true && (
      value.msDuplicateProductPromptHandled === true && value.msDuplicateProductPromptChoice === 'view'
      || value.msLocationPromptHandled === true && value.msLocationPromptChoice === 'view'
    ));
    return viewOnly ? 'CANCELLED' : 'FAILED';
  }

  function aaFinishCartOperation(operationId, status) {
    if (!operationId || !['SUCCEEDED', 'FAILED', 'CANCELLED'].includes(status)) return;
    document.dispatchEvent(new CustomEvent('aa:cart-operation-result', {
      detail: {
        schema: 'aa-cart-operation-result-v1',
        operation_id: operationId,
        status: status
      }
    }));
  }

  function quickShopRequestCartOpen(source, operationId) {
    if (source === 'quick-shop') {
      closeQuickShopAfterCart();
    }
    const event = new CustomEvent('ms:cart:open-request', {
      bubbles: true,
      cancelable: true,
      detail: operationId
        ? { source: source || 'theme', pending: true, operation_id: operationId }
        : { source: source || 'theme' }
    });
    if (document.dispatchEvent(event) === false || event.defaultPrevented) {
      return;
    }
    document.dispatchEvent(new CustomEvent('aa:cart-open-blocked', {
      detail: { source: source || 'theme' }
    }));
  }

  function purchaseSurfaceEnsureCartOpen() {
    const root = qs('[data-msno-aa-fk7-v2][data-aa-enabled="true"]');
    if (root && root.getAttribute('data-aa-open') === 'true') return true;
    quickShopRequestCartOpen('purchase-surface-success');
    return false;
  }

  function aaZoorixCartDetail(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
    const variantId = value.variantId;
    if (!['number', 'string'].includes(typeof variantId)
      || !/^[1-9]\d*$/.test(String(variantId || ''))
      || !Number.isSafeInteger(Number(variantId))) return false;
    return Number.isSafeInteger(value.quantity) && value.quantity > 0;
  }

  let aaZoorixCartSync = null;
  let aaZoorixCartDirty = false;

  function aaZoorixCartBusy() {
    const root = qs('[data-msno-aa-fk7-v2][data-aa-enabled="true"]');
    return Boolean(root && (
      root.getAttribute('data-aa-cart-transaction') === 'active'
      || root.getAttribute('data-aa-checkout-materialization') === 'materializing'
    ));
  }

  function aaHandleZoorixCartAdded(event) {
    if (!aaZoorixCartDetail(event && event.detail)) return;
    const cart = window.MSNO_AA_FK7;
    if (!cart || typeof cart.open !== 'function' || typeof cart.refreshCart !== 'function') return;
    aaZoorixCartDirty = true;
    if (aaZoorixCartSync) return aaZoorixCartSync;

    const task = Promise.resolve().then(async function () {
      try {
        // Zoorix owns the successful add. FK7 owns fresh totals and header count.
        if (await cart.open({ source: 'zoorix-slider' }) === false) return false;
        while (aaZoorixCartDirty) {
          aaZoorixCartDirty = false;
          const awaitingExistingWork = aaZoorixCartBusy();
          await cart.refreshCart();
          // A busy refresh can only await older work. Read again after it settles.
          if (awaitingExistingWork) await cart.refreshCart();
        }
        return true;
      } catch (error) {
        // Preserve the confirmed add; never retry the mutation or fabricate count.
        return false;
      } finally {
        if (aaZoorixCartSync === task) {
          aaZoorixCartSync = null;
          aaZoorixCartDirty = false;
        }
      }
    });
    aaZoorixCartSync = task;
    return task;
  }

  function aaCartReadbackDetail(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    if (Object.keys(value).sort().join('|') !== 'item_count|revision|schema') return null;
    if (value.schema !== 'aa-cart-readback-v2') return null;
    if (!Number.isInteger(value.item_count) || value.item_count < 0) return null;
    if (!Number.isSafeInteger(value.revision) || value.revision <= 0) return null;
    return value;
  }

  let aaCartReadbackRevision = 0;

  function aaProjectCartCount(itemCount) {
    if (!Number.isSafeInteger(itemCount) || itemCount < 0) return false;
    qsa('[data-cart-count], .cart-count-bubble').forEach(function (node) {
      node.textContent = String(itemCount);
      node.hidden = itemCount <= 0;
    });
    return true;
  }

  function aaUpdateCartCount(itemCount, revision) {
    if (!Number.isSafeInteger(revision) || revision <= aaCartReadbackRevision) return false;
    aaCartReadbackRevision = revision;
    return aaProjectCartCount(itemCount);
  }

  const aaCartPageOpenPromises = new WeakMap();
  let aaCartPageInitialOpenStarted = false;

  function aaOpenCartPageEntry(entry) {
    const active = aaCartPageOpenPromises.get(entry);
    if (active) return active;
    const button = qs('[data-aa-cart-entry-open]', entry);
    const status = qs('[data-aa-cart-entry-status]', entry);
    if (button) button.disabled = true;
    if (status) status.textContent = 'Åpner handlekurven …';
    const task = aaReadyCartService().then(async function (service) {
      // Return recovery may already have opened AA before connecting the bridge.
      // Keep that verified empty state and avoid another open/refresh operation.
      const current = qs('[data-msno-aa-fk7-v2][data-aa-open="true"]');
      if (!current) {
        const opened = await service.open({ source: 'cart-page-entry' });
        if (opened === false && !qs('[data-msno-aa-fk7-v2][data-aa-open="true"]')) {
          throw new Error('AA_CART_ENTRY_OPEN_FAILED');
        }
      }
      if (status) status.textContent = 'Handlekurven er åpnet.';
      return true;
    }).catch(function () {
      if (status) status.textContent = 'Handlekurven kunne ikke åpnes. Trykk «Åpne handlekurv» for å prøve igjen.';
      return false;
    }).finally(function () {
      if (button) button.disabled = false;
      aaCartPageOpenPromises.delete(entry);
    });
    aaCartPageOpenPromises.set(entry, task);
    return task;
  }

  function bindAaCartPageEntry(root) {
    qsa('[data-aa-cart-page-entry]', root).forEach(function (entry) {
      if (entry.dataset.aaCartPageEntryBound === 'true') return;
      entry.dataset.aaCartPageEntryBound = 'true';
      const button = qs('[data-aa-cart-entry-open]', entry);
      if (button) {
        button.hidden = false;
        button.addEventListener('click', function (event) {
          event.preventDefault();
          void aaOpenCartPageEntry(entry);
        });
      }
      if (!aaCartPageInitialOpenStarted) {
        aaCartPageInitialOpenStarted = true;
        void aaOpenCartPageEntry(entry);
      }
    });
  }

  function aaRequestCartFromEntry(event) {
    if (!event || event.defaultPrevented) return;
    event.preventDefault();
    event.stopPropagation();
    quickShopRequestCartOpen('header');
  }

  function aaRequestCheckoutFromCartPage(event) {
    if (!event || event.defaultPrevented) return;
    event.preventDefault();
    event.stopPropagation();
    quickShopRequestCartOpen('cart-page');
  }

  function bindAaCartIntegration(root) {
    bindAaCartPageEntry(root);
    qsa('.site-header__cart-fallback[href]', root).forEach(function (entry) {
      if (entry.dataset.aaCartEntryBound === 'true') return;
      entry.dataset.aaCartEntryBound = 'true';
      entry.addEventListener('click', aaRequestCartFromEntry);
      entry.addEventListener('auxclick', aaRequestCartFromEntry);
    });
    qsa('.cart-page__checkout-form', root).forEach(function (form) {
      if (form.dataset.aaCartCheckoutBound === 'true') return;
      form.dataset.aaCartCheckoutBound = 'true';
      form.addEventListener('submit', aaRequestCheckoutFromCartPage);
    });
    if (document.documentElement.dataset.aaCartReadbackBound === 'true') return;
    document.documentElement.dataset.aaCartReadbackBound = 'true';
    document.addEventListener('zrx-slider-item-added', aaHandleZoorixCartAdded);
    document.addEventListener('aa:cart-readback', function (event) {
      const detail = aaCartReadbackDetail(event && event.detail);
      if (!detail) return;
      aaUpdateCartCount(detail.item_count, detail.revision);
    });
  }

  function quickShopShouldUseIsolatedCartTransport(url) {
    try {
      const parsed = new URL(String(url || ''), window.location.origin);
      return parsed.origin === window.location.origin
        && /^\/cart(?:\/|\.js$)/.test(parsed.pathname);
    } catch (error) {
      return String(url || '').indexOf('/cart') !== -1;
    }
  }

  const QUICK_SHOP_CART_TRANSPORT_TIMEOUT_MS = 15000;

  function quickShopCartTransportError(message, name) {
    const error = new Error(message);
    if (name) error.name = name;
    return error;
  }

  function quickShopCartResponseHeaders(xhr) {
    const headers = new Headers();
    String(xhr.getAllResponseHeaders() || '').trim().split(/\r?\n/).forEach(function (line) {
      const separator = line.indexOf(':');
      if (separator <= 0) return;
      headers.append(line.slice(0, separator).trim(), line.slice(separator + 1).trim());
    });
    return headers;
  }

  function quickShopIsolatedCartFetch(url, options) {
    const request = options || {};
    const absoluteUrl = new URL(String(url || ''), window.location.origin).toString();
    return new Promise(function (resolve, reject) {
      const xhr = new XMLHttpRequest();
      const signal = request.signal || null;
      let settled = false;

      function cleanup() {
        if (signal && typeof signal.removeEventListener === 'function') {
          signal.removeEventListener('abort', abortRequest);
        }
      }

      function settle(callback, value) {
        if (settled) return;
        settled = true;
        cleanup();
        callback(value);
      }

      function abortRequest() {
        try { xhr.abort(); } catch (error) {}
      }

      xhr.open(String(request.method || 'GET').toUpperCase(), absoluteUrl, true);
      xhr.timeout = QUICK_SHOP_CART_TRANSPORT_TIMEOUT_MS;
      new Headers(request.headers || {}).forEach(function (value, name) {
        xhr.setRequestHeader(name, value);
      });
      xhr.onload = function () {
        if (!xhr.status) {
          settle(reject, quickShopCartTransportError('Kunne ikke lese svar fra handlekurven.'));
          return;
        }
        const emptyBody = [101, 103, 204, 205, 304].includes(xhr.status);
        settle(resolve, new Response(emptyBody ? null : xhr.responseText, {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: quickShopCartResponseHeaders(xhr)
        }));
      };
      xhr.onerror = function () {
        settle(reject, quickShopCartTransportError('Kunne ikke kontakte handlekurven.'));
      };
      xhr.ontimeout = function () {
        settle(reject, quickShopCartTransportError('Det tok for lang tid å oppdatere handlekurven.', 'AbortError'));
      };
      xhr.onabort = function () {
        settle(reject, quickShopCartTransportError('Oppdateringen av handlekurven ble avbrutt.', 'AbortError'));
      };
      if (signal && signal.aborted) {
        settle(reject, quickShopCartTransportError('Oppdateringen av handlekurven ble avbrutt.', 'AbortError'));
        abortRequest();
        return;
      }
      if (signal && typeof signal.addEventListener === 'function') {
        signal.addEventListener('abort', abortRequest, { once: true });
      }
      xhr.send(request.body === undefined ? null : request.body);
    });
  }

  function quickShopFetch(url, options) {
    if (quickShopShouldUseIsolatedCartTransport(url)) {
      return quickShopIsolatedCartFetch(url, options);
    }
    const fetcher = quickShopNativeFetch || (typeof window.fetch === 'function' ? window.fetch.bind(window) : null);
    if (!fetcher) return Promise.reject(new Error('Nettleseren mangler fetch-støtte.'));
    return fetcher(url, options);
  }

  function quickShopNormalizeDocumentUrl(rawUrl) {
    if (!rawUrl) return '';
    try {
      const url = new URL(String(rawUrl), window.location.href);
      if (url.origin !== window.location.origin) return '';
      if (url.searchParams.get('view') !== 'quick-shop') return '';
      url.hash = '';
      return url.toString();
    } catch (error) {
      return '';
    }
  }

  function quickShopHandleFromDocumentUrl(rawUrl) {
    const href = quickShopNormalizeDocumentUrl(rawUrl);
    if (!href) return '';
    try {
      const url = new URL(href);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match && match[1] ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function quickShopStartActiveLoad(rawUrl) {
    const href = quickShopNormalizeDocumentUrl(rawUrl);
    quickShopLoadToken += 1;
    quickShopActiveLoad = {
      token: quickShopLoadToken,
      href: href,
      handle: quickShopHandleFromDocumentUrl(rawUrl)
    };
    return quickShopActiveLoad;
  }

  function quickShopInvalidateActiveLoad() {
    quickShopLoadToken += 1;
    quickShopActiveLoad = null;
    return quickShopLoadToken;
  }

  function quickShopIsActiveLoad(request) {
    return Boolean(
      request
      && quickShopActiveLoad
      && request.token === quickShopActiveLoad.token
      && request.href === quickShopActiveLoad.href
    );
  }

  function quickShopAbortStaleLoad(request) {
    if (quickShopIsActiveLoad(request)) return false;
    return true;
  }

  function quickShopDrawerProductMeta() {
    const content = quickShopContent();
    const product = content ? qs('[data-quick-shop-product]', content) : null;
    const surface = content ? qs('[data-ms-purchase-surface]', content) : null;
    return {
      handle: product ? product.getAttribute('data-product-handle') || '' : '',
      vendor: product ? product.getAttribute('data-product-vendor') || '' : '',
      title: product ? (qs('h2', product)?.textContent || '').trim() : '',
      surfaceVendor: surface ? surface.getAttribute('data-product-vendor') || '' : '',
      surfaceTitle: surface ? surface.getAttribute('data-product-title') || '' : ''
    };
  }

  function quickShopValidateActiveProductForAdd() {
    const root = quickShopRoot();
    if (!root || root.hasAttribute('hidden')) return true;
    const meta = quickShopDrawerProductMeta();
    const request = quickShopActiveLoad;
    const hasProduct = Boolean(meta.handle || meta.vendor || meta.title || meta.surfaceVendor || meta.surfaceTitle);
    const staleRequest = hasProduct && (!request || !quickShopIsActiveLoad(request));
    const handleMismatch = Boolean(request && request.handle && meta.handle && request.handle !== meta.handle);
    const vendorMismatch = Boolean(meta.vendor && meta.surfaceVendor && meta.vendor !== meta.surfaceVendor);
    if (!staleRequest && !handleMismatch && !vendorMismatch) return true;

    if (window.console && typeof window.console.warn === 'function') {
      window.console.warn('[MSPA QS] Stopper add: aktiv QS-intensjon matcher ikke drawer-produkt.', {
        active: request,
        drawer: meta
      });
    }
    setQuickShopStatus('Produktet kunne ikke verifiseres. Åpne hurtigkjøp på nytt og prøv igjen.', true);
    quickShopSetActionsBusy(false, '');
    return false;
  }

  function quickShopValidateIntentMatchesDrawer(intent) {
    const meta = quickShopDrawerProductMeta();
    if (!meta.vendor && !meta.title) return true;
    const items = Array.isArray(intent?.items) ? intent.items : [];
    const productLine = items.find(function (item) {
      const properties = item && item.properties;
      return properties && (properties._ms_product_vendor || properties._ms_product_title);
    });
    const plainBagIntent = !productLine
      && ['hagesingel', 'elvestein'].includes(intent?.family)
      && (typeof intent.vendor !== 'string' || intent.vendor.toLowerCase() !== 'benders');
    if (!productLine && !plainBagIntent) return true;

    const identityLine = productLine || items[0] || {};
    const properties = productLine ? productLine.properties || {} : {};
    // Capture the same family-owned strings without writing them to Shopify.
    const identity = Object.freeze({
      vendor: plainBagIntent ? intent.vendor : properties._ms_product_vendor || '',
      title: plainBagIntent ? intent.preview?.title : properties._ms_product_title || ''
    });
    const invalidPlainBagIdentity = plainBagIntent && (
      items.length !== 1
      || !identityLine.properties
      || typeof identityLine.properties !== 'object'
      || Array.isArray(identityLine.properties)
      || typeof identity.vendor !== 'string'
      || typeof identity.title !== 'string'
      || !identity.title.trim()
    );
    const vendor = identity.vendor;
    const title = identity.title;
    const vendorMismatch = Boolean(vendor && meta.vendor && vendor !== meta.vendor);
    const titleMismatch = Boolean(title && meta.title && title !== meta.title);
    if (!invalidPlainBagIdentity && !vendorMismatch && !titleMismatch) return true;

    if (window.console && typeof window.console.warn === 'function') {
      window.console.warn('[MSPA QS] Stopper add: cart-intent matcher ikke drawer-produkt.', {
        drawer: meta,
        intentLine: {
          id: identityLine.id,
          quantity: identityLine.quantity,
          vendor: vendor,
          title: title
        }
      });
    }
    setQuickShopStatus('Produktet kunne ikke verifiseres. Åpne hurtigkjøp på nytt og prøv igjen.', true);
    quickShopSetActionsBusy(false, '');
    return false;
  }

  function quickShopFetchDocument(url) {
    const href = quickShopNormalizeDocumentUrl(url);
    if (!href) return Promise.reject(new Error('Ugyldig hurtigkjøp-lenke.'));
    const cached = quickShopHtmlCache.get(href);
    const now = Date.now();
    if (cached && cached.html && now - cached.time < 5 * 60 * 1000) {
      return Promise.resolve(cached.html);
    }
    if (cached && cached.promise) return cached.promise;

    const fetcher = quickShopNativeFetch || (typeof window.fetch === 'function' ? window.fetch.bind(window) : null);
    if (!fetcher) return Promise.reject(new Error('Nettleseren mangler fetch-støtte.'));

    const promise = fetcher(href, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Kunne ikke hente produktet.');
      return response.text();
    }).then(function (html) {
      quickShopHtmlCache.set(href, {
        html: html,
        time: Date.now()
      });
      quickShopWarmAssetsFromHtml(html);
      return html;
    }).catch(function (error) {
      quickShopHtmlCache.delete(href);
      throw error;
    });

    quickShopHtmlCache.set(href, {
      promise: promise,
      time: now
    });
    return promise;
  }

  function quickShopWarmScript(src) {
    if (!src || quickShopWarmedScripts.has(src) || loadedQuickShopScripts.has(src)) return;
    quickShopWarmedScripts.add(src);
    try {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'script';
      link.href = src;
      link.dataset.msQuickShopWarm = 'script';
      document.head.appendChild(link);
    } catch (error) {}
  }

  function quickShopWarmAssetsFromHtml(html) {
    if (!html || !document.head) return;
    const template = document.createElement('template');
    template.innerHTML = html;
    qsa('script[src]', template.content).forEach(function (script) {
      const src = script.src || script.getAttribute('src') || '';
      if (canReuseQuickShopScript(src)) quickShopWarmScript(src);
    });

  }

  function quickShopResetTransientStateForLoad() {
    window.clearTimeout(quickShopCalculationTimer);
    window.clearTimeout(quickShopFlowScrollTimer);
    quickShopCartMode = null;
    quickShopRecentCalculatorInteraction = 0;
    quickShopLastFlowKey = '';

    if (quickShopActionObserver) {
      quickShopActionObserver.disconnect();
      quickShopActionObserver = null;
    }

    const root = quickShopRoot();
    if (root) {
      root.classList.remove('is-handing-off', 'is-added-silently', 'is-minimizing-to-cart', 'is-calculating', 'has-quick-actions', 'has-quick-actions-ready');
      const cue = qs('[data-quick-shop-scroll-cue]', root);
      if (cue) cue.hidden = true;
      const resetButton = quickShopResetButton();
      if (resetButton) resetButton.hidden = true;
      const actions = quickShopActions();
      if (actions) actions.hidden = true;
    }
    setQuickShopStatus('', false);
  }

  function quickShopPreloadLimit() {
    if (document.body && document.body.classList.contains('template-product')) return 3;
    if (document.body && document.body.classList.contains('template-collection')) return 8;
    return 4;
  }

  function quickShopQueuePreload(rawUrl) {
    const href = quickShopNormalizeDocumentUrl(rawUrl);
    if (!href || quickShopHtmlCache.has(href)) return;
    if (quickShopPreloadState.queued.has(href)) return;
    if (!quickShopPreloadState.maxTotal) quickShopPreloadState.maxTotal = quickShopPreloadLimit();
    if (quickShopPreloadState.total + quickShopPreloadState.queue.length >= quickShopPreloadState.maxTotal) return;
    quickShopPreloadState.queued.add(href);
    quickShopPreloadState.queue.push(href);
    quickShopDrainPreloadQueue();
  }

  function quickShopDrainPreloadQueue() {
    if (quickShopPreloadState.active > 0 || !quickShopPreloadState.queue.length) return;
    const href = quickShopPreloadState.queue.shift();
    quickShopPreloadState.queued.delete(href);
    quickShopPreloadState.active += 1;
    quickShopPreloadState.total += 1;
    quickShopFetchDocument(href).catch(function () {}).finally(function () {
      quickShopPreloadState.active = Math.max(0, quickShopPreloadState.active - 1);
      window.setTimeout(quickShopDrainPreloadQueue, 220);
    });
  }

  function quickShopSchedulePreload(trigger) {
    if (!trigger || trigger.dataset.msQuickShopPreloadBound === 'true') return;
    trigger.dataset.msQuickShopPreloadBound = 'true';
    const url = trigger.getAttribute('data-quick-shop-url') || '';
    if (!url) return;

    const eager = function () {
      quickShopQueuePreload(url);
    };
    trigger.addEventListener('pointerenter', eager, { passive: true });
    trigger.addEventListener('touchstart', eager, { passive: true });
    trigger.addEventListener('mousedown', eager, { passive: true });
    trigger.addEventListener('focus', eager, { passive: true });

    if (!('IntersectionObserver' in window)) {
      if (!quickShopPreloadState.scheduled) {
        quickShopPreloadState.scheduled = true;
        const schedule = function () {
          window.setTimeout(function () {
            qsa('[data-quick-shop-url]').forEach(function (candidate) {
              if (!candidate.closest('[data-quick-shop-root]')) quickShopQueuePreload(candidate.getAttribute('data-quick-shop-url'));
            });
          }, 1400);
        };
        if (document.readyState === 'complete') schedule();
        else window.addEventListener('load', schedule, { once: true });
      }
      return;
    }

    if (!quickShopPreloadState.observer) {
      quickShopPreloadState.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          quickShopPreloadState.observer.unobserve(entry.target);
          quickShopQueuePreload(entry.target.getAttribute('data-quick-shop-url'));
        });
      }, { rootMargin: '520px 0px' });
    }

    const observe = function () {
      if (!trigger.closest('[data-quick-shop-root]')) quickShopPreloadState.observer.observe(trigger);
    };
    if (document.readyState === 'complete') {
      window.setTimeout(observe, 900);
    } else {
      window.addEventListener('load', function () {
        window.setTimeout(observe, 900);
      }, { once: true });
    }
  }

  function quickShopIsUsableSource(candidate) {
    if (!candidate || candidate.closest('[data-quick-shop-actions]')) return false;
    if (candidate.matches('[data-ms-flat-open], .ms-flat-start-card__cta')) return false;
    if (candidate.disabled || candidate.hidden) return false;
    if (candidate.getAttribute('aria-disabled') === 'true') return false;
    if (candidate.closest('[hidden], [aria-hidden="true"]')) return false;
    return true;
  }

  function purchaseMotorAddSource(scope) {
    if (!scope) return null;
    return qsa(QUICK_SHOP_ADD_SOURCE_SELECTOR, scope).find(quickShopIsUsableSource) || null;
  }


  function quickShopCalculatorHost() {
    const content = quickShopContent();
    return content ? qs('[data-ms-calculator-host]', content) : null;
  }

  function quickShopFlushActiveCalculatorInput() {
    const host = quickShopCalculatorHost();
    const api = window.MSPurchaseMotor;
    if (!host || !api || typeof api.flushActiveInput !== 'function') return false;
    const flushed = api.flushActiveInput(host);
    if (flushed) quickShopRefreshActions();
    return flushed;
  }

  function quickShopIsMspaHost(host) {
    return Boolean(host && (
      host.getAttribute('data-ms-purchase-app-host') === 'true'
      || host.getAttribute('data-mspa-motor-contract') === 'mspa-motor-v1'
    ));
  }

  function quickShopMspaMotorMissingState(host) {
    if (host) host.setAttribute('data-mspa-motor-missing', 'true');
    return {
      ready: false,
      busy: false,
      disabled: true,
      error: true,
      status: 'error',
      label: 'Produktvelgeren er ikke tilgjengelig',
      step: 'Produktvelgeren er ikke tilgjengelig',
      stepIndex: '',
      stepTotal: '',
      summary: CUSTOMER_OUTPUT.messages.boot,
      reason: 'mspa-motor-missing',
      family: host ? host.getAttribute('data-calculator-type') || '' : ''
    };
  }

  function quickShopCalculatorFlowState(host) {
    if (!host) return null;
    const isMspaHost = quickShopIsMspaHost(host);
    const hasMspaMotorApi = window.MSPurchaseMotor && typeof window.MSPurchaseMotor.getState === 'function';
    if (isMspaHost && !hasMspaMotorApi) {
      return quickShopMspaMotorMissingState(host);
    }
    if (isMspaHost && hasMspaMotorApi) {
      const motorState = window.MSPurchaseMotor.getState(host);
      if (motorState) {
        host.removeAttribute('data-mspa-motor-missing');
        if (host.getAttribute('data-mspa-motor-reason') === 'mspa-motor-missing') {
          host.removeAttribute('data-mspa-motor-reason');
        }
        if (!motorState.error && host.getAttribute('data-mspa-motor-error') === 'true') {
          host.setAttribute('data-mspa-motor-error', 'false');
        }
        return {
          ready: Boolean(motorState.ready),
          busy: Boolean(motorState.busy),
          disabled: Boolean(motorState.disabled),
          error: Boolean(motorState.error),
          status: motorState.status || host.dataset.mspaMotorStatus || '',
          label: motorState.label || '',
          step: motorState.step || host.dataset.mspaMotorStep || '',
          stepIndex: motorState.stepIndex || host.dataset.mspaMotorStepIndex || '',
          stepTotal: motorState.stepTotal || host.dataset.mspaMotorStepTotal || '',
          summary: motorState.summary || '',
          validation: motorState.validation || '',
          reason: motorState.reason || '',
          family: motorState.family || host.dataset.mspaMotorFamily || '',
          source: motorState.source || null,
          focusTarget: motorState.focusTarget || null,
          motorAdd: typeof motorState.add === 'function' ? motorState.add : null,
          motorIntent: motorState.intent || null
        };
      }
    }
    if (isMspaHost && host.dataset && host.dataset.mspaMotorStatus) {
      return {
        ready: host.dataset.mspaMotorReady === 'true',
        busy: host.dataset.mspaMotorBusy === 'true',
        disabled: host.dataset.mspaMotorDisabled === 'true',
        error: host.dataset.mspaMotorError === 'true',
        status: host.dataset.mspaMotorStatus || '',
        label: host.dataset.mspaMotorLabel || '',
        step: host.dataset.mspaMotorStep || '',
        stepIndex: host.dataset.mspaMotorStepIndex || '',
        stepTotal: host.dataset.mspaMotorStepTotal || '',
        summary: host.dataset.mspaMotorSummary || '',
        validation: '',
        reason: host.dataset.mspaMotorReason || '',
        family: host.dataset.mspaMotorFamily || ''
      };
    }
    if (isMspaHost) {
      return quickShopMspaMotorMissingState(host);
    }
    return null;
  }

  function quickShopFlowSource(host, flow, scope) {
    const content = scope || quickShopContent();
    const source = flow && flow.source && flow.source.nodeType === 1 ? flow.source : null;
    if (!content || !source || !content.contains(source)) return null;
    return quickShopIsUsableSource(source) ? source : null;
  }


  function purchaseMotorCalculatorActionState(host, scope) {
    const isMspaHost = host && (
      host.getAttribute('data-ms-purchase-app-host') === 'true'
      || host.getAttribute('data-mspa-motor-contract') === 'mspa-motor-v1'
    );
    const flow = quickShopCalculatorFlowState(host);
    const source = quickShopFlowSource(host, flow, scope) || (isMspaHost ? null : purchaseMotorAddSource(scope || host));

    if (host && flow) {
      const motorAdd = isMspaHost && typeof flow.motorAdd === 'function' ? flow.motorAdd : null;
      const ready = Boolean(flow.ready && !flow.busy && (source || motorAdd));
      const reason = String(flow.reason || '').toLowerCase();
      const status = String(flow.status || '').toLowerCase();
      const blocked = Boolean(flow.disabled || flow.error || (!ready && ['sold-out', 'unavailable', 'error'].indexOf(reason) !== -1) || ['disabled', 'error'].indexOf(status) !== -1);
      const focusTarget = ready ? source : (blocked ? null : (flow.focusTarget || host));
      return {
        show: true,
        ready: ready,
        disabled: blocked,
        busy: Boolean(flow.busy),
        source: ready ? source : null,
        motorAdd: ready ? motorAdd : null,
        motorIntent: flow.motorIntent || null,
        focusTarget: focusTarget,
        primaryTitle: flow.busy ? (flow.label || 'Legger i kurven...') : (ready ? READY_CART_OFFER_LABEL : (flow.label || 'Fullfør valget')),
        primarySubtitle: flow.busy ? 'Jobber med kurven.' : (ready ? 'Vis totalpris med frakt eller hent selv' : (flow.validation || flow.summary || 'Følg steget i kalkulatoren først.'))
      };
    }

    if (source) {
      return {
        show: true,
        ready: true,
        busy: false,
        source: source,
        primaryTitle: READY_CART_OFFER_LABEL,
        primarySubtitle: 'Vis totalpris med frakt eller hent selv'
      };
    }

    return null;
  }

  function quickShopCurrentActionState() {
    const content = quickShopContent();
    const state = purchaseMotorCalculatorActionState(quickShopCalculatorHost(), content);
    if (state) return state;

    return {
      show: false,
      ready: false,
      busy: false,
      source: null,
      focusTarget: null,
      disabled: true
    };
  }

  function quickShopActions() {
    const root = quickShopRoot();
    if (!root) return null;
    quickShopActionsNode = qs('[data-quick-shop-actions]', root) || quickShopActionsNode;
    return quickShopActionsNode;
  }

  // Keep the same bound CTA across family renders and product switches.
  function quickShopRestoreActions() {
    const root = quickShopRoot();
    const actions = quickShopActions();
    const home = root && qs('[data-quick-shop-actions-home]', root);
    if (actions && home && actions.parentElement !== home) home.appendChild(actions);
    if (actions) actions.hidden = true;
  }

  function quickShopSyncLayout(state) {
    const content = quickShopContent();
    const actions = quickShopActions();
    if (!content || !actions) return;
    const host = quickShopCalculatorHost();
    const price = host && qsa('[data-mspa-price-card], .mspa-price-card, .mspa-panel__price-card', host)
      .find(purchaseSurfaceIsElementVisible);
    const normalize = function (text) { return String(text || '').replace(/\s+/g, ' ').trim(); };
    const label = normalize(state.primaryTitle);
    qsa('[data-mspa-step-question], .mspa-choice-block__title', content).forEach(function (node) {
      node.toggleAttribute('data-quick-shop-redundant', !!label && normalize(node.textContent) === label);
    });
    qsa('[data-mspa-quantity-preset]', content).forEach(function (group) {
      const unitLabel = qs('.mspa-quantity-preset__label', group);
      if (group.getAttribute('data-mspa-quantity-preset') === 'flatPallets' && unitLabel && unitLabel.textContent !== 'Antall paller') {
        unitLabel.textContent = 'Antall paller';
      }
      const hint = qs('[data-mspa-quantity-hint]', group);
      if (hint && group.lastElementChild !== hint) group.appendChild(hint);
    });
    qsa('[data-mspa-ready-status]', content).forEach(function (node) {
      const ready = node.getAttribute('data-mspa-status-type') === 'ready';
      const text = normalize(node.textContent);
      const result = text.replace(/^Utvalget er klart\.\s*/, '');
      const generic = /^(?:Utvalget er klart for kurven\.|Legg i kurven(?: og se tilbudet)?\.|)$/.test(result);
      const repeatedHint = result && qsa('[data-mspa-quantity-hint]', host || content)
        .some(function (hint) { return normalize(hint.textContent).indexOf(result) === 0; });
      node.toggleAttribute('data-quick-shop-redundant', ready && (generic || repeatedHint));
      if (ready && result && result !== text) node.textContent = result;
      const flow = host && qs('[data-mspa-motor-flow]', host);
      if (ready && flow && flow.lastElementChild !== node) flow.appendChild(node);
    });
    if (host && state.show) {
      const anchor = price && (price.closest('.mspa-panel__header, .mspa-ecco__header, .mspa-flat__header, .mspa-kantstein__header, .mspa-wall__header') || price);
      const fallback = qs('[data-mspa-motor-shell]', host) || host;
      if (anchor && anchor.parentElement && anchor.nextElementSibling !== actions) {
        anchor.parentElement.insertBefore(actions, anchor.nextSibling);
      } else if (!anchor && fallback.firstElementChild !== actions) {
        fallback.insertBefore(actions, fallback.firstChild);
      }
    }
    // Standard products retain their native form and submit handler.
    qsa('[data-ms-purchase-kind="standard"] .product-purchase-surface__standard-row', content).forEach(function (row) {
      const button = qs('[data-ms-purchase-add]', row);
      if (button && row.firstElementChild !== button) row.insertBefore(button, row.firstChild);
    });
    const root = quickShopRoot();
    const payments = root && qs('[data-quick-shop-payments]', root);
    if (payments) payments.hidden = !qs('[data-quick-shop-product]', content);
  }

  function quickShopActionButtons() {
    const actions = quickShopActions();
    return actions ? qsa('[data-quick-shop-action]', actions) : [];
  }

  function quickShopSetActionsBusy(busy, activeAction) {
    quickShopActionButtons().forEach(function (button) {
      button.disabled = !!busy;
      button.setAttribute('aria-disabled', busy ? 'true' : 'false');
      button.toggleAttribute('aria-busy', !!busy && button.getAttribute('data-quick-shop-action') === activeAction);
    });
  }

  function quickShopUpdateScrollCue() {
    const root = quickShopRoot();
    const content = quickShopContent();
    const actions = quickShopActions();
    const cue = root ? qs('[data-quick-shop-scroll-cue]', root) : null;
    if (!root || !content || !actions || !cue || actions.hidden) {
      if (cue) cue.hidden = true;
      return;
    }

    const payments = qs('[data-quick-shop-payments]', root);
    const footerHeight = payments && !payments.hidden ? payments.offsetHeight : 0;
    root.style.setProperty('--quick-shop-footer-height', `${footerHeight}px`);
    const hasMore = content.scrollHeight - content.scrollTop - content.clientHeight > 28;
    cue.hidden = !hasMore;
  }

  function quickShopSetActionCopy(button, title, subtitle) {
    if (!button) return;
    const titleNode = qs('.quick-shop-action__title', button);
    const subtitleNode = qs('.quick-shop-action__subtitle', button);
    if (titleNode && titleNode.textContent !== (title || '')) titleNode.textContent = title || '';
    if (subtitleNode && subtitleNode.textContent !== (subtitle || '')) subtitleNode.textContent = subtitle || '';
  }

  function quickShopFocusActionTarget(target) {
    const content = quickShopContent();
    if (!target || !content || !content.contains(target)) return false;
    try {
      target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    } catch (error) {
      target.scrollIntoView();
    }

    const focusable = target.matches?.('button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ? target
      : target.querySelector?.('button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (focusable && typeof focusable.focus === 'function') {
      window.setTimeout(function () {
        try {
          focusable.focus({ preventScroll: true });
        } catch (error) {
          focusable.focus();
        }
      }, 220);
    }
    return true;
  }

  function quickShopRefreshActions() {
    const root = quickShopRoot();
    const actions = quickShopActions();
    if (!root || !actions) return;
    // Layout and CTA copy are now inside the observed content; do not observe our own writes.
    if (quickShopActionObserver) quickShopActionObserver.disconnect();
    const state = quickShopCurrentActionState();
    quickShopSyncLayout(state);
    const isCalculating = root.classList.contains('is-calculating') && state.show;
    actions.hidden = !state.show;
    root.classList.toggle('has-quick-actions', !!state.show);
    root.classList.toggle('has-quick-actions-ready', !!state.ready);
    quickShopActionButtons().forEach(function (button) {
      const isPrimary = button.getAttribute('data-quick-shop-action') === 'open';
      const canUsePrimary = Boolean(state.ready || state.focusTarget);
      const disabled = isCalculating || state.busy || state.disabled || (isPrimary ? !canUsePrimary : !state.ready);
      quickShopSetActionCopy(
        button,
        isCalculating && isPrimary ? 'Beregner...' : (isPrimary ? state.primaryTitle : state.secondaryTitle),
        isCalculating && isPrimary ? 'Oppdaterer utvalget.' : (isPrimary ? state.primarySubtitle : state.secondarySubtitle)
      );
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      button.toggleAttribute('aria-busy', isCalculating || !!state.busy);
    });
    quickShopWatchContent();
    window.requestAnimationFrame(quickShopUpdateScrollCue);
  }

  function quickShopSetTransientCalculationState(active) {
    const root = quickShopRoot();
    if (!root) return;
    window.clearTimeout(quickShopCalculationTimer);
    root.classList.toggle('is-calculating', !!active);
    if (active) {
      setQuickShopStatus('Beregner...', true);
      quickShopCalculationTimer = window.setTimeout(function () {
        root.classList.remove('is-calculating');
        setQuickShopStatus('', false);
        quickShopRefreshActions();
      }, 700);
    }
    quickShopRefreshActions();
  }

  function quickShopMaybeShowCalculationState(event) {
    const target = event && event.target && event.target.closest ? event.target : null;
    if (!target) return;
    const geonettChoice = target.closest('[data-msn-wall-choice="geonett"], [data-msn-boston-choice="geonett"]');
    if (!geonettChoice) return;
    quickShopSetTransientCalculationState(true);
  }

  function quickShopMarkCalculatorInteraction(event) {
    quickShopRecentCalculatorInteraction = Date.now();
    quickShopMaybeShowCalculationState(event);
  }

  function quickShopResolveFlowTarget(host, flow) {
    if (!host || !flow) return null;
    const target = flow.focusTarget;
    if (target) {
      if (target.nodeType === 1) return target;
      if (typeof target === 'string') return host.querySelector(target);
    }
    return null;
  }

  function quickShopScrollFlowTargetIntoView(host, flow, forceFocus, preferredTarget, preferTop) {
    const content = quickShopContent();
    const actions = quickShopActions();
    const target = preferredTarget || quickShopResolveFlowTarget(host, flow);
    if (!content || !actions || !target || !content.contains(target)) return false;

    const targetRect = target.getBoundingClientRect();
    const contentRect = content.getBoundingClientRect();
    const isCovered = targetRect.bottom > contentRect.bottom - 18 || targetRect.top < contentRect.top + 18;
    if (!preferTop && !isCovered && !forceFocus) return false;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (preferTop) {
      const nextTop = Math.max(0, content.scrollTop + targetRect.top - contentRect.top - 8);
      try {
        content.scrollTo({ top: nextTop, behavior: 'auto' });
      } catch (error) {
        content.scrollTop = nextTop;
      }
    } else {
      try {
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center', inline: 'nearest' });
      } catch (error) {
        target.scrollIntoView();
      }
    }

    if (forceFocus) {
      const focusable = target.matches?.('input:not([disabled]), select:not([disabled]), button:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
        ? target
        : target.querySelector?.('input:not([disabled]), select:not([disabled]), button:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (focusable && typeof focusable.focus === 'function') {
        window.setTimeout(function () {
          try {
            focusable.focus({ preventScroll: true });
          } catch (error) {
            focusable.focus();
          }
        }, 220);
      }
    }
    return true;
  }

  function quickShopMaybeAutoScrollCalculatorFlow(event) {
    const root = quickShopRoot();
    const content = quickShopContent();
    if (!root || !content || !root.classList.contains('is-open')) return;
    const host = event && event.target && event.target.closest
      ? event.target.closest('[data-ms-calculator-host]')
      : quickShopCalculatorHost();
    if (!host || !content.contains(host)) return;
    const flow = quickShopCalculatorFlowState(host);
    if (!flow || flow.busy) return;
    if (Date.now() - quickShopRecentCalculatorInteraction > 2200) return;

    const key = [flow.label || '', flow.reason || '', flow.summary || '', flow.ready ? 'ready' : 'step'].join('|');
    if (key === quickShopLastFlowKey) return;
    quickShopLastFlowKey = key;

    window.clearTimeout(quickShopFlowScrollTimer);
    quickShopFlowScrollTimer = window.setTimeout(function () {
      const readyTarget = flow.ready ? quickShopReadyFlowTarget(content) : null;
      if (flow.ready && !readyTarget) {
        window.setTimeout(function () {
          const retryTarget = quickShopReadyFlowTarget(content);
          if (!retryTarget) {
            quickShopLastFlowKey = '';
            return;
          }
          quickShopScrollFlowTargetIntoView(host, flow, false, retryTarget, true);
        }, 320);
        return;
      }
      quickShopScrollFlowTargetIntoView(host, flow, false, readyTarget, Boolean(flow.ready && readyTarget));
    }, 140);
  }

  function quickShopHandleCalculatorFlowUpdate(event) {
    quickShopRefreshActions();
    quickShopMaybeAutoScrollCalculatorFlow(event);
  }

  function quickShopObserveContent() {
    const content = quickShopContent();
    if (quickShopActionObserver) {
      quickShopActionObserver.disconnect();
      quickShopActionObserver = null;
    }
    if (!content || !('MutationObserver' in window)) return;
    quickShopActionObserver = new MutationObserver(function () {
      quickShopRefreshActions();
    });
    quickShopWatchContent();
  }

  function quickShopWatchContent() {
    const content = quickShopContent();
    if (!content || !quickShopActionObserver) return;
    quickShopActionObserver.observe(content, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'disabled', 'aria-disabled', 'data-mspa-motor-ready', 'data-mspa-motor-busy', 'data-mspa-motor-label']
    });
  }

  function quickShopFetchCart() {
    return quickShopFetch(quickShopRoute('cart', '/cart'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error(`Kunne ikke hente handlekurven (${response.status}).`);
      return response.json();
    });
  }

  function aaReadyCartService() {
    const bridge = window.MSNO_FK8_BRIDGE;
    if (!bridge || typeof bridge.waitForService !== 'function') return Promise.reject(new Error('FK8_CART_SERVICE_UNAVAILABLE'));
    return bridge.waitForService({ timeoutMs: 15000 });
  }

  function aaMarkCartRequestSent(lease) {
    if (!lease || typeof lease.markRequestSent !== 'function') return Promise.reject(new Error('FK8_CART_LEASE_INVALID'));
    return lease.markRequestSent();
  }

  function aaMarkCartResponseReceived(lease) {
    if (!lease || typeof lease.markResponseReceived !== 'function') return Promise.reject(new Error('FK8_CART_LEASE_INVALID'));
    return lease.markResponseReceived();
  }

  function aaRunCartWrite(writerKind, worker) {
    return aaReadyCartService().then(function (service) {
      return service.withCartWriterLease(worker, writerKind);
    });
  }

  function aaRunLocationAwareCartWrite(writerKind, incomingLines, worker, options) {
    const controller = window.MSNO_AA_FK7;
    const operational = controller
      && typeof controller.runLocationAwareCartWrite === 'function'
      && (typeof controller.isOperational !== 'function' || controller.isOperational());
    if (!operational) return aaReadyCartService().then(function (service) {
      return service.runLocationAwareCartWrite(writerKind, incomingLines, worker, options || {});
    });
    return controller.runLocationAwareCartWrite(
      writerKind,
      incomingLines,
      worker,
      options || {}
    );
  }

  function calculatorPurchaseMeasurement(intent) {
    try {
      const calculators = window.MSCalculators;
      return calculators && typeof calculators.purchaseJourneyContext === 'function'
        ? calculators.purchaseJourneyContext(intent) : null;
    } catch (_) { return null; }
  }

  function directPurchaseMeasurement(root) {
    try {
      const measurement = window.MSPurchaseJourney;
      return root && measurement && typeof measurement.snapshot === 'function'
        ? measurement.snapshot(root, {
          surface:root.getAttribute('data-ms-purchase-context') === 'quick-shop' ? 'quick_shop' : 'product_page',
          selection_method:'direct_quantity',selection_methods_used:['direct_quantity'],cart_origin:'purchase_panel'
        }) : null;
    } catch (_) { return null; }
  }




  function quickShopText(value) {
    return String(value == null ? '' : value).trim();
  }





  function quickShopLocationIdentityLines(items, fallbackSku) {
    const seen = new Map();
    (Array.isArray(items) ? items : []).forEach(function (item) {
      const variantId = String(item && (item.variant_id || item.id) || '');
      const sku = quickShopText(item && item.sku) || quickShopText(fallbackSku);
      const quantity = Number(item && item.quantity);
      if (!/^\d+$/.test(variantId) || !sku || !Number.isSafeInteger(quantity) || quantity <= 0) return;
      const key = `${variantId}|${sku}`;
      const current = seen.get(key) || { variant_id: variantId, sku, quantity: 0 };
      current.quantity += quantity;
      seen.set(key, current);
    });
    return Array.from(seen.values());
  }

  function quickShopNormalizeIntent(intent) {
    if (window.MSCalculatorCart && typeof window.MSCalculatorCart.normalize === 'function') {
      return window.MSCalculatorCart.normalize(intent);
    }
    if (window.MSCalculators && typeof window.MSCalculators.normalizeCartIntent === 'function') {
      return window.MSCalculators.normalizeCartIntent(intent);
    }
    return intent;
  }

  async function quickShopPrepareCalculatorIntent(intent) {
    let normalized = quickShopNormalizeIntent(intent);
    if (typeof window.MSCalculatorCartPrepareIntent === 'function') {
      normalized = await window.MSCalculatorCartPrepareIntent(normalized);
    }
    return normalized;
  }

  async function quickShopAddCalculatorIntentSilently(intent) {
    const analyticsContext = calculatorPurchaseMeasurement(intent);
    const normalized = await quickShopPrepareCalculatorIntent(intent);
    if (!quickShopValidateActiveProductForAdd() || !quickShopValidateIntentMatchesDrawer(normalized)) {
      throw new Error('Produktet kunne ikke verifiseres.');
    }
    const locationLines = quickShopLocationIdentityLines(
      (normalized.shippingItems || []).concat(normalized.items || []),
      ''
    );
    const duplicateLines = Array.isArray(normalized.shippingItems) && normalized.shippingItems.length
      ? normalized.shippingItems
      : (normalized.items || []);
    let result;
    try {
      result = await aaRunLocationAwareCartWrite('CALCULATOR', locationLines, async function (lease) {
      const route = quickShopRoute('cartAdd', '/cart/add');
      await lease.markMutation(route);
      await aaMarkCartRequestSent(lease);
      let response = null;
      try {
        response = await quickShopFetch(route, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: normalized.items || [] })
        });
        await aaMarkCartResponseReceived(lease);
      } catch (error) {
        throw error;
      }
      if (!response.ok) {
        let data = null;
        try { data = await response.clone().json(); } catch (error) {}
        const error = new Error(data?.description || data?.message || `Kunne ikke legge i kurven (${response.status}).`);
        error.response = response;
        error.status = response.status;
        error.payload = data;
        throw error;
      }
      let mutationResult = null;
      try {
        mutationResult = await response.json();
      } catch (error) {
        error.msPurchaseErrorType = 'cart_non_json';
        throw error;
      }
      return mutationResult;
    }, {
      keepSurfaceOpen: false,
      duplicateLines: duplicateLines,
      cartItems: normalized.items || [],
      analyticsContext
    });
    } catch (error) {
      if (quickShopIsControlledCartStop(error)) throw error;
      throw handlePurchaseLayerError(error, {
        source: 'quick-shop-calculator-add',
        intent: normalized
      });
    }
    document.dispatchEvent(new CustomEvent('ms:quick-shop:cart-silent-success', {
      detail: { intent: normalized, result: result }
    }));
    return result;
  }

  function quickShopInstallCalculatorCartBridge() {
    const cartApi = window.MSCalculatorCart;
    if (!cartApi || typeof cartApi.add !== 'function') return false;
    if (cartApi.__msQuickShopActionBridgeWrapped) return true;
    const originalAdd = cartApi.add.bind(cartApi);
    cartApi.add = async function msQuickShopCartAdd(intent) {
      const analyticsContext = calculatorPurchaseMeasurement(intent);
      if (!quickShopCartMode || quickShopCartMode.behavior !== 'silent') {
        if (cartApi.__msAaCartCoordinatorNative === true) {
          return originalAdd(intent);
        }
        const normalized = await quickShopPrepareCalculatorIntent(intent);
        const locationLines = quickShopLocationIdentityLines(
          (normalized.shippingItems || []).concat(normalized.items || []),
          ''
        );
        const duplicateLines = Array.isArray(normalized.shippingItems) && normalized.shippingItems.length
          ? normalized.shippingItems
          : (normalized.items || []);
        return aaRunLocationAwareCartWrite('CALCULATOR', locationLines, async function (lease) {
          await lease.markMutation(quickShopRoute('cartAdd', '/cart/add'));
          await aaMarkCartRequestSent(lease);
          const result = await originalAdd(normalized);
          await aaMarkCartResponseReceived(lease);
          return result;
        }, {
          keepSurfaceOpen: normalized.openCart === true,
          duplicateLines: duplicateLines,
          cartItems: normalized.items || [],
          analyticsContext
        });
      }
      try {
        return await quickShopAddCalculatorIntentSilently(intent);
      } catch (error) {
        document.dispatchEvent(new CustomEvent('ms:quick-shop:cart-silent-error', {
          detail: { intent: intent, error: error }
        }));
        throw error;
      }
    };
    cartApi.__msQuickShopActionBridgeWrapped = true;
    return true;
  }

  function purchaseSurfaceSelectedOption(root) {
    const select = qs('[data-ms-purchase-variant]', root);
    if (!select) return null;
    return select.selectedOptions ? select.selectedOptions[0] : qs(`option[value="${select.value}"]`, select);
  }

  function purchaseSurfaceVariantMapEntry(root, id) {
    const node = qs('[data-aa-shopify-variant-map]', root);
    if (!node || !/^\d+$/.test(id)) return null;
    try {
      const map = JSON.parse(node.textContent || '');
      if (
        !map
        || map.schema !== 'aa-shopify-product-variant-map-v1'
        || String(map.product_id || '') !== String(root.getAttribute('data-product-id') || '')
        || String(map.handle || '').trim() !== String(root.getAttribute('data-product-handle') || '').trim()
        || !Array.isArray(map.variants)
      ) return null;
      const matches = map.variants.filter(function (entry) {
        return String(entry && entry.variant_id || '') === id;
      });
      return matches.length === 1 ? matches[0] : null;
    } catch (error) {
      return null;
    }
  }

  function purchaseSurfaceVariantState(root) {
    const select = qs('[data-ms-purchase-variant]', root);
    const option = purchaseSurfaceSelectedOption(root);
    const id = String(select && select.value || '').trim();
    const numericId = Number(id);
    const sku = String(option && option.getAttribute('data-sku') || '').trim();
    const priceCents = Number(option && option.getAttribute('data-price'));
    const compareAtPriceCents = Number(option && option.getAttribute('data-compare-at-price'));
    const grams = Number(option && option.getAttribute('data-grams'));
    const availableRaw = String(option && option.getAttribute('data-available') || '');
    const inventoryManagement = String(option && option.getAttribute('data-inventory-management') || '').trim();
    const inventoryPolicy = String(option && option.getAttribute('data-inventory-policy') || '').trim();
    const inventoryQuantityRaw = String(option && option.getAttribute('data-inventory-quantity') || '').trim();
    const inventoryQuantity = inventoryQuantityRaw === '' ? null : Number(inventoryQuantityRaw);
    const mapEntry = purchaseSurfaceVariantMapEntry(root, id);
    if (
      !select
      || !option
      || option.value !== id
      || !/^\d+$/.test(id)
      || !Number.isSafeInteger(numericId)
      || numericId <= 0
      || !sku
      || !Number.isSafeInteger(priceCents)
      || priceCents < 0
      || !Number.isSafeInteger(compareAtPriceCents)
      || compareAtPriceCents < 0
      || !Number.isSafeInteger(grams)
      || grams < 0
      || !['true', 'false'].includes(availableRaw)
      || (inventoryManagement && !Number.isSafeInteger(inventoryQuantity))
      || (!inventoryManagement && inventoryQuantityRaw !== '')
      || !mapEntry
      || String(mapEntry.sku || '').trim() !== sku
      || Number(mapEntry.price_cents) !== priceCents
      || Number(mapEntry.compare_at_price_cents) !== compareAtPriceCents
      || Number(mapEntry.grams) !== grams
      || mapEntry.available !== (availableRaw === 'true')
      || String(mapEntry.inventory_management || '').trim() !== inventoryManagement
      || String(mapEntry.inventory_policy || '').trim() !== inventoryPolicy
      || (mapEntry.inventory_quantity === null && inventoryQuantityRaw !== '')
      || (mapEntry.inventory_quantity !== null
        && (!Number.isSafeInteger(inventoryQuantity)
          || inventoryQuantity !== Number(mapEntry.inventory_quantity)))
    ) return null;
    return Object.freeze({
      id,
      numericId,
      sku,
      priceCents,
      compareAtPriceCents,
      grams,
      available: availableRaw === 'true',
      inventoryManagement,
      inventoryPolicy,
      inventoryQuantity,
      inventoryQuantityRaw
    });
  }

  function purchaseSurfaceSyncVariantIdentity(root) {
    const state = purchaseSurfaceVariantState(root);
    if (!state) return null;
    root.setAttribute('data-product-variant-id', state.id);
    root.setAttribute('data-product-sku', state.sku);
    root.setAttribute('data-product-price-cents', String(state.priceCents));
    root.setAttribute('data-product-grams', String(state.grams));
    root.setAttribute('data-product-available', state.available ? 'true' : 'false');
    root.setAttribute('data-product-inventory-management', state.inventoryManagement);
    root.setAttribute('data-product-inventory-policy', state.inventoryPolicy);
    root.setAttribute('data-product-inventory-quantity', state.inventoryQuantityRaw);
    return state;
  }

  function purchaseSurfaceVariantAvailable(root) {
    const state = purchaseSurfaceVariantState(root);
    return Boolean(state && state.available);
  }

  function purchaseSurfaceQuantity(root) {
    const input = qs('[data-ms-purchase-qty-input]', root);
    const value = Math.max(1, Number.parseInt(String(input && input.value ? input.value : '1').replace(/[^\d]/g, ''), 10) || 1);
    if (input) input.value = String(value);
    return value;
  }

  const STANDARD_DEMAND_PROPERTY_KEYS = Object.freeze([
    '_aa_demand_schema',
    '_aa_demand_family',
    '_aa_demand_source_variant',
    '_aa_demand_kind',
    '_aa_demand_value',
    '_aa_demand_source_quantity'
  ]);

  function purchaseSurfaceDemandProperties(root) {
    const properties = {};
    let found = 0;
    STANDARD_DEMAND_PROPERTY_KEYS.forEach(function (key) {
      const input = qs(`[name="properties[${key}]"]`, root);
      if (!input) return;
      found += 1;
      properties[key] = String(input.value || '');
    });
    if (found === 0) return null;
    if (
      found !== STANDARD_DEMAND_PROPERTY_KEYS.length
      || STANDARD_DEMAND_PROPERTY_KEYS.some(function (key) { return !properties[key]; })
    ) throw new Error('Produktets leveringsgrunnlag er ufullstendig.');
    return properties;
  }

  function purchaseSurfacePayload(root) {
    const variant = purchaseSurfaceSyncVariantIdentity(root);
    const quantity = purchaseSurfaceQuantity(root);
    if (!variant || !variant.available) return null;
    const payload = { id: variant.numericId, quantity: quantity };
    const properties = purchaseSurfaceDemandProperties(root);
    if (properties) payload.properties = properties;
    return payload;
  }


  function purchaseSurfaceStatus(root, message, tone) {
    const status = qs('[data-ms-purchase-status]', root);
    if (!status) return;
    if (!message) {
      status.hidden = true;
      status.textContent = '';
      status.removeAttribute('data-tone');
      return;
    }
    status.hidden = false;
    status.textContent = message;
    if (tone) status.setAttribute('data-tone', tone);
    else status.removeAttribute('data-tone');
  }

  function purchaseSurfaceDeliveryStatusNode(root) {
    const scope = root.closest('.product__info') || root.closest('.quick-shop') || document;
    return qs('[data-ms-delivery-status]', scope);
  }

  function purchaseSurfaceSyncDeliveryStatus(root) {
    const node = purchaseSurfaceDeliveryStatusNode(root);
    if (!node) return;
    const option = purchaseSurfaceSelectedOption(root);
    const available = purchaseSurfaceVariantAvailable(root);
    const inventoryManagement = option ? option.getAttribute('data-inventory-management') : '';

    let tone = 'available';
    let message = node.getAttribute('data-delivery-in-stock') || node.textContent.trim();

    if (!available) {
      tone = 'sold-out';
      message = node.getAttribute('data-delivery-sold-out') || 'UTSOLGT';
    } else if (!inventoryManagement) {
      tone = 'quote';
      message = node.getAttribute('data-delivery-quote') || message;
    }

    node.textContent = message;
    node.dataset.tone = tone;
  }

  function purchaseSurfaceEmitVariantChange(root, stateOverride) {
    const state = stateOverride || purchaseSurfaceSyncVariantIdentity(root);
    if (!state) return;
    document.dispatchEvent(new CustomEvent('ms:variant:change', {
      detail: {
        id: state.id,
        sku: state.sku,
        price: String(state.priceCents),
        compareAtPrice: String(state.compareAtPriceCents),
        grams: state.grams,
        available: state.available,
        inventoryManagement: state.inventoryManagement,
        inventoryPolicy: state.inventoryPolicy,
        inventoryQuantity: state.inventoryQuantity
      }
    }));
  }

  function purchaseSurfaceSetBusy(root, busy) {
    const addButton = qs('[data-ms-purchase-add]', root);
    const text = qs('[data-ms-purchase-button-text]', root) || addButton;
    const available = purchaseSurfaceVariantAvailable(root);
    qsa('button, input, select', root).forEach(function (node) {
      if (node.closest('[data-ms-postcode-variant-gate-panel]')) return;
      node.disabled = Boolean(busy) || (node === addButton && !available);
    });
    if (addButton) {
      addButton.setAttribute('aria-disabled', busy || !available ? 'true' : 'false');
      addButton.toggleAttribute('aria-busy', !!busy);
      addButton.classList.toggle('is-sold-out', !available);
    }
    if (text) {
      text.textContent = busy ? 'Legger til...' : (available ? 'Legg i kurven' : 'Utsolgt');
    }
  }



  async function purchaseSurfaceAddStandard(root) {
    const writerKind = root.getAttribute('data-ms-purchase-context') === 'quick-shop'
      ? 'QUICK_SHOP'
      : 'PRODUCT';
    const payload = purchaseSurfacePayload(root);
    if (!payload) throw new Error('Produktet er ikke tilgjengelig.');
    const variant = purchaseSurfaceVariantState(root);
    if (!variant || variant.numericId !== payload.id) {
      throw new Error('Produktvarianten kunne ikke bekreftes.');
    }
    const requestedPayload = payload;
    const locationLines = quickShopLocationIdentityLines(
      Array.isArray(payload.items) ? payload.items : [payload],
      variant.sku
    );
    const duplicateLines = Array.isArray(payload.items) ? payload.items : [payload];
    const analyticsContext = directPurchaseMeasurement(root);
    let cartOperationId = aaCreateCartOperationId();
    const telemetryIntent = {
      id: cartOperationId,
      context: { quickShop: writerKind === 'QUICK_SHOP' },
      items: locationLines
    };
    try {
      const result = await aaRunLocationAwareCartWrite(writerKind, locationLines, async function (lease) {
        cartOperationId = aaBeginCartOperation(
          root.getAttribute('data-ms-purchase-context') === 'quick-shop'
            ? 'quick-shop'
            : 'purchase-surface',
          cartOperationId
        );
        const route = quickShopRoute('cartAdd', '/cart/add');
        await lease.markMutation(route);
        await aaMarkCartRequestSent(lease);
        const response = await quickShopFetch(route, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        await aaMarkCartResponseReceived(lease);
        if (!response.ok) {
          let data = null;
          try { data = await response.clone().json(); } catch (error) {}
          const error = new Error(data?.description || data?.message || `Kunne ikke legge i kurven (${response.status}).`);
          error.response = response;
          error.status = response.status;
          error.payload = data;
          throw error;
        }
        try {
          return await response.json();
        } catch (error) {
          throw handlePurchaseLayerError(error, {
            source: 'standard-purchase-add',
            intent: telemetryIntent,
            type: 'cart_non_json'
          });
        }
      }, {
        keepSurfaceOpen: true,
        duplicateLines: duplicateLines,
        cartItems: duplicateLines,
        analyticsContext,
        operationId: cartOperationId
      });
      if (!cartOperationId) {
        cartOperationId = aaBeginCartOperation(
          root.getAttribute('data-ms-purchase-context') === 'quick-shop'
            ? 'quick-shop'
            : 'purchase-surface'
        );
      }
      const cart = await quickShopFetchCart();
      document.dispatchEvent(new CustomEvent('ms:product-purchase:add', {
        detail: {
          variantId: requestedPayload.id,
          quantity: requestedPayload.quantity,
          productTitle: root.getAttribute('data-product-title') || '',
          vendor: root.getAttribute('data-product-vendor') || '',
          source: 'standard-direct-add',
          result: result,
          cart: cart
        }
      }));
      aaFinishCartOperation(cartOperationId, 'SUCCEEDED');
      if (writerKind === 'PRODUCT') purchaseSurfaceEnsureCartOpen();
      return result;
    } catch (error) {
      aaFinishCartOperation(cartOperationId, aaControlledCartOperationStatus(error));
      if (aaControlledCartOperationStatus(error) === 'CANCELLED') throw error;
      throw handlePurchaseLayerError(error, {
        source: 'standard-purchase-add',
        intent: telemetryIntent
      });
    }
  }

  function purchaseSurfaceWallSummaryReady(root) {
    const lengthInput = qs('[data-msn-wall-length]', root);
    const heightSelect = qs('[data-msn-wall-height]', root);
    const length = Number.parseInt(String(lengthInput && lengthInput.value ? lengthInput.value : '').replace(/[^\d]/g, ''), 10);
    return Boolean(Number.isFinite(length) && length > 0 && heightSelect && heightSelect.value);
  }

  function purchaseSurfaceSyncWallSummary(root) {
    const summary = qs('[data-msn-wall-summary]', root);
    if (!summary) return;
    qsa('.msn-pallet__metric', summary).forEach(function (metric) {
      const value = qs('[data-msn-wall-metric]', metric);
      const metricType = value ? value.getAttribute('data-msn-wall-metric') : '';
      const visible = metricType === 'length' || metricType === 'height';
      metric.hidden = !visible;
      metric.toggleAttribute('aria-hidden', !visible);
    });
    const ready = purchaseSurfaceWallSummaryReady(root);
    if (ready) summary.hidden = false;
    summary.toggleAttribute('data-ms-purchase-summary-ready', ready);
  }

  const productPurchaseFlowScrollTimers = new WeakMap();
  const productPurchaseFlowLastKeys = new WeakMap();

  function purchaseSurfaceCalculatorHost(surface) {
    return surface ? qs('[data-ms-calculator-host]', surface) : null;
  }

  function purchaseSurfaceActionArea(surface) {
    return qs([
      '.msn-pallet__primary-action',
      '.ms-flat-action-bar',
      '.msk-selection-action-row',
      '.ms-pick-actions',
      '.msn-pick__primary-wrap',
      '.msn-pick__actions',
      '.ms-mw-advanced-wizard__actions',
      '.ms-mw-advanced-final-actions-slot .ms-mw-advanced-wizard__actions',
      '.ms-mw-advanced-preview-actions-slot .ms-mw-advanced-wizard__actions'
    ].join(','), surface);
  }


  function purchaseSurfaceActionButton(surface) {
    const action = purchaseSurfaceActionArea(surface);
    if (!action) return null;
    return qsa([
      '.msn-pallet__primary',
      '.ms-flat-add-btn',
      '.msk-selection-add-main',
      '.msk-drawer-add',
      '.msn-pick__primary',
      '[data-add-to-cart]',
      'button'
    ].join(','), action).find(function (button) {
      return purchaseSurfaceIsElementVisible(button);
    }) || null;
  }

  function purchaseSurfaceIsElementVisible(element) {
    if (!element || element.hidden || element.closest('[hidden], [aria-hidden="true"]')) return false;
    return Boolean(element.offsetParent || element.getClientRects().length);
  }

  function purchaseSurfaceButtonReady(button) {
    return Boolean(
      button
      && purchaseSurfaceIsElementVisible(button)
      && !button.disabled
      && button.getAttribute('aria-disabled') !== 'true'
    );
  }

  function purchaseSurfaceStatusState(surface) {
    const status = qs('[data-ms-purchase-status]', surface);
    if (!status || status.hidden) return '';
    const message = String(status.textContent || '').trim();
    if (!message) return '';
    if (status.getAttribute('data-tone') === 'error') return 'error';
    if (/lagt i kurven/i.test(message)) return 'added';
    return '';
  }

  function purchaseSurfaceCtaState(surface) {
    if (!surface || surface.getAttribute('data-ms-purchase-context') !== 'product') return '';

    if (surface.dataset.msPurchaseBusy === 'true') return 'busy';

    const statusState = purchaseSurfaceStatusState(surface);
    if (statusState) return statusState;

    const hasInteraction = surface.dataset.msPurchaseHasInteraction === 'true';
    const kind = surface.getAttribute('data-ms-purchase-kind') || '';

    if (kind === 'standard') {
      if (!hasInteraction) return 'not_started';
      return purchaseSurfacePayload(surface) ? 'ready' : 'missing_input';
    }

    const host = purchaseSurfaceCalculatorHost(surface);
    const flow = quickShopCalculatorFlowState(host);
    if (flow && flow.busy) return 'busy';
    if (!hasInteraction) return 'not_started';

    const primary = purchaseSurfaceActionButton(surface);
    if (purchaseSurfaceButtonReady(primary)) return 'ready';
    return 'missing_input';
  }

  function purchaseSurfaceApplyCtaState(surface) {
    const state = purchaseSurfaceCtaState(surface);
    if (!state) return '';
    surface.dataset.msPurchaseCtaState = state;
    return state;
  }

  function purchaseSurfaceHeaderBottom() {
    const header = qs('[data-sticky-header]');
    if (!header) return 0;
    const rect = header.getBoundingClientRect();
    return Math.max(0, rect.bottom || 0);
  }








  const productFlowBoundProducts = new WeakSet();

  function productFlowViewportWidth() {
    return Math.min(
      window.innerWidth || Number.POSITIVE_INFINITY,
      document.documentElement ? document.documentElement.clientWidth || Number.POSITIVE_INFINITY : Number.POSITIVE_INFINITY
    );
  }

  function productFlowCommerce(product) {
    return qs('#ProductCommerceFlow', product) || qs('.product__info--commerce-card', product);
  }

  function productFlowSurface(product) {
    return qs('[data-ms-purchase-surface][data-ms-purchase-context="product"]', product);
  }

  function productFlowHost(product) {
    return qs('[data-ms-calculator-host][data-calculator-context="product"]', product);
  }

  function productFlowExplicitSubscroll(commerce) {
    if (!commerce) return null;
    return qsa('[data-ms-product-flow-subscroll-node], [data-ms-product-flow-subscroll]', commerce).find(function (candidate) {
      if (!candidate || candidate === commerce) return false;
      if (candidate.getAttribute('data-ms-product-flow-subscroll') === 'none') return false;
      const style = getComputedStyle(candidate);
      if (style.overflowY === 'visible' || style.overflowY === 'clip') return false;
      return candidate.scrollHeight > candidate.clientHeight + 4;
    }) || null;
  }

  function productFlowMode(surface, host) {
    const modeRoot = host || surface;
    if (!modeRoot) return surface && surface.getAttribute('data-ms-purchase-kind') === 'standard' ? 'standard' : 'unknown';
    const explicitMode = modeRoot.getAttribute('data-mspa-active-mode') || modeRoot.getAttribute('data-ms-product-flow-mode') || '';
    if (explicitMode === 'pick') return 'pickmix';
    if (explicitMode === 'calculate') return 'calculate';
    const activeMode = qs('[data-mspa-component="mode-switch"][data-mspa-choice-group="mode"] [data-mspa-choice].is-active, .mspa-mode-switch__button.is-active[data-mspa-choice]', modeRoot);
    const choice = activeMode ? activeMode.getAttribute('data-mspa-choice') : '';
    if (choice === 'pick') return 'pickmix';
    if (choice === 'calculate') return 'calculate';
    if (host && host.getAttribute('data-calculator-context') === 'product') return 'calculate';
    return 'unknown';
  }

  function productFlowContentHeight(commerce, surface, host) {
    return Math.max(
      commerce ? commerce.scrollHeight : 0,
      surface ? surface.scrollHeight : 0,
      host ? host.scrollHeight : 0
    );
  }

  function productFlowCtaState(surface, host) {
    if (host) {
      if (host.getAttribute('data-mspa-motor-ready') === 'true' || host.getAttribute('data-mspa-motor-status') === 'ready') return 'ready';
      if (host.getAttribute('data-mspa-motor-busy') === 'true' || host.getAttribute('data-mspa-motor-status') === 'busy') return 'busy';
      if (host.getAttribute('data-mspa-motor-error') === 'true' || host.getAttribute('data-mspa-motor-status') === 'error') return 'error';
    }
    return surface ? purchaseSurfaceApplyCtaState(surface) : '';
  }

  function productFlowBottomGutter() {
    return Math.max(14, Math.min(window.innerHeight * 0.035, 28));
  }

  function productFlowStickyTopOffset() {
    return purchaseSurfaceHeaderBottom() + 14;
  }

  function productFlowAvailableHeight() {
    return Math.max(0, window.innerHeight - productFlowStickyTopOffset() - productFlowBottomGutter());
  }

  function productFlowStickyTop(content, contentHeight) {
    const topOffset = productFlowStickyTopOffset();
    if (content !== 'tall') return topOffset;
    const bottomAnchoredTop = window.innerHeight - productFlowBottomGutter() - contentHeight;
    return Math.min(topOffset, bottomAnchoredTop);
  }

  function productFlowUsesWindowScroll(owner) {
    return owner === 'window' || owner === 'window-with-subscroll';
  }

  function productFlowSetAttribute(nodes, name, value) {
    nodes.forEach(function (node) {
      if (!node) return;
      node.setAttribute(name, value);
    });
  }

  function productFlowSetStyle(nodes, name, value) {
    nodes.forEach(function (node) {
      if (!node || !node.style) return;
      node.style.setProperty(name, value);
    });
  }

  function productFlowUpdate(product) {
    if (!product || !product.matches('.product--visual-commerce')) return;
    const commerce = productFlowCommerce(product);
    const surface = productFlowSurface(product);
    const host = productFlowHost(product);
    if (!commerce) return;

    const mode = productFlowMode(surface, host);
    const subscroll = productFlowExplicitSubscroll(commerce);
    const contentHeight = productFlowContentHeight(commerce, surface, host);
    const availableHeight = productFlowAvailableHeight();
    const content = mode === 'pickmix' || contentHeight > availableHeight + 4 ? 'tall' : 'fits';
    const sticky = productFlowViewportWidth() >= 1280
      && !document.body.classList.contains('is-drawer-open')
      ? (content === 'tall' ? 'bottom' : 'top')
      : 'disabled';
    const stickyTop = sticky === 'disabled' ? productFlowStickyTopOffset() : productFlowStickyTop(content, contentHeight);
    const bottomGutter = productFlowBottomGutter();
    const ctaState = productFlowCtaState(surface, host);
    const scrollOwner = subscroll ? 'window-with-subscroll' : 'window';
    const nodes = [product, commerce, surface, host];

    productFlowSetAttribute(nodes, 'data-ms-product-flow-contract', 'qp-scroll-v2');
    productFlowSetAttribute(nodes, 'data-ms-product-flow-mode', mode);
    productFlowSetAttribute(nodes, 'data-ms-product-flow-content', content);
    productFlowSetAttribute(nodes, 'data-ms-product-flow-sticky', sticky);
    productFlowSetAttribute(nodes, 'data-ms-product-flow-scroll-owner', scrollOwner);
    productFlowSetAttribute(nodes, 'data-ms-product-flow-subscroll', subscroll ? 'present' : 'none');
    productFlowSetAttribute(nodes, 'data-ms-product-flow-cta-state', ctaState || 'unknown');
    productFlowSetStyle(nodes, '--ms-product-flow-sticky-top', stickyTop.toFixed(2) + 'px');
    productFlowSetStyle(nodes, '--ms-product-flow-bottom-gutter', bottomGutter.toFixed(2) + 'px');
    productFlowSetStyle(nodes, '--ms-product-flow-content-height', contentHeight.toFixed(2) + 'px');
    productFlowSetStyle(nodes, '--ms-product-flow-available-height', availableHeight.toFixed(2) + 'px');
  }

  function bindProductFlow(root) {
    qsa('.product--visual-commerce', root).forEach(function (product) {
      if (productFlowBoundProducts.has(product)) return;
      productFlowBoundProducts.add(product);

      let raf = 0;
      const requestUpdate = function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = 0;
          productFlowUpdate(product);
        });
      };

      product.addEventListener('input', requestUpdate, true);
      product.addEventListener('change', requestUpdate, true);
      product.addEventListener('click', function () {
        window.setTimeout(requestUpdate, 60);
        window.setTimeout(requestUpdate, 240);
      }, true);
      product.addEventListener('ms:mspa-motor:update', requestUpdate);
      product.addEventListener('ms:calculator-flow:update', requestUpdate);
      window.addEventListener('resize', requestUpdate, { passive: true });

      if (typeof MutationObserver === 'function') {
        const observer = new MutationObserver(requestUpdate);
        observer.observe(product, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: [
            'hidden',
            'class',
            'aria-disabled',
            'disabled',
            'data-ms-calculator-flow-ready',
            'data-ms-calculator-flow-busy',
            'data-mspa-choice-value',
            'data-mspa-motor-status',
            'data-mspa-motor-ready',
            'data-mspa-motor-disabled',
            'data-mspa-step-state'
          ]
        });
      }

      if (typeof ResizeObserver === 'function') {
        const resizeObserver = new ResizeObserver(requestUpdate);
        [productFlowCommerce(product), productFlowSurface(product), productFlowHost(product)].forEach(function (node) {
          if (node) resizeObserver.observe(node);
        });
      }

      productFlowUpdate(product);
      window.setTimeout(requestUpdate, 180);
      window.setTimeout(requestUpdate, 900);
    });
  }

  function purchaseSurfaceFallbackFlowTarget(surface) {
    return qsa([
      '.is-current',
      '[aria-current="step"]',
      '[aria-current="true"]',
      '[data-msn-wall-choice]:not([hidden])',
      '[data-msn-boston-choice]:not([hidden])'
    ].join(','), surface).find(function (candidate) {
      if (!purchaseSurfaceIsElementVisible(candidate)) return false;
      if (candidate.closest('.msn-pallet__primary-action, .ms-flat-action-bar, .msk-selection-action-row, .ms-pick-actions, .msn-pick__primary-wrap, .msn-pick__actions')) return false;
      return true;
    }) || null;
  }

  function purchaseSurfaceReadyMessageTarget(scope) {
    return qsa([
      '.msn-pallet__message:not([hidden])'
    ].join(','), scope).find(function (candidate) {
      if (!purchaseSurfaceIsElementVisible(candidate)) return false;
      const text = String(candidate.textContent || '').trim().toLowerCase();
      return text.includes('utvalget')
        || text.includes('beregningen er klar')
        || (text.includes('kurven') && (text.includes('legg') || text.includes('klar')));
    }) || null;
  }

  function purchaseSurfaceReadyLineTarget(scope) {
    return qsa([
      '[data-ms-flat-lines-panel]:not([hidden])',
      '.ms-flat-lines:not(:empty)',
      '.msn-pallet__lines:not([hidden])',
      '.ms-kubbemur-inline-selection:not([hidden])',
      '[data-msn-troja-lines]:not([hidden])',
      '.msn-pick__lines:not(:empty)',
      '.ms2-selection-lines:not([hidden])'
    ].join(','), scope).find(function (candidate) {
      if (!purchaseSurfaceIsElementVisible(candidate)) return false;
      return qsa('.msn-pallet-line, .msn-wall-line, .ms-flat-line, .msn-pick-line, .ms-pick-line, .ms2-selection-line, .msk-selection-line, .msk-drawer-line', candidate)
        .some(purchaseSurfaceIsElementVisible);
    }) || null;
  }

  function purchaseSurfaceReadySelectionTarget(scope) {
    const lineTarget = purchaseSurfaceReadyLineTarget(scope);
    if (!lineTarget) return null;
    return purchaseSurfaceReadyMessageTarget(scope) || lineTarget;
  }

  function purchaseSurfaceReadyFlowTarget(surface) {
    const selectionTarget = purchaseSurfaceReadySelectionTarget(surface);
    if (selectionTarget) return selectionTarget;
    return null;
  }

  function quickShopReadyFlowTarget(content) {
    const actions = quickShopActions();
    if (actions && content && content.contains(actions) && !actions.hidden) return actions;
    return purchaseSurfaceReadySelectionTarget(content);
  }

  function purchaseSurfaceResolveFlowTarget(surface, host, flow) {
    const target = quickShopResolveFlowTarget(host, flow);
    if (target && surface.contains(target) && purchaseSurfaceIsElementVisible(target)) return target;
    return purchaseSurfaceFallbackFlowTarget(surface);
  }

  function purchaseSurfaceScrollTargetIntoView(surface, target, forceFocus, preferTop) {
    if (!surface || !target || !surface.contains(target)) return false;
    const host = target.closest?.('[data-ms-calculator-host][data-calculator-context="product"]');
    const isMspaProductHost = quickShopIsMspaHost(host);
    const productFlowScrollOwner = surface.closest?.('.product--visual-commerce')?.getAttribute('data-ms-product-flow-scroll-owner');
    const productFlowWindowScroll = isMspaProductHost
      && productFlowUsesWindowScroll(productFlowScrollOwner);
    const surfaceRect = surface.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const action = purchaseSurfaceActionArea(surface);
    const actionRect = action ? action.getBoundingClientRect() : null;
    const surfaceStyle = getComputedStyle(surface);
    const surfaceCanScroll = surface.scrollHeight > surface.clientHeight + 4
      && surfaceStyle.overflowY !== 'visible'
      && surfaceStyle.overflowY !== 'clip';
    const viewportTopLimit = purchaseSurfaceHeaderBottom() + 16;
    const viewportBottomLimit = window.innerHeight - Math.max(96, Math.min(window.innerHeight * 0.18, 132));
    const topLimit = surfaceCanScroll
      ? surfaceRect.top + 16
      : Math.max(surfaceRect.top + 16, viewportTopLimit);
    const bottomLimit = surfaceCanScroll
      ? (actionRect && actionRect.top > surfaceRect.top
        ? Math.min(surfaceRect.bottom - 16, actionRect.top - 16)
        : surfaceRect.bottom - 18)
      : viewportBottomLimit;
    const isCovered = targetRect.top < topLimit || targetRect.bottom > bottomLimit;
    if (!preferTop && !isCovered && !forceFocus) return false;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!surfaceCanScroll) {
      if (isMspaProductHost && !productFlowWindowScroll) return false;
      const headerOffset = preferTop
        ? purchaseSurfaceHeaderBottom() + 12
        : purchaseSurfaceHeaderBottom() + Math.max(24, Math.min(window.innerHeight * 0.14, 120));
      const nextTop = Math.max(0, window.scrollY + targetRect.top - headerOffset);
      try {
        window.scrollTo({ top: nextTop, behavior: reducedMotion ? 'auto' : 'smooth' });
      } catch (error) {
        window.scrollTo(0, nextTop);
      }
      return true;
    }

    const targetOffset = targetRect.top - surfaceRect.top;
    const targetCenterOffset = preferTop
      ? targetOffset - 10
      : targetOffset - Math.max(28, Math.min(surface.clientHeight * 0.28, 140));
    const nextTop = Math.max(0, surface.scrollTop + targetCenterOffset);
    try {
      surface.scrollTo({ top: nextTop, behavior: preferTop || reducedMotion ? 'auto' : 'smooth' });
    } catch (error) {
      surface.scrollTop = nextTop;
    }

    if (forceFocus) {
      const focusable = target.matches?.('input:not([disabled]), select:not([disabled]), button:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
        ? target
        : target.querySelector?.('input:not([disabled]), select:not([disabled]), button:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (focusable && typeof focusable.focus === 'function') {
        window.setTimeout(function () {
          try {
            focusable.focus({ preventScroll: true });
          } catch (error) {
            focusable.focus();
          }
        }, 220);
      }
    }
    return true;
  }

  function purchaseSurfaceMarkInteraction(surface) {
    if (!surface) return;
    surface.dataset.msPurchaseHasInteraction = 'true';
    purchaseSurfaceApplyCtaState(surface);
  }

  function purchaseSurfaceMarkCalculatorInteraction(surface) {
    if (!surface) return;
    purchaseSurfaceMarkInteraction(surface);
    surface.dataset.msPurchaseRecentCalculatorInteraction = String(Date.now());
  }

  function purchaseSurfaceMaybeAutoScrollCalculatorFlow(surface, event) {
    const host = event && event.target && event.target.closest
      ? event.target.closest('[data-ms-calculator-host]')
      : purchaseSurfaceCalculatorHost(surface);
    if (!surface || !host || !surface.contains(host)) return;
    if (productFlowMode(surface, host) === 'pickmix') return;
    const lastInteraction = Number(surface.dataset.msPurchaseRecentCalculatorInteraction || 0);
    if (!lastInteraction || Date.now() - lastInteraction > 2400) return;

    const flow = quickShopCalculatorFlowState(host);
    if (flow && flow.busy) return;
    const readyTarget = purchaseSurfaceReadyFlowTarget(surface);
    const fallbackTarget = !readyTarget && !flow ? purchaseSurfaceFallbackFlowTarget(surface) : null;
    if (flow && flow.ready && !readyTarget) return;
    if (!readyTarget && !flow && !fallbackTarget) return;

    const key = readyTarget
      ? ['ready-target', readyTarget.textContent || '', readyTarget.className || ''].join('|')
      : flow
      ? [flow.label || '', flow.reason || '', flow.summary || '', flow.ready ? 'ready' : 'step', readyTarget ? readyTarget.textContent || readyTarget.className || '' : ''].join('|')
      : ['fallback', fallbackTarget.textContent || '', fallbackTarget.className || ''].join('|');
    if (productPurchaseFlowLastKeys.get(surface) === key) return;
    productPurchaseFlowLastKeys.set(surface, key);

    const existingTimer = productPurchaseFlowScrollTimers.get(surface);
    window.clearTimeout(existingTimer);
    productPurchaseFlowScrollTimers.set(surface, window.setTimeout(function () {
      const target = readyTarget || (flow
        ? purchaseSurfaceResolveFlowTarget(surface, host, flow)
        : purchaseSurfaceFallbackFlowTarget(surface));
      purchaseSurfaceScrollTargetIntoView(surface, target, false, Boolean(readyTarget));
    }, 150));
  }

  function bindProductPurchaseCalculatorSurface(surface) {
    if (surface.dataset.msPurchaseCalculatorBound === 'true') return;
    surface.dataset.msPurchaseCalculatorBound = 'true';

    const sync = function () {
      window.setTimeout(function () {
        purchaseSurfaceSyncWallSummary(surface);
        purchaseSurfaceApplyCtaState(surface);
      }, 0);
    };

    const markAndSync = function (event) {
      purchaseSurfaceMarkCalculatorInteraction(surface);
      sync();
      window.setTimeout(function () {
        purchaseSurfaceMaybeAutoScrollCalculatorFlow(surface, event);
      }, 90);
    };

    qsa('[data-msn-wall-length], [data-msn-wall-height]', surface).forEach(function (node) {
      node.addEventListener('input', markAndSync);
      node.addEventListener('change', markAndSync);
    });

    surface.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest) return;
      const interactive = event.target.closest('button, input, select, textarea, [role="button"], [tabindex]');
      if (!interactive || !surface.contains(interactive)) return;
      purchaseSurfaceMarkCalculatorInteraction(surface);
      window.setTimeout(function () {
        purchaseSurfaceMaybeAutoScrollCalculatorFlow(surface, event);
      }, 120);
    }, true);

    surface.addEventListener('change', function (event) {
      purchaseSurfaceMarkCalculatorInteraction(surface);
      window.setTimeout(function () {
        purchaseSurfaceMaybeAutoScrollCalculatorFlow(surface, event);
      }, 120);
    }, true);

    surface.addEventListener('input', markAndSync, true);

    surface.addEventListener('ms:calculator-flow:update', function (event) {
      purchaseSurfaceSyncWallSummary(surface);
      purchaseSurfaceApplyCtaState(surface);
      purchaseSurfaceMaybeAutoScrollCalculatorFlow(surface, event);
    });

    const summary = qs('[data-msn-wall-summary]', surface);
    if (summary && typeof MutationObserver === 'function') {
      const observer = new MutationObserver(function () {
        if (purchaseSurfaceWallSummaryReady(surface) && summary.hidden) sync();
      });
      observer.observe(summary, { attributes: true, attributeFilter: ['hidden'] });
    }

    if (typeof MutationObserver === 'function') {
      const flowObserver = new MutationObserver(function () {
        purchaseSurfaceApplyCtaState(surface);
        const lastInteraction = Number(surface.dataset.msPurchaseRecentCalculatorInteraction || 0);
        if (!lastInteraction || Date.now() - lastInteraction > 2400) return;
        window.setTimeout(function () {
          purchaseSurfaceMaybeAutoScrollCalculatorFlow(surface);
        }, 80);
      });
      flowObserver.observe(surface, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['hidden', 'class', 'aria-disabled', 'disabled']
      });
    }

    purchaseSurfaceSyncWallSummary(surface);
    purchaseSurfaceApplyCtaState(surface);
  }

  function bindProductPurchaseSurfaces(root) {
    qsa('[data-ms-purchase-surface][data-ms-purchase-kind="calculator"][data-ms-purchase-context="product"]', root).forEach(bindProductPurchaseCalculatorSurface);

    qsa('[data-ms-purchase-surface][data-ms-purchase-kind="standard"]', root).forEach(function (surface) {
      if (surface.dataset.msPurchaseSurfaceBound === 'true') return;
      surface.dataset.msPurchaseSurfaceBound = 'true';

      const input = qs('[data-ms-purchase-qty-input]', surface);
      const minus = qs('[data-ms-purchase-qty-minus]', surface);
      const plus = qs('[data-ms-purchase-qty-plus]', surface);
      const select = qs('[data-ms-purchase-variant]', surface);

      if (minus) {
        minus.addEventListener('click', function () {
          purchaseSurfaceMarkInteraction(surface);
          if (input) input.value = String(Math.max(1, purchaseSurfaceQuantity(surface) - 1));
          purchaseSurfaceStatus(surface, '', '');
          purchaseSurfaceApplyCtaState(surface);
        });
      }

      if (plus) {
        plus.addEventListener('click', function () {
          purchaseSurfaceMarkInteraction(surface);
          if (input) input.value = String(purchaseSurfaceQuantity(surface) + 1);
          purchaseSurfaceStatus(surface, '', '');
          purchaseSurfaceApplyCtaState(surface);
        });
      }

      if (input) {
        input.addEventListener('input', function () {
          purchaseSurfaceMarkInteraction(surface);
          input.value = String(input.value || '').replace(/[^\d]/g, '');
          purchaseSurfaceStatus(surface, '', '');
          purchaseSurfaceApplyCtaState(surface);
        });
        input.addEventListener('blur', function () {
          purchaseSurfaceQuantity(surface);
          purchaseSurfaceApplyCtaState(surface);
        });
        input.addEventListener('change', function () {
          purchaseSurfaceMarkInteraction(surface);
          purchaseSurfaceQuantity(surface);
          purchaseSurfaceStatus(surface, '', '');
          purchaseSurfaceApplyCtaState(surface);
        });
      }

      if (select) {
        select.addEventListener('change', function () {
          purchaseSurfaceMarkInteraction(surface);
          const variant = purchaseSurfaceSyncVariantIdentity(surface);
          purchaseSurfaceEmitVariantChange(surface, variant);
          purchaseSurfaceSyncDeliveryStatus(surface);
          purchaseSurfaceSetBusy(surface, false);
          purchaseSurfaceStatus(surface, '', '');
          purchaseSurfaceApplyCtaState(surface);
        });
      }

      surface.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (surface.dataset.msPurchaseBusy === 'true') return;
        surface.dataset.msPurchaseBusy = 'true';
        purchaseSurfaceStatus(surface, '', '');
        purchaseSurfaceSetBusy(surface, true);
        purchaseSurfaceApplyCtaState(surface);
        try {
          await purchaseSurfaceAddStandard(surface);
          purchaseSurfaceStatus(surface, 'Lagt i kurven.', 'success');
        } catch (error) {
          const message = error && (
            error.msLocationPromptHandled
            || error.msVendorPromptHandled
            || error.msDuplicateProductPromptHandled
          )
            ? ''
            : isPurchaseLayerError(error)
              ? ''
              : customerMessageForError(error, { action: 'cart', surface: 'standard-product' });
          purchaseSurfaceStatus(surface, message, message ? 'error' : '');
        } finally {
          purchaseSurfaceSetBusy(surface, false);
          surface.dataset.msPurchaseBusy = 'false';
          purchaseSurfaceApplyCtaState(surface);
        }
      });

      purchaseSurfaceSyncVariantIdentity(surface);
      purchaseSurfaceSetBusy(surface, false);
      purchaseSurfaceSyncDeliveryStatus(surface);
      purchaseSurfaceApplyCtaState(surface);
    });
  }

  function productSendLinkViewport() {
    if (typeof window.matchMedia === 'function') {
      if (window.matchMedia('(max-width: 740px)').matches) return 'mobile';
      if (window.matchMedia('(max-width: 1024px)').matches) return 'tablet';
    }
    return 'desktop';
  }

  function productSendLinkCleanUrl(container) {
    const raw = container.getAttribute('data-product-url') || window.location.href;
    try {
      const url = new URL(raw, window.location.origin);
      url.search = '';
      url.hash = '';
      url.searchParams.set('ms_share', 'product_link');
      return url.toString();
    } catch (error) {
      return window.location.origin + window.location.pathname;
    }
  }

  // Google & YouTube owns GA4 configuration and standard events.
  const OWN_ANALYTICS_DESTINATION = 'G-QE0S9L31YR';
  const ownAnalyticsQueue = [];
  const ownAnalyticsRetryDelays = [250, 1000, 3500, 8000];
  let ownAnalyticsTimer = null;
  let ownAnalyticsRetry = 0;
  let ownAnalyticsFlushing = false;
  let ownAnalyticsGeneration = 0;
  let ownAnalyticsBound = false;
  let ownAnalyticsFrame = null;
  let ownAnalyticsConsent = false;
  let ownAnalyticsOwnerSeen = false;

  function ownAnalyticsAllowed() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && typeof privacy.analyticsProcessingAllowed === 'function'
        && privacy.analyticsProcessingAllowed() === true;
    } catch (error) { return false; }
  }

  function ownAnalyticsConfigured() {
    // The owner must have queued its config before our event commands.
    // A gtag function alone may belong to an Ads-only destination.
    if (typeof window.gtag !== 'function' || !Array.isArray(window.dataLayer)) return false;
    if (!ownAnalyticsOwnerSeen) {
      ownAnalyticsOwnerSeen = window.dataLayer.some(function (entry) {
        return entry && entry[0] === 'config' && entry[1] === OWN_ANALYTICS_DESTINATION;
      });
    }
    // Google can truncate the layer later; positive readiness lasts this document.
    return ownAnalyticsOwnerSeen;
  }

  function ownAnalyticsVisible(element) {
    if (!element || !element.isConnected || document.visibilityState === 'hidden') return false;
    if (element.closest('[hidden], [aria-hidden="true"]')) return false;
    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0
      && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  function ownAnalyticsViewPending(element, attribute) {
    return element.getAttribute(attribute) === 'true' || ownAnalyticsQueue.some(function (record) {
      return record.element === element && record.attribute === attribute;
    });
  }

  function clearOwnAnalyticsPending() {
    ownAnalyticsGeneration += 1;
    ownAnalyticsQueue.length = 0;
    window.clearTimeout(ownAnalyticsTimer);
    ownAnalyticsTimer = null;
    ownAnalyticsRetry = 0;
    if (ownAnalyticsFrame !== null) window.cancelAnimationFrame(ownAnalyticsFrame);
    ownAnalyticsFrame = null;
  }

  function scheduleOwnAnalyticsFlush(delay) {
    if (ownAnalyticsTimer !== null || ownAnalyticsFlushing || !ownAnalyticsQueue.length) return;
    ownAnalyticsTimer = window.setTimeout(flushOwnAnalytics, delay);
  }

  function flushOwnAnalytics() {
    ownAnalyticsTimer = null;
    if (!ownAnalyticsAllowed()) { clearOwnAnalyticsPending(); return; }
    if (!ownAnalyticsQueue.length || ownAnalyticsFlushing) return;
    const generation = ownAnalyticsGeneration;
    const budget = ownAnalyticsQueue.reduce(function (sum, record) { return sum + record.events.length; }, 0);
    ownAnalyticsFlushing = true;
    try {
      let sent = 0;
      while (ownAnalyticsQueue.length && sent < budget && ownAnalyticsConfigured()) {
        if (!ownAnalyticsAllowed() || generation !== ownAnalyticsGeneration) break;
        const record = ownAnalyticsQueue[0];
        if (record.element && !record.element.isConnected) { ownAnalyticsQueue.shift(); continue; }
        const event = record.events[0];
        try {
          window.gtag('event', event.name, event.params);
        } catch (error) { break; }
        // Handoff succeeded. Never replay this command because a later one fails.
        record.events.shift();
        sent += 1;
        if (!record.events.length && record.element) record.element.setAttribute(record.attribute, 'true');
        if (generation !== ownAnalyticsGeneration || !ownAnalyticsAllowed()) break;
        try { window.dataLayer.push(event.payload); } catch (error) {}
        if (generation !== ownAnalyticsGeneration) break;
        if (!record.events.length) ownAnalyticsQueue.shift();
      }
    } finally {
      ownAnalyticsFlushing = false;
    }
    if (!ownAnalyticsAllowed()) { clearOwnAnalyticsPending(); return; }
    if (!ownAnalyticsQueue.length) { ownAnalyticsRetry = 0; return; }
    if (ownAnalyticsRetry < ownAnalyticsRetryDelays.length) {
      scheduleOwnAnalyticsFlush(ownAnalyticsRetryDelays[ownAnalyticsRetry++]);
    } else {
      // Discard unsent work after this short retry window, never replay it later.
      clearOwnAnalyticsPending();
    }
  }

  function queueOwnAnalytics(events, element, attribute) {
    if (!ownAnalyticsAllowed()) return false;
    if (element && ownAnalyticsViewPending(element, attribute)) return true;
    if (ownAnalyticsQueue.length >= 20) return false;
    ownAnalyticsQueue.push({ events: events, element: element, attribute: attribute });
    if (ownAnalyticsTimer === null && !ownAnalyticsFlushing) ownAnalyticsRetry = 0;
    scheduleOwnAnalyticsFlush(0);
    return true;
  }

  function scanOwnAnalyticsViews() {
    ownAnalyticsFrame = null;
    if (!ownAnalyticsAllowed()) return;
    qsa('[data-ms-product-send-link]').forEach(trackProductSendLinkView);
    qsa('[data-article-product-spot]').forEach(trackArticleProductView);
  }

  function scheduleOwnAnalyticsViews() {
    if (!ownAnalyticsAllowed() || ownAnalyticsFrame !== null) return;
    ownAnalyticsFrame = window.requestAnimationFrame(scanOwnAnalyticsViews);
  }

  function syncOwnAnalyticsConsent() {
    const allowed = ownAnalyticsAllowed();
    if (!allowed) clearOwnAnalyticsPending();
    else if (!ownAnalyticsConsent) {
      scheduleOwnAnalyticsViews();
      scheduleOwnAnalyticsFlush(0);
    }
    ownAnalyticsConsent = allowed;
  }

  function bindOwnAnalyticsConsent() {
    if (ownAnalyticsBound) return;
    ownAnalyticsBound = true;
    document.addEventListener('visitorConsentCollected', syncOwnAnalyticsConsent);
    document.addEventListener('visibilitychange', function () {
      syncOwnAnalyticsConsent();
      scheduleOwnAnalyticsViews();
    });
    window.addEventListener('pageshow', function () {
      syncOwnAnalyticsConsent();
      scheduleOwnAnalyticsViews();
    });
    window.addEventListener('scroll', scheduleOwnAnalyticsViews, { passive: true });
    window.addEventListener('resize', scheduleOwnAnalyticsViews);
    syncOwnAnalyticsConsent();
    // The CMP owns API loading. A bounded read retry covers delayed initialization
    // with saved consent, which need not publish a new consent-change event.
    let attempt = 0;
    function waitForPrivacyApi() {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
        syncOwnAnalyticsConsent();
      } else if (attempt < ownAnalyticsRetryDelays.length) {
        window.setTimeout(waitForPrivacyApi, ownAnalyticsRetryDelays[attempt++]);
      }
    }
    waitForPrivacyApi();
  }

  function productSendLinkGa4Destination() {
    return OWN_ANALYTICS_DESTINATION;
  }

  function productSendLinkGa4Params(payload) {
    const params = {};
    [
      'product_id',
      'variant_id',
      'product_handle',
      'product_type',
      'vendor',
      'source_surface',
      'link_method'
    ].forEach(function (key) {
      if (payload[key] != null && payload[key] !== '') params[key] = payload[key];
    });
    const destination = productSendLinkGa4Destination();
    if (destination) params.send_to = destination;
    return params;
  }

  function productSendLinkEvent(container, eventName, method, viewAttribute) {
    const payload = {
      event: eventName,
      product_id: container.getAttribute('data-product-id') || '',
      variant_id: container.getAttribute('data-variant-id') || '',
      product_handle: container.getAttribute('data-product-handle') || '',
      product_type: container.getAttribute('data-product-type') || '',
      vendor: container.getAttribute('data-product-vendor') || '',
      source_surface: 'product_page',
      viewport: productSendLinkViewport()
    };
    if (method) {
      payload.share_method = method;
      payload.link_method = method === 'native' ? 'native_share' : method;
    }

    document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    return queueOwnAnalytics([{
      name: eventName,
      params: productSendLinkGa4Params(payload),
      payload: payload
    }], viewAttribute ? container : null, viewAttribute);
  }

  function trackProductSendLinkView(container) {
    const attribute = 'data-ms-product-send-link-viewed';
    if (!ownAnalyticsAllowed() || !ownAnalyticsVisible(container) || ownAnalyticsViewPending(container, attribute)) return;
    productSendLinkEvent(container, 'ms_product_link_section_viewed', '', attribute);
  }

  function observeProductSendLinkView(container) {
    if (!container || container.getAttribute('data-ms-product-send-link-view-observed') === 'true') return;
    container.setAttribute('data-ms-product-send-link-view-observed', 'true');
    if (typeof window.IntersectionObserver === 'function') {
      const observer = new window.IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting && entry.intersectionRatio > 0; })) return;
        observer.disconnect();
        trackProductSendLinkView(container);
      }, { threshold: 0.01 });
      observer.observe(container);
      return;
    }

    const check = function () {
      const rect = container.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.right <= 0 || rect.top >= window.innerHeight || rect.left >= window.innerWidth) return;
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
      trackProductSendLinkView(container);
    };
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    window.requestAnimationFrame(check);
  }

  function productSendLinkStatus(container, message) {
    const status = qs('[data-ms-product-send-link-status]', container);
    if (!status) return;
    window.clearTimeout(container.msProductSendLinkStatusTimer);
    status.textContent = message || '';
    status.hidden = !message;
    if (message) {
      container.msProductSendLinkStatusTimer = window.setTimeout(function () {
        status.textContent = '';
        status.hidden = true;
      }, 2600);
    }
  }

  function productSendLinkCopy(url) {
    if (window.navigator && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard.writeText(url);
    }

    return new Promise(function (resolve, reject) {
      const textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      textarea.style.top = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        const copied = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (copied) resolve();
        else reject(new Error('copy_failed'));
      } catch (error) {
        document.body.removeChild(textarea);
        reject(error);
      }
    });
  }

  function productSendLinkOpenMailto(container, url) {
    const subject = container.getAttribute('data-mail-subject') || '';
    const prefix = container.getAttribute('data-mail-body-prefix') || '';
    const body = [prefix, url].filter(Boolean).join('\n');
    productSendLinkEvent(container, 'ms_product_link_mailto_opened', 'mailto');
    window.location.href = 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  async function productSendLinkShare(container, button) {
    if (button.getAttribute('aria-busy') === 'true') return;

    const url = productSendLinkCleanUrl(container);
    const title = container.getAttribute('data-share-title') || document.title;
    const copiedText = container.getAttribute('data-copied-text') || 'Lenke kopiert';
    button.setAttribute('aria-busy', 'true');

    try {
      if (window.navigator && typeof navigator.share === 'function') {
        try {
          productSendLinkEvent(container, 'ms_product_link_share_opened', 'native');
          await navigator.share({ title: title, url: url });
          return;
        } catch (shareError) {
          if (shareError && shareError.name === 'AbortError') return;
        }
      }

      try {
        await productSendLinkCopy(url);
        productSendLinkStatus(container, copiedText);
        productSendLinkEvent(container, 'ms_product_link_copied', 'copy');
      } catch (copyError) {
        productSendLinkOpenMailto(container, url);
      }
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  function bindProductSendLink(root) {
    qsa('[data-ms-product-send-link]:not([data-ms-product-send-link-bound])', root).forEach(function (container) {
      const button = qs('[data-ms-product-send-link-button]', container);
      const copyButton = qs('[data-ms-product-copy-link-button]', container);
      if (!button && !copyButton) return;
      container.setAttribute('data-ms-product-send-link-bound', 'true');
      observeProductSendLinkView(container);
      if (button) {
        button.addEventListener('click', function () {
          productSendLinkShare(container, button);
        });
      }
      if (copyButton) {
        copyButton.addEventListener('click', async function () {
          if (copyButton.getAttribute('aria-busy') === 'true') return;
          copyButton.setAttribute('aria-busy', 'true');
          const url = productSendLinkCleanUrl(container);
          const copiedText = container.getAttribute('data-copied-text') || 'Lenke kopiert';
          try {
            await productSendLinkCopy(url);
            productSendLinkStatus(container, copiedText);
            productSendLinkEvent(container, 'ms_product_link_copied', 'copy');
          } catch (error) {
            productSendLinkOpenMailto(container, url);
          } finally {
            copyButton.removeAttribute('aria-busy');
          }
        });
      }
    });
  }

  function quickShopWaitForEvent(successName, errorName, timeout) {
    return new Promise(function (resolve, reject) {
      const timer = window.setTimeout(function () {
        cleanup();
        reject(new Error('Det tok for lang tid å legge varene i kurven.'));
      }, timeout || 18000);

      function cleanup() {
        window.clearTimeout(timer);
        document.removeEventListener(successName, onSuccess);
        if (errorName) document.removeEventListener(errorName, onError);
      }

      function onSuccess(event) {
        cleanup();
        resolve(event.detail || {});
      }

      function onError(event) {
        cleanup();
        const error = event.detail && event.detail.error ? event.detail.error : new Error('Kunne ikke legge i kurven.');
        reject(error);
      }

      document.addEventListener(successName, onSuccess, { once: true });
      if (errorName) document.addEventListener(errorName, onError, { once: true });
    });
  }

  function quickShopFinishSilentAdd() {
    const root = quickShopRoot();
    if (!root) return;
    setQuickShopStatus('Lagt i kurven.', true);
    root.classList.add('is-added-silently');
    document.body.classList.add('ms-quick-shop-cart-pulse');
    window.setTimeout(function () {
      if (!root.hasAttribute('hidden')) root.classList.add('is-minimizing-to-cart');
    }, 360);
    window.setTimeout(function () {
      closeQuickShop({ restoreFocus: false });
    }, 820);
    window.setTimeout(function () {
      document.body.classList.remove('ms-quick-shop-cart-pulse');
    }, 1100);
  }

  function quickShopIsControlledCartStop(value) {
    if (!value || typeof value !== 'object') return false;
    if (value.msControlledCartStop || value.controlledStop || value.msLocationGuardBlocked || value.msVendorGuardBlocked || value.msQuickShopVendorConflict) return true;
    if (window.MSPurchaseMotor && typeof window.MSPurchaseMotor.isControlledCartStop === 'function') {
      return window.MSPurchaseMotor.isControlledCartStop(value);
    }
    if (window.MSCalculators && typeof window.MSCalculators.isControlledCartStop === 'function') {
      return window.MSCalculators.isControlledCartStop(value);
    }
    return false;
  }

  function quickShopEnsureControlledCartNotice(value) {
    if (document.getElementById('miniCartMixedVendorModal') || document.querySelector('.fk7Cart-vendorConflict, .fk6-notice--error')) return;
    const detail = {
      source: 'quick-shop-controlled-stop',
      conflict: value?.msVendorConflict || value?.vendorConflict || value?.error?.msVendorConflict || null
    };
    if (typeof window.MSShowVendorConflictWarning === 'function') {
      try {
        window.MSShowVendorConflictWarning(detail);
        return;
      } catch (error) {
        console.warn('Kunne ikke vise vendor-varsel etter QS-stopp:', error);
      }
    }
    document.dispatchEvent(new CustomEvent('ms:cart:vendor-conflict', { detail }));
  }

  function quickShopHandleControlledCartStop(value) {
    const promptHandled = Boolean(value && (
      value.msLocationPromptHandled === true
      || value.msVendorPromptHandled === true
      || value.msDuplicateProductPromptHandled === true
    ));
    const promptChoice = value && (
      value.msLocationPromptChoice
      || value.msVendorPromptChoice
      || value.msDuplicateProductPromptChoice
    );
    if (promptHandled) {
      quickShopCartMode = null;
      setQuickShopStatus('', false);
      quickShopSetActionsBusy(false, '');
      quickShopRefreshActions();
      if (promptChoice === 'view') closeQuickShop({ restoreFocus: false });
      return;
    }
    quickShopEnsureControlledCartNotice(value);
    quickShopCartMode = null;
    setQuickShopStatus('', false);
    quickShopSetActionsBusy(false, '');
    quickShopRefreshActions();
    closeQuickShop({ restoreFocus: false });
  }

  async function quickShopAddSilently(source) {
    quickShopInstallCalculatorCartBridge();
    const pending = quickShopWaitForEvent('ms:quick-shop:cart-silent-success', 'ms:quick-shop:cart-silent-error', 22000);
    try {
      quickShopCartMode = { behavior: 'silent' };
      source.click();
      await pending;
    } catch (error) {
      if (quickShopIsControlledCartStop(error)) {
        quickShopHandleControlledCartStop(error);
        return;
      }
      throw error;
    } finally {
      quickShopCartMode = null;
    }
    quickShopFinishSilentAdd();
  }

  async function quickShopAddAndOpenCart(source) {
    source.click();
  }

  async function quickShopRunMotorAdd(add, action) {
    if (typeof add !== 'function') throw new Error('MSPA-motoren mangler add-intent.');
    quickShopInstallCalculatorCartBridge();
    if (action === 'silent') {
      let result;
      try {
        quickShopCartMode = { behavior: 'silent' };
        result = await add({ context: 'quick-shop', action: 'silent' });
      } catch (error) {
        if (quickShopIsControlledCartStop(error)) {
          quickShopHandleControlledCartStop(error);
          return;
        }
        throw error;
      } finally {
        quickShopCartMode = null;
      }
      if (quickShopIsControlledCartStop(result)) {
        quickShopHandleControlledCartStop(result);
        return;
      }
      quickShopFinishSilentAdd();
      return;
    }
    const cartMode = { behavior: 'open', operationId: '' };
    quickShopCartMode = cartMode;
    try {
      const result = await add({ context: 'quick-shop', action: 'open' });
      if (quickShopIsControlledCartStop(result)) {
        if (cartMode.operationId) {
          aaFinishCartOperation(cartMode.operationId, aaControlledCartOperationStatus(result));
        }
        quickShopHandleControlledCartStop(result);
        return;
      }
      if (!cartMode.operationId && !cartMode.intentObserved) {
        cartMode.operationId = aaBeginCartOperation('quick-shop');
      }
      if (cartMode.operationId) {
        aaFinishCartOperation(cartMode.operationId, 'SUCCEEDED');
      }
    } catch (error) {
      if (cartMode.operationId) {
        aaFinishCartOperation(cartMode.operationId, aaControlledCartOperationStatus(error));
      }
      throw error;
    } finally {
      if (quickShopCartMode === cartMode) quickShopCartMode = null;
    }
  }

  async function quickShopHandleAction(button) {
    quickShopFlushActiveCalculatorInput();
    const action = button.getAttribute('data-quick-shop-action') || '';
    if (!quickShopValidateActiveProductForAdd()) {
      quickShopRefreshActions();
      return;
    }
    const state = quickShopCurrentActionState();
    const source = state.source;
    const motorAdd = typeof state.motorAdd === 'function' ? state.motorAdd : null;
    if (!state.ready || (!source && !motorAdd)) {
      if (state.focusTarget && quickShopFocusActionTarget(state.focusTarget)) return;
      return;
    }
    quickShopSetActionsBusy(true, action);
    setQuickShopStatus(action === 'silent' ? 'Legger i kurven...' : 'Åpner handlekurven...', true);
    try {
      if (motorAdd) {
        await quickShopRunMotorAdd(motorAdd, action);
      } else if (action === 'silent') {
        await quickShopAddSilently(source);
      } else {
        await quickShopAddAndOpenCart(source);
      }
    } catch (error) {
      if (quickShopIsControlledCartStop(error)) {
        quickShopHandleControlledCartStop(error);
        return;
      }
      quickShopCartMode = null;
      setQuickShopStatus(
        isPurchaseLayerError(error) ? '' : customerMessageForError(error, { action: 'cart', surface: 'quick-shop' }),
        !isPurchaseLayerError(error)
      );
      quickShopSetActionsBusy(false, '');
      quickShopRefreshActions();
    }
  }

  function bindQuickShopActions() {
    const root = quickShopRoot();
    if (!root || root.dataset.msQuickShopActionsBound === 'true') return;
    root.dataset.msQuickShopActionsBound = 'true';

    function beginCalculatorOperation(intent, preparing) {
      const cartMode = quickShopCartMode;
      if (
        !cartMode
        || cartMode.behavior !== 'open'
        || !intent
        || !intent.context
        || intent.context.quickShop !== true
      ) return;
      cartMode.intentObserved = true;
      const rebinding = Boolean(cartMode.operationId);
      if (rebinding && cartMode.pendingIntent === intent) {
        if (preparing !== true && !cartMode.closeScheduled) {
          cartMode.closeScheduled = true;
          closeQuickShopAfterCart();
        }
        return;
      }
      const operationId = cartMode.operationId || aaCreateCartOperationId();
      const event = new CustomEvent('ms:cart:open-request', {
        bubbles: true,
        cancelable: true,
        detail: {
          source: 'quick-shop',
          pending: true,
          operation_id: operationId,
          // Presentation and private writer correlation only; AA and Shopify
          // still validate the real cart before any commerce authority is ready.
          pending_intent: intent,
          rebind_pending_intent: rebinding
        }
      });
      const dispatched = document.dispatchEvent(event);
      if (dispatched !== false && event.defaultPrevented !== true) return;
      cartMode.operationId = operationId;
      cartMode.pendingIntent = intent;
      // The preparation hook requires the QS controller to remain connected.
      // Keep its DOM until the exact prepared intent has been rebound.
      if (preparing !== true && !cartMode.closeScheduled) {
        cartMode.closeScheduled = true;
        closeQuickShopAfterCart();
      }
    }

    document.addEventListener('ms:calculator-cart:prepare-start', function (event) {
      beginCalculatorOperation(event && event.detail && event.detail.intent, true);
    });
    // Rebind the prepared selection before the writer captures item identity.
    document.addEventListener('ms:calculator-cart:intent', function (event) {
      beginCalculatorOperation(event && event.detail && event.detail.intent);
    });
    document.addEventListener('ms:calculator:add-start', function (event) {
      beginCalculatorOperation(event && event.detail && event.detail.options && event.detail.options.intent);
    });

    qsa('[data-quick-shop-action]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        quickShopHandleAction(button);
      });
    });

    root.addEventListener('pointerdown', function (event) {
      const button = event.target.closest?.('[data-quick-shop-action]');
      if (!button || !root.contains(button)) return;
      quickShopFlushActiveCalculatorInput();
    }, true);

    root.addEventListener('keydown', function (event) {
      if (!root.classList.contains('is-open') || root.hasAttribute('hidden')) return;
      const drawer = qs('.quick-shop-drawer', root) || root;
      if (event.key === 'Tab') {
        trapFocusWithin(drawer, event);
        return;
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        closeQuickShop();
      }
    });

    const content = quickShopContent();
    if (content) {
      content.addEventListener('scroll', quickShopUpdateScrollCue, { passive: true });
      content.addEventListener('input', quickShopMarkCalculatorInteraction, true);
      content.addEventListener('change', quickShopMarkCalculatorInteraction, true);
      content.addEventListener('click', quickShopMarkCalculatorInteraction, true);
    }
    window.addEventListener('resize', quickShopUpdateScrollCue, { passive: true });
    document.addEventListener('ms:calculator-flow:update', quickShopHandleCalculatorFlowUpdate);
    document.addEventListener('ms:mspa-motor:update', quickShopHandleCalculatorFlowUpdate);
  }




  function quickShopApplyLaunchOptions(trigger, container) {
    // Kategori-QS bruker ikke produktside-launch-attributter. Hold hooken lett for fremtidig produktkort-data.
    if (!trigger || !container) return;
    quickShopRefreshActions();
  }

  function executeQuickShopScripts(container) {
    const scriptTasks = qsa('script', container).map(function (oldScript) {
      if (oldScript.src && loadedQuickShopScripts.has(oldScript.src) && canReuseQuickShopScript(oldScript.src)) {
        oldScript.remove();
        return Promise.resolve();
      }

      const nextScript = document.createElement('script');
      Array.prototype.slice.call(oldScript.attributes).forEach(function (attr) {
        nextScript.setAttribute(attr.name, attr.value);
      });
      nextScript.async = false;

      const task = oldScript.src ? new Promise(function (resolve) {
        nextScript.addEventListener('load', function () {
          loadedQuickShopScripts.add(nextScript.src);
          resolve();
        }, { once: true });
        nextScript.addEventListener('error', resolve, { once: true });
      }) : Promise.resolve();

      if (!oldScript.src) nextScript.textContent = oldScript.textContent;
      oldScript.replaceWith(nextScript);

      return task;
    });

    return Promise.all(scriptTasks);
  }

  function openCalculatorExperience(shell, options) {
    if (!shell) return;
    const config = options || {};

    function focusFirstCalculatorField() {
      if (!config.focus) return;
      const focusTarget = qsa('input:not([type="hidden"]):not([disabled]), select:not([disabled])', shell)
        .find(function (field) {
          return !!(
            field &&
            typeof field.focus === 'function' &&
            field.offsetParent !== null &&
            !field.closest('[hidden], [aria-hidden="true"]')
          );
        });
      if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus({ preventScroll: true });
      }
    }

    window.setTimeout(function () {
      if (window.MSCalculators && typeof window.MSCalculators.openQuick === 'function') {
        const handled = window.MSCalculators.openQuick(shell);
        if (handled) {
          window.setTimeout(focusFirstCalculatorField, 120);
          return;
        }
      }

      if (quickShopIsMspaHost(shell)) {
        quickShopRefreshActions();
        window.setTimeout(focusFirstCalculatorField, 80);
        return;
      }

      const flatModal = qs('[data-ms-flat-modal]', shell);
      const flatOverlay = qs('[data-ms-flat-overlay]', shell);
      const openedFlatInline = !!flatModal;

      if (flatModal) {
        flatModal.hidden = false;
        flatModal.setAttribute('aria-hidden', 'false');
        if (flatOverlay) flatOverlay.hidden = true;
      }

      const startSelectors = openedFlatInline ? [] : [
        '#mwSingleWallButton',
        '#miniStraightWallButton',
        '#megasmartStartWallButton',
        '#megastoneNyOpenWizard',
        '#bostonNyOpenWizard',
        '#trainStartButton',
        '#granittStartButton',
        '#kantsteinStartButton'
      ];
      const opener = startSelectors
        .map(function (selector) { return qs(selector, shell); })
        .find(function (button) { return button && !button.disabled && button.getAttribute('aria-disabled') !== 'true'; });

      if (opener && typeof opener.click === 'function') {
        const hadAddToCart = opener.hasAttribute('data-add-to-cart');
        const addToCartValue = opener.getAttribute('data-add-to-cart');
        if (hadAddToCart) opener.removeAttribute('data-add-to-cart');
        opener.click();
        if (hadAddToCart) opener.setAttribute('data-add-to-cart', addToCartValue || '');
      }

      if (openedFlatInline) {
        window.setTimeout(focusFirstCalculatorField, 120);
        return;
      }

      window.setTimeout(focusFirstCalculatorField, 120);
    }, 80);
  }

  function primeQuickShopCalculator(container) {
    const shell = qs('[data-ms-quick-shop-calculator]', container);
    if (!shell || shell.dataset.msQuickShopPrimed === 'true') return;
    shell.dataset.msQuickShopPrimed = 'true';
    openCalculatorExperience(shell, { focus: true });
  }

  function primeProductCalculatorFlow(root) {
    qsa('[data-ms-calculator-host][data-calculator-context="product"]', root).forEach(function (shell) {
      if (shell.dataset.msProductCalculatorPrimed === 'true') return;
      shell.dataset.msProductCalculatorPrimed = 'true';
      openCalculatorExperience(shell, { focus: false });
    });
  }

  function productCalculatorScrollableContainer(shell, target) {
    if (!shell || !target) return null;
    const flowPanel = shell.closest('.calculator-flow-panel');
    const stop = flowPanel || shell;
    const product = shell.closest('.product--visual-commerce');
    const productFlowWindowScroll = product && productFlowUsesWindowScroll(product.getAttribute('data-ms-product-flow-scroll-owner'));
    let node = target.parentElement;

    function isExplicitSubscroll(element) {
      if (!element) return false;
      if (element.hasAttribute('data-ms-product-flow-subscroll-node')) return true;
      return element.hasAttribute('data-ms-product-flow-subscroll')
        && element.getAttribute('data-ms-product-flow-subscroll') !== 'none';
    }

    function canScroll(element) {
      if (!element || !element.contains(target)) return false;
      if (productFlowWindowScroll && !isExplicitSubscroll(element)) return false;
      const style = getComputedStyle(element);
      if (style.overflowY === 'visible' || style.overflowY === 'clip') return false;
      return element.scrollHeight > element.clientHeight + 4;
    }

    while (node && node !== document.body) {
      if (canScroll(node)) return node;
      if (node === stop) break;
      node = node.parentElement;
    }
    return canScroll(shell) ? shell : null;
  }

  function productCalculatorScrollTargetIntoView(shell, target, options) {
    if (!shell || !target || !shell.contains(target)) return false;
    const scroller = productCalculatorScrollableContainer(shell, target);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const flowPanel = shell.closest('.calculator-flow-panel');
    const footer = flowPanel ? qs(':scope > .msn-wall-product-footer, :scope > .msn-pick-product-footer', flowPanel) : null;
    const preferTop = Boolean(options && options.preferTop && footer);
    const keepSurfaceFrame = Boolean(preferTop && flowPanel && flowPanel.dataset.msnSelectionProductFooter === 'true');
    const isMspaProductHost = quickShopIsMspaHost(shell) && shell.getAttribute('data-calculator-context') === 'product';
    const productFlowScrollOwner = shell.closest?.('.product--visual-commerce')?.getAttribute('data-ms-product-flow-scroll-owner');
    const productFlowWindowScroll = isMspaProductHost
      && productFlowUsesWindowScroll(productFlowScrollOwner);

    function ensureFooterInViewport() {
      if (isMspaProductHost && !productFlowWindowScroll) return;
      if (!footer) return;
      const footerRect = footer.getBoundingClientRect();
      const flowRect = (flowPanel || shell).getBoundingClientRect();
      const topLimit = purchaseSurfaceHeaderBottom() + 12;
      const bottomLimit = window.innerHeight - 18;
      let nextTop = window.scrollY;
      if (footerRect.bottom > bottomLimit) nextTop += footerRect.bottom - bottomLimit;
      if (!preferTop && flowRect.top < topLimit) nextTop -= topLimit - flowRect.top;
      nextTop = Math.max(0, nextTop);
      if (Math.abs(nextTop - window.scrollY) < 2) return;
      try {
        window.scrollTo({ top: nextTop, behavior: reducedMotion ? 'auto' : 'smooth' });
      } catch (error) {
        window.scrollTo(0, nextTop);
      }
    }

    function ensureTargetStartsViewport() {
      if (isMspaProductHost && !productFlowWindowScroll) return;
      if (!preferTop) return;
      const targetRect = target.getBoundingClientRect();
      const desiredTop = purchaseSurfaceHeaderBottom() + 12;
      const delta = targetRect.top - desiredTop;
      if (Math.abs(delta) < 8) return;
      const nextTop = Math.max(0, window.scrollY + delta);
      try {
        window.scrollTo({ top: nextTop, behavior: reducedMotion ? 'auto' : 'smooth' });
      } catch (error) {
        window.scrollTo(0, nextTop);
      }
    }

    if (!scroller) {
      if (isMspaProductHost && !productFlowWindowScroll) return false;
      if (preferTop) {
        const headerOffset = purchaseSurfaceHeaderBottom() + 12;
        const nextTop = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerOffset);
        try {
          window.scrollTo({ top: nextTop, behavior: reducedMotion ? 'auto' : 'smooth' });
        } catch (error) {
          window.scrollTo(0, nextTop);
        }
      } else {
        try {
          target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center', inline: 'nearest' });
        } catch (error) {
          target.scrollIntoView();
        }
      }
      if (!keepSurfaceFrame) window.setTimeout(ensureTargetStartsViewport, 120);
      window.setTimeout(ensureFooterInViewport, 220);
      return true;
    }

    const scrollerRect = scroller.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const footerRect = footer ? footer.getBoundingClientRect() : null;
    const topLimit = scrollerRect.top + 12;
    const bottomLimit = footerRect && footerRect.top > scrollerRect.top
      ? Math.min(scrollerRect.bottom - 12, footerRect.top - 12)
      : scrollerRect.bottom - 12;

    if (!preferTop && targetRect.top >= topLimit && targetRect.bottom <= bottomLimit) return false;

    const targetTop = targetRect.top - scrollerRect.top + scroller.scrollTop;
    const nextTop = Math.max(0, targetTop - (preferTop ? 8 : 12));
    try {
      scroller.scrollTo({ top: nextTop, behavior: preferTop || reducedMotion ? 'auto' : 'smooth' });
    } catch (error) {
      scroller.scrollTop = nextTop;
    }
    if (!keepSurfaceFrame) window.setTimeout(ensureTargetStartsViewport, 120);
    window.setTimeout(ensureFooterInViewport, 220);
    return true;
  }

  function bindProductCalculatorState(root) {
    qsa('.product--visual-commerce', root).forEach(function (product) {
      if (product.dataset.msProductCalculatorStateBound === 'true') return;
      const shell = qs('[data-ms-calculator-host][data-calculator-context="product"]', product);
      if (!shell) return;

      product.dataset.msProductCalculatorStateBound = 'true';
      let ticking = false;
      let lastCalculatorInteraction = 0;
      let lastReadyScrollKey = '';
      let readyScrollTimer = 0;

      function isUsable(element) {
        return !!(element && !element.hidden && !element.closest('[hidden]'));
      }

      function hasMeaningfulInput() {
        return qsa('input:not([type="hidden"]), textarea, select', shell).some(function (field) {
          if (field.disabled || !isUsable(field)) return false;
          if (field.matches('input[type="checkbox"], input[type="radio"]')) return field.checked;
          return String(field.value || '').trim() !== '';
        });
      }

      function hasReadyAction() {
        return qsa('[data-add-to-cart]', shell).some(function (button) {
          if (!isUsable(button)) return false;
          return !button.disabled && button.getAttribute('aria-disabled') !== 'true' && !button.hidden;
        });
      }

      function update() {
        ticking = false;
        product.classList.toggle('is-calculating', hasMeaningfulInput() || hasReadyAction());
      }

      function requestUpdate() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      function markCalculatorInteraction() {
        lastCalculatorInteraction = Date.now();
      }

      function maybeScrollReadySelection() {
        if (!lastCalculatorInteraction || Date.now() - lastCalculatorInteraction > 2600) return;
        const flow = quickShopCalculatorFlowState(shell);
        if (!flow || !flow.ready || flow.busy) return;
        const key = [flow.label || '', flow.reason || '', flow.summary || '', 'ready-selection'].join('|');
        if (key === lastReadyScrollKey) return;
        window.clearTimeout(readyScrollTimer);
        readyScrollTimer = window.setTimeout(function () {
          const target = purchaseSurfaceReadySelectionTarget(shell);
          if (!target) {
            window.setTimeout(function () {
              const retryTarget = purchaseSurfaceReadySelectionTarget(shell);
              if (!retryTarget) {
                lastReadyScrollKey = '';
                return;
              }
              lastReadyScrollKey = key;
              productCalculatorScrollTargetIntoView(shell, retryTarget, { preferTop: true });
            }, 320);
            return;
          }
          lastReadyScrollKey = key;
          productCalculatorScrollTargetIntoView(shell, target, { preferTop: true });
        }, 150);
      }

      shell.addEventListener('input', function () {
        markCalculatorInteraction();
        requestUpdate();
        window.setTimeout(maybeScrollReadySelection, 180);
        window.setTimeout(maybeScrollReadySelection, 620);
      }, true);
      shell.addEventListener('change', function () {
        markCalculatorInteraction();
        requestUpdate();
        window.setTimeout(maybeScrollReadySelection, 80);
        window.setTimeout(maybeScrollReadySelection, 620);
      }, true);
      shell.addEventListener('click', function () {
        markCalculatorInteraction();
        window.setTimeout(requestUpdate, 80);
        window.setTimeout(maybeScrollReadySelection, 120);
        window.setTimeout(maybeScrollReadySelection, 620);
      }, true);
      shell.addEventListener('ms:calculator-flow:update', function () {
        requestUpdate();
        maybeScrollReadySelection();
      });
      document.addEventListener('cartModal:done', requestUpdate);
      window.setTimeout(requestUpdate, 160);
    });
  }

  let reviewNavigationBound = false;

  function reviewWidgetTarget() {
    return qs('.stamped-reviews-app--product')
      || qs('#stamped-main-widget')
      || qs('[id*="stamped_reviews_main_widget"]')
      || qs('.stamped-main-widget')
      || qs('[data-widget-type*="review"]');
  }

  function ensureReviewTopButton() {
    const widget = reviewWidgetTarget();
    if (!widget || widget.dataset.msReviewTopButton === 'true') return;
    widget.dataset.msReviewTopButton = 'true';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ms-review-top-button';
    button.textContent = 'Til toppen';
    button.addEventListener('click', function () {
      scrollToElementWithHeaderOffset(qs('.product') || qs('#MainContent') || document.body);
    });

    widget.insertAdjacentElement('afterend', button);
  }

  function bindReviewNavigation(root) {
    ensureReviewTopButton();
    window.setTimeout(ensureReviewTopButton, 700);
    window.setTimeout(ensureReviewTopButton, 1800);

    if (reviewNavigationBound) return;
    reviewNavigationBound = true;

    document.addEventListener('click', function (event) {
      const target = event.target;
      if (!target || !target.closest) return;
      const badge = target.closest('.ms-native-rating-badge, .stamped-product-reviews-badge, .stamped-main-badge, .stamped-badge');
      if (!badge || badge.closest('#stamped-main-widget')) return;
      const reviewTarget = reviewWidgetTarget();
      if (!reviewTarget) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      scrollToElementWithHeaderOffset(reviewTarget);
      ensureReviewTopButton();
    }, true);
  }

  function openQuickShopShell(title) {
    const root = quickShopRoot();
    if (!root) return null;
    const drawer = qs('.quick-shop-drawer', root);
    const titleNode = qs('#QuickShopTitle', root);
    if (titleNode) {
      titleNode.textContent = root.getAttribute('data-quick-shop-label')
        || titleNode.getAttribute('data-quick-shop-default-title')
        || 'Quick Shop';
    }
    root.removeAttribute('hidden');
    document.body.classList.add('is-drawer-open');
    window.setTimeout(function () {
      root.classList.add('is-open');
      if (drawer) drawer.focus({ preventScroll: true });
    }, 10);
    return root;
  }

  function closeQuickShop(options) {
    const root = quickShopRoot();
    if (!root) return;
    window.clearTimeout(quickShopCalculationTimer);
    const closeToken = quickShopInvalidateActiveLoad();
    const content = quickShopContent();
    const productLocation = window.MSNO_AA_PRODUCT_LOCATION;
    if (content && productLocation && typeof productLocation.dispose === 'function') {
      productLocation.dispose(content);
    }
    const wasOpen = root.classList.contains('is-open') || !root.hasAttribute('hidden');
    if (!wasOpen) {
      root.classList.remove('is-handing-off', 'has-calculator', 'has-quick-actions', 'is-added-silently', 'is-minimizing-to-cart', 'is-calculating');
      document.body.classList.remove('ms-quick-shop-cart-pulse');
      return;
    }
    const config = options || {};
    const focusTarget = config.restoreFocus === false ? null : quickShopReturnFocusTarget;
    root.classList.remove('is-open');
    root.classList.remove('is-handing-off');
    root.classList.remove('has-calculator');
    root.classList.remove('has-quick-actions');
    root.classList.remove('is-added-silently');
    root.classList.remove('is-minimizing-to-cart');
    root.classList.remove('is-calculating');
    document.body.classList.remove('is-drawer-open');
    document.body.classList.remove('ms-quick-shop-cart-pulse');
    quickShopCartMode = null;
    if (quickShopActionObserver) {
      quickShopActionObserver.disconnect();
      quickShopActionObserver = null;
    }
    window.setTimeout(function () {
      if (quickShopActiveLoad && quickShopActiveLoad.token > closeToken) return;
      root.setAttribute('hidden', '');
      const content = quickShopContent();
      quickShopRestoreActions();
      if (content) content.innerHTML = '';
      const payments = qs('[data-quick-shop-payments]', root);
      if (payments) payments.hidden = true;
      setQuickShopStatus('', false);
      const actions = quickShopActions();
      if (actions) actions.hidden = true;
      const cue = qs('[data-quick-shop-scroll-cue]', root);
      if (cue) cue.hidden = true;
      const resetButton = quickShopResetButton();
      if (resetButton) resetButton.hidden = true;
      quickShopReturnFocusTarget = null;
      restoreQuickShopFocus(focusTarget);
    }, 220);
  }

  function closeQuickShopAfterCart() {
    const root = quickShopRoot();
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.add('is-handing-off');
    window.setTimeout(function () {
      closeQuickShop({ restoreFocus: false });
    }, 180);
  }

  async function loadQuickShop(url, title, trigger) {
    rememberQuickShopTrigger(trigger);
    const root = openQuickShopShell(title);
    const content = quickShopContent();
    if (!root || !content) return;
    const loadRequest = quickShopStartActiveLoad(url);

    quickShopResetTransientStateForLoad();
    quickShopRestoreActions();
    const payments = qs('[data-quick-shop-payments]', root);
    if (payments) payments.hidden = true;
    const productLocation = window.MSNO_AA_PRODUCT_LOCATION;
    if (productLocation && typeof productLocation.dispose === 'function') {
      productLocation.dispose(content);
    }
    content.innerHTML = '';
    setQuickShopStatus('Henter produktflyt...', true);

    try {
      const html = await quickShopFetchDocument(url);
      if (quickShopAbortStaleLoad(loadRequest)) return;
      content.innerHTML = html;
      await executeQuickShopScripts(content);
      if (quickShopAbortStaleLoad(loadRequest)) return;
      init(content);
      root.classList.toggle('has-calculator', !!qs('[data-ms-quick-shop-calculator]', content));
      quickShopUpdateResetButton();
      document.dispatchEvent(new CustomEvent('ms:quick-shop:loaded', {
        detail: { container: content, content: content }
      }));
      quickShopApplyLaunchOptions(trigger, content);
      quickShopInstallCalculatorCartBridge();
      primeQuickShopCalculator(content);
      setQuickShopStatus('', false);
      bindQuickShopActions();
      quickShopObserveContent();
      quickShopRefreshActions();
    } catch (error) {
      if (quickShopAbortStaleLoad(loadRequest)) return;
      setQuickShopStatus(customerMessageForError(error, { action: 'load', surface: 'quick-shop-load' }), true);
    }
  }

  function bindQuickShop(root) {
    qsa('[data-quick-shop-url]', root).forEach(function (button) {
      quickShopSchedulePreload(button);
      if (button.dataset.msQuickShopBound === 'true') return;
      button.dataset.msQuickShopBound = 'true';
      button.addEventListener('click', function () {
        loadQuickShop(button.getAttribute('data-quick-shop-url'), button.getAttribute('data-quick-shop-title'), button);
      });
    });

    qsa('[data-quick-shop-close]', root).forEach(function (button) {
      if (button.dataset.msQuickShopCloseBound === 'true') return;
      button.dataset.msQuickShopCloseBound = 'true';
      button.addEventListener('click', closeQuickShop);
    });

    qsa('[data-quick-shop-reset]', root).forEach(function (button) {
      if (button.dataset.msQuickShopResetBound === 'true') return;
      button.dataset.msQuickShopResetBound = 'true';
      button.addEventListener('click', quickShopResetCalculator);
    });
  }

  const smartPrefetchState = {
    seen: new Set(),
    queue: [],
    active: 0,
    total: 0,
    observer: null
  };

  function smartPrefetchConfig() {
    const performance = (window.MSTheme && window.MSTheme.performance) || {};
    const config = performance.smartPrefetch || {};
    return {
      enabled: config.enabled !== false,
      mode: config.mode === 'standard' ? 'standard' : 'conservative',
      quickShop: config.quickShop === true
    };
  }

  function canUseSmartPrefetch(config) {
    if (!config.enabled || !document.head || !window.URL) return false;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-data: reduce)').matches) return false;
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!connection) return true;
    if (connection.saveData) return false;
    return !['slow-2g', '2g'].includes(connection.effectiveType);
  }

  function normalizePrefetchUrl(rawUrl, options) {
    if (!rawUrl) return '';
    let url;
    try {
      url = new URL(rawUrl, window.location.href);
    } catch (error) {
      return '';
    }

    if (url.origin !== window.location.origin) return '';
    if (!/^https?:$/.test(url.protocol)) return '';

    const current = new URL(window.location.href);
    url.hash = '';
    if (url.href === current.href.replace(current.hash, '')) return '';

    const path = url.pathname.replace(/\/+$/, '') || '/';
    const blockedRoots = [
      '/cart',
      '/checkout',
      '/checkouts',
      '/account',
      '/search',
      '/admin',
      '/apps',
      '/challenge',
      '/password',
      '/orders'
    ];
    if (blockedRoots.some(function (root) { return path === root || path.indexOf(root + '/') === 0; })) return '';
    if (/\.(?:css|js|json|png|jpe?g|webp|gif|svg|pdf|zip|mp4|webm|xml)$/i.test(path)) return '';

    const isQuickShop = options && options.quickShop === true;
    if (url.search) {
      const params = url.searchParams;
      const onlyQuickShop = Array.from(params.keys()).length === 1 && params.get('view') === 'quick-shop';
      if (!isQuickShop || !onlyQuickShop) return '';
    }

    return url.href;
  }

  function enqueueSmartPrefetch(rawUrl, options) {
    const config = smartPrefetchConfig();
    if (!canUseSmartPrefetch(config)) return;

    const href = normalizePrefetchUrl(rawUrl, options);
    if (!href || smartPrefetchState.seen.has(href)) return;

    const maxTotal = config.mode === 'standard' ? 24 : 10;
    if (smartPrefetchState.total >= maxTotal) return;

    smartPrefetchState.seen.add(href);
    smartPrefetchState.queue.push(href);
    drainSmartPrefetchQueue(config);
  }

  function drainSmartPrefetchQueue(config) {
    const maxActive = config.mode === 'standard' ? 2 : 1;
    while (smartPrefetchState.active < maxActive && smartPrefetchState.queue.length) {
      const href = smartPrefetchState.queue.shift();
      smartPrefetchState.active += 1;
      smartPrefetchState.total += 1;

      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'document';
      link.href = href;
      link.dataset.msSmartPrefetch = 'true';

      const release = function () {
        if (link.dataset.msSmartPrefetchDone === 'true') return;
        link.dataset.msSmartPrefetchDone = 'true';
        smartPrefetchState.active = Math.max(0, smartPrefetchState.active - 1);
        drainSmartPrefetchQueue(config);
      };

      link.addEventListener('load', release, { once: true });
      link.addEventListener('error', release, { once: true });
      window.setTimeout(release, 4500);
      document.head.appendChild(link);
    }
  }

  function candidatePrefetchUrl(element, config) {
    if (!element || !element.closest) return '';
    const quickShopTrigger = element.matches && element.matches('[data-quick-shop-url]')
      ? element
      : element.closest('[data-quick-shop-url]');
    if (quickShopTrigger && config.quickShop) {
      return quickShopTrigger.getAttribute('data-quick-shop-url') || '';
    }

    const link = element.matches && element.matches('a[href]') ? element : element.closest('a[href]');
    if (!link) return '';
    if (link.target && link.target !== '_self') return '';
    if (link.hasAttribute('download')) return '';
    if ((link.getAttribute('rel') || '').toLowerCase().split(/\s+/).some(function (rel) {
      return rel === 'nofollow' || rel === 'external';
    })) return '';
    if (link.closest('[data-no-smart-prefetch], [data-smart-search], [data-quick-shop-drawer]')) return '';
    return link.href;
  }

  function bindSmartPagePrefetch(root) {
    const config = smartPrefetchConfig();
    if (!canUseSmartPrefetch(config)) return;

    qsa('a[href], [data-quick-shop-url]', root).forEach(function (element) {
      if (element.dataset.msSmartPrefetchBound === 'true') return;
      element.dataset.msSmartPrefetchBound = 'true';

      const prefetch = function () {
        const url = candidatePrefetchUrl(element, config);
        enqueueSmartPrefetch(url, { quickShop: element.hasAttribute('data-quick-shop-url') });
      };

      element.addEventListener('pointerenter', prefetch, { passive: true });
      element.addEventListener('touchstart', prefetch, { passive: true });
      element.addEventListener('mousedown', prefetch, { passive: true });
      element.addEventListener('focus', prefetch, { passive: true });
    });

    if (config.mode !== 'standard' || !('IntersectionObserver' in window)) return;
    if (!smartPrefetchState.observer) {
      smartPrefetchState.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          smartPrefetchState.observer.unobserve(entry.target);
          const url = candidatePrefetchUrl(entry.target, config);
          enqueueSmartPrefetch(url);
        });
      }, { rootMargin: '360px 0px' });
    }

    qsa('.product-card a[href], .subcollection-card a[href], .category-link-card a[href]', root).forEach(function (link) {
      if (link.dataset.msSmartPrefetchObserved === 'true') return;
      link.dataset.msSmartPrefetchObserved = 'true';
      smartPrefetchState.observer.observe(link);
    });
  }


  function hideNativePandectesTrigger() {
    document.documentElement.classList.add('ms-tabs-owns-pandectes');

    const cmp = qs('pandectes-cmp');
    const shadow = cmp && cmp.shadowRoot;
    if (!shadow) return false;

    qsa('.widget', shadow).forEach(function (element) {
      element.setAttribute('aria-hidden', 'true');
      element.setAttribute('tabindex', '-1');
      element.style.setProperty('display', 'none', 'important');
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('pointer-events', 'none', 'important');
    });

    return true;
  }

  function openPandectesPreferences() {
    if (window.Pandectes && typeof window.Pandectes.openDialog === 'function') {
      try {
        window.Pandectes.openDialog('preferences');
        return true;
      } catch (error) {
        try {
          window.Pandectes.openDialog('notice');
          return true;
        } catch (fallbackError) {}
      }
    }

    const cmp = qs('pandectes-cmp');
    const shadow = cmp && cmp.shadowRoot;
    const nativeTrigger = shadow && qs('.widget, button, [role="button"]', shadow);
    if (nativeTrigger && typeof nativeTrigger.click === 'function') {
      nativeTrigger.click();
      return true;
    }

    return false;
  }

  function bindPandectesPreferences(root) {
    window.MSTheme = window.MSTheme || {};
    window.MSTheme.openPandectesPreferences = openPandectesPreferences;

    qsa('[data-pandectes-preferences]:not([data-pandectes-bound])', root).forEach(function (button) {
      button.setAttribute('data-pandectes-bound', 'true');
      button.addEventListener('click', function (event) {
        event.preventDefault();
        hideNativePandectesTrigger();
        if (!openPandectesPreferences()) {
          window.setTimeout(openPandectesPreferences, 450);
        }
      });
    });

    if (window.MSTheme.pandectesPreferencesBound) return;
    window.MSTheme.pandectesPreferencesBound = true;

    document.addEventListener('PandectesInitialized', function () {
      hideNativePandectesTrigger();
    });

    document.addEventListener('PandectesDialogOpened', function () {
      document.documentElement.classList.add('ms-tabs-pandectes-open');
    });

    document.addEventListener('PandectesDialogClosed', function () {
      document.documentElement.classList.remove('ms-tabs-pandectes-open');
      window.setTimeout(hideNativePandectesTrigger, 120);
    });

    window.setTimeout(hideNativePandectesTrigger, 1500);
    window.setTimeout(hideNativePandectesTrigger, 5000);
  }

  function bindProductCardHoverImages(root) {
    qsa('.product-card__image-stack--has-hover:not([data-hover-image-bound])', root).forEach(function (stack) {
      var hoverImage = qs('.product-card__image--hover', stack);
      if (!hoverImage) return;

      stack.setAttribute('data-hover-image-bound', 'true');

      function markReady() {
        if (hoverImage.naturalWidth > 0 && hoverImage.naturalHeight > 0) {
          stack.classList.add('product-card__image-stack--hover-ready');
        } else {
          stack.classList.remove('product-card__image-stack--hover-ready');
        }
      }

      if (hoverImage.complete) {
        markReady();
      } else {
        hoverImage.addEventListener('load', markReady, { once: true });
        hoverImage.addEventListener('error', function () {
          stack.classList.remove('product-card__image-stack--hover-ready');
        }, { once: true });
      }
    });
  }

  function bindReadingFocusContainers(root) {
    qsa('.article-page__content:not([data-reading-focus-bound])', root).forEach(function (content) {
      content.setAttribute('data-reading-focus-bound', 'true');
      const itemSelector = 'p, h2, h3, h4, li, blockquote';

      const items = qsa(itemSelector, content)
        .filter(function (item) {
          if (item.closest('.article-faq-summary')) return false;
          return item.textContent && item.textContent.trim().length > 24;
        });

      if (items.length < 3) return;

      content.classList.add('has-reading-focus');
      items.forEach(function (item) {
        item.classList.add('ms-reading-focus-item');
      });

      let activeItem = null;
      let frame = 0;

      function updateActiveItem() {
        frame = 0;
        let nextItem = null;
        let bestScore = Infinity;
        const focusLine = window.innerHeight * 0.48;

        items.forEach(function (item) {
          const rect = item.getBoundingClientRect();
          if (rect.width <= 0 || rect.height <= 0) return;
          const itemCenter = rect.top + (rect.height / 2);
          const distance = Math.abs(focusLine - itemCenter);
          if (distance < bestScore) {
            bestScore = distance;
            nextItem = item;
          }
        });

        if (!nextItem || nextItem === activeItem) return;
        if (activeItem) activeItem.classList.remove('is-reading-focus');
        activeItem = nextItem;
        activeItem.classList.add('is-reading-focus');
      }

      function requestUpdate() {
        if (frame) return;
        if (typeof window.requestAnimationFrame === 'function') {
          frame = window.requestAnimationFrame(updateActiveItem);
        } else {
          frame = window.setTimeout(updateActiveItem, 16);
        }
      }

      requestUpdate();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
    });
  }

  function bindReadingMode(root) {
    qsa('[data-reading-mode-toggle]:not([data-reading-mode-bound])', root).forEach(function (button) {
      const article = button.closest('.article-page');
      if (!article) return;

      button.setAttribute('data-reading-mode-bound', 'true');

      let stored = 'true';
      try {
        stored = window.localStorage.getItem('ms_article_focus_mode');
        if (stored === null) stored = 'true';
      } catch (error) {}

      function update(enabled) {
        const defaultLabel = button.getAttribute('data-reading-mode-label') || 'Les med fokus';
        const activeLabel = button.getAttribute('data-reading-mode-active-label') || 'Skru av les med fokus';
        article.classList.remove('article-page--reading-mode');
        article.classList.toggle('article-page--focus-mode', !!enabled);
        button.setAttribute('aria-pressed', enabled ? 'true' : 'false');
        button.textContent = enabled ? activeLabel : defaultLabel;
        try {
          window.localStorage.setItem('ms_article_focus_mode', enabled ? 'true' : 'false');
        } catch (error) {}
      }

      update(stored !== 'false');
      button.addEventListener('click', function () {
        update(!article.classList.contains('article-page--focus-mode'));
      });
    });
  }

  function bindArticleGuide(root) {
    function escapeGuideText(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    qsa('.article-page__content:not([data-article-guide-bound])', root).forEach(function (content) {
      content.setAttribute('data-article-guide-bound', 'true');

      const article = content.closest('.article-page');
      if (!article || content.querySelector('.article-page__guide')) return;

      const headings = qsa('h2', content).filter(function (heading) {
        return !heading.closest('.article-product-spot, .article-faq-summary') && (heading.textContent || '').trim().length > 2;
      }).slice(0, 6);

      if (headings.length < 2) return;

      const usedIds = new Set();
      const slugify = function (text) {
        return (text || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '')
          .slice(0, 56) || 'seksjon';
      };

      const guide = document.createElement('nav');
      guide.className = 'article-page__guide';
      guide.setAttribute('aria-label', article.getAttribute('data-article-guide-label') || 'I denne guiden');

      const label = document.createElement('span');
      label.className = 'article-page__guide-label';
      label.textContent = article.getAttribute('data-article-guide-label') || 'I denne guiden';
      guide.appendChild(label);

      const links = document.createElement('div');
      links.className = 'article-page__guide-links';

      headings.forEach(function (heading, index) {
        let id = heading.id || slugify(heading.textContent);
        const baseId = id;
        let suffix = 2;
        while (usedIds.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
          id = baseId + '-' + suffix;
          suffix += 1;
        }
        heading.id = id;
        usedIds.add(id);

        const link = document.createElement('a');
        link.href = '#' + id;
        link.innerHTML = '<span>' + String(index + 1).padStart(2, '0') + '</span>' + escapeGuideText((heading.textContent || '').trim());
        links.appendChild(link);
      });

      guide.appendChild(links);
      content.prepend(guide);
    });
  }

  function bindArticleFaqSummary(root) {
    qsa('.article-page__content:not([data-article-faq-bound])', root).forEach(function (content) {
      content.setAttribute('data-article-faq-bound', 'true');

      const headings = qsa('h2, h3', content).filter(function (heading) {
        if (heading.closest('.article-faq-summary')) return false;
        const text = (heading.textContent || '').replace(/\s+/g, ' ').trim();
        if (text.length < 8 || text.length > 120) return false;
        return /\?$/.test(text) || /^(hva|hvordan|hvor|hvilken|hvilke|når|nar|kan|bør|bor|skal|må|ma)\b/i.test(text);
      });

      const questions = headings.slice(0, 6).map(function (heading) {
        const answerParts = [];
        let node = heading.nextElementSibling;
        while (node && !/^H[2-3]$/.test(node.tagName || '') && answerParts.length < 2) {
          if (!node.matches('.article-product-spot, .article-faq-summary')) {
            const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
            if (text.length > 30) answerParts.push(text);
          }
          node = node.nextElementSibling;
        }
        return {
          question: (heading.textContent || '').replace(/\s+/g, ' ').trim(),
          answer: answerParts.join(' ')
        };
      }).filter(function (item) {
        return item.question && item.answer;
      });

      if (questions.length < 2) return;

      const section = document.createElement('section');
      section.className = 'article-faq-summary';
      section.setAttribute('aria-label', 'Spørsmål og svar fra artikkelen');

      const eyebrow = document.createElement('p');
      eyebrow.className = 'article-faq-summary__eyebrow';
      eyebrow.textContent = 'Spørsmål og svar';
      section.appendChild(eyebrow);

      const title = document.createElement('h2');
      title.textContent = 'Kort oppsummert';
      section.appendChild(title);

      questions.forEach(function (item, index) {
        const detail = document.createElement('details');
        detail.className = 'article-faq-summary__item';
        if (index === 0) detail.open = true;

        const summary = document.createElement('summary');
        summary.textContent = item.question;
        detail.appendChild(summary);

        const answer = document.createElement('p');
        answer.textContent = item.answer.length > 260 ? item.answer.slice(0, 257).trim() + '...' : item.answer;
        detail.appendChild(answer);
        section.appendChild(detail);
      });

      content.appendChild(section);
    });
  }

  function revealArticleProductSpot(spot, observer) {
    setArticleProductContext(spot, true);
    trackArticleProductView(spot);
    if (observer) observer.unobserve(spot);
  }

  function articleProductImageSrc(src, width) {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width || 360));
      return url.toString();
    } catch (error) {
      return src;
    }
  }

  function articleProductPrice(product) {
    const variant = product && product.variants && product.variants[0];
    const rawPrice = variant && variant.price ? Number.parseFloat(variant.price) : Number.parseFloat(product && product.price);
    if (!Number.isFinite(rawPrice)) return '';

    return new Intl.NumberFormat('nb-NO', {
      style: 'currency',
      currency: 'NOK',
      maximumFractionDigits: rawPrice % 1 === 0 ? 0 : 2
    }).format(rawPrice);
  }

  function articleProductPrimaryId(product) {
    const variant = product && product.variants && product.variants[0];
    return String(
      (variant && (variant.sku || variant.id))
      || (product && (product.sku || product.id || product.handle))
      || ''
    );
  }

  const articleProductStopWords = new Set([
    'alle', 'andre', 'artikkel', 'av', 'bare', 'bedre', 'bli', 'blir', 'bruk', 'bruke', 'bruker',
    'deg', 'den', 'der', 'det', 'dette', 'din', 'dine', 'disse', 'du', 'eller', 'en', 'er', 'et',
    'for', 'fra', 'foran', 'forste', 'gjore', 'gjennom', 'god', 'gode', 'har', 'hele', 'her',
    'hva', 'hvordan', 'hvis', 'ikke', 'inn', 'kan', 'klar', 'lage', 'med', 'men', 'montere', 'montering', 'mot', 'mye',
    'nar', 'ned', 'noe', 'og', 'om', 'opp', 'over', 'pa', 'rett', 'riktig', 'skal', 'slik',
    'som', 'til', 'under', 'uten', 'ved', 'velg', 'vi', 'vil'
  ]);

  const articleProductSynonyms = {
    belegningsstein: ['helle', 'heller', 'brostein', 'metro', 'marksten'],
    hage: ['utemiljo', 'uterom'],
    hagesingel: ['singel', 'elvestein', 'dekorstein', 'edelsplitt'],
    kantstein: ['granittkantstein', 'kant'],
    mur: ['stottemur', 'megawall', 'miniblokk', 'boston', 'megasmart', 'megastone'],
    portstolpe: ['portstolper', 'granittstolpe', 'stolpe', 'stolper'],
    portstolp: ['portstolpe', 'portstolper', 'granittstolpe', 'stolpe', 'stolper'],
    stottemur: ['mur', 'megawall', 'miniblokk', 'boston', 'megasmart', 'megastone'],
    trapp: ['trinn', 'trappetrinn', 'megastep']
  };
  const articleProductAccessoryTokens = new Set([
    'palletillegg',
    'tilbehor',
    'geonett',
    'hjorne',
    'hjornesett',
    'hjorneblokk',
    'hjorn',
    'sabeljelke',
    'salebjelke',
    'monteringsknott',
    'knott',
    'toppblokk',
    'endeblokk',
    'avslutningsblokk',
    'fugesand',
    'lim',
    'rens',
    'impregnering'
  ]);
  const articleProductCollectionCache = new Map();
  const articleWallQueryTokens = new Set([
    'mur',
    'stottemur',
    'stottemurer',
    'megawall',
    'miniblokk',
    'boston',
    'megasmart',
    'megastone',
    'stottemurbetong',
    'stottemurblokk'
  ]);
  const articleWallPrimarySkus = ['2503010SN', '2501007SN', '2561007B', '2545007H', '2551007B'];
  const articleWallPrimarySkuSet = new Set(articleWallPrimarySkus);
  const articleRecommendationGroups = new Set([
    'stottemur',
    'multisize',
    'dekorstein_elvestein_hagesingel',
    'kantstein',
    'belegningsstein_heller',
    'granitt_brostein_kantstein',
    'ugress_fugesand_vedlikehold',
    'low_commercial'
  ]);
  const articleRecommendationGroupAliases = {
    mur: 'stottemur',
    stottemur: 'stottemur',
    stottemurer: 'stottemur',
    støttemur: 'stottemur',
    støttemurer: 'stottemur',
    dekorstein: 'dekorstein_elvestein_hagesingel',
    elvestein: 'dekorstein_elvestein_hagesingel',
    hagesingel: 'dekorstein_elvestein_hagesingel',
    singel: 'dekorstein_elvestein_hagesingel',
    brostein: 'granitt_brostein_kantstein',
    granitt: 'granitt_brostein_kantstein',
    granittkantstein: 'granitt_brostein_kantstein',
    fugesand: 'ugress_fugesand_vedlikehold',
    ugress: 'ugress_fugesand_vedlikehold',
    vedlikehold: 'ugress_fugesand_vedlikehold',
    heller: 'belegningsstein_heller',
    helle: 'belegningsstein_heller',
    belegningsstein: 'belegningsstein_heller'
  };

  function normalizeArticleProductText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ø/g, 'o')
      .replace(/æ/g, 'ae')
      .replace(/å/g, 'a')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function singularArticleProductToken(token) {
    return token
      .replace(/ene$/, '')
      .replace(/er$/, '')
      .replace(/ene$/, '')
      .replace(/s$/, '');
  }

  function articleProductTokenVariants(token) {
    const normalized = normalizeArticleProductText(token);
    const variants = new Set([normalized, singularArticleProductToken(normalized)]);

    if (normalized.endsWith('er') && normalized.length > 4) {
      variants.add(normalized.slice(0, -1));
    }

    if (normalized.endsWith('r') && normalized.length > 4) {
      variants.add(normalized.slice(0, -1));
    }

    return Array.from(variants).filter(Boolean);
  }

  function articleProductTokens(text) {
    const tokens = [];
    normalizeArticleProductText(text)
      .split(/\s+/)
      .forEach(function (rawToken) {
        articleProductTokenVariants(rawToken).forEach(function (token) {
          if (token.length > 2 && !articleProductStopWords.has(token)) tokens.push(token);
        });
      });
    return Array.from(new Set(tokens));
  }

  function articleProductQuery(pool) {
    const article = pool.closest('.article-page');
    if (!article) return [];

    const parts = [];
    const title = qs('.article-page__heading h1', article);
    if (title) parts.push(title.textContent || '');

    const articleHandle = pool.getAttribute('data-article-handle') || articleProductHandleFromArticleUrl(pool.getAttribute('data-article-url') || '');
    if (articleHandle) parts.push(articleHandle);

    qsa('.article-page__tags a, .article-page__heading .ms-eyebrow', article).forEach(function (item) {
      parts.push(item.textContent || '');
    });

    qsa('.article-page__content h2, .article-page__content h3', article)
      .slice(0, 6)
      .forEach(function (heading) {
        parts.push(heading.textContent || '');
      });

    const tokens = articleProductTokens(parts.join(' '));
    const expanded = new Set(tokens);
    tokens.forEach(function (token) {
      const synonyms = articleProductSynonyms[token] || articleProductSynonyms[singularArticleProductToken(token)] || [];
      synonyms.forEach(function (synonym) {
        expanded.add(singularArticleProductToken(normalizeArticleProductText(synonym)));
      });
    });
    return Array.from(expanded);
  }

  function articleProductHandleFromArticleUrl(url) {
    if (!url) return '';
    try {
      const parsed = new URL(url, window.location.origin);
      const parts = parsed.pathname.split('/').filter(Boolean);
      return parts[parts.length - 1] || '';
    } catch (error) {
      const parts = String(url || '').split('/').filter(Boolean);
      return parts[parts.length - 1] || '';
    }
  }

  function normalizeArticleRecommendationGroup(value) {
    const normalized = normalizeArticleProductText(value).replace(/\s+/g, '_');
    if (articleRecommendationGroups.has(normalized)) return normalized;
    const compact = normalized.replace(/_/g, '');
    if (articleRecommendationGroupAliases[normalized]) return articleRecommendationGroupAliases[normalized];
    if (articleRecommendationGroupAliases[compact]) return articleRecommendationGroupAliases[compact];
    return '';
  }

  function articleRecommendationArticleText(pool, includeContentHeadings, includeTags) {
    const article = pool.closest('.article-page');
    if (!article) return '';
    const parts = [
      pool.getAttribute('data-article-title') || '',
      pool.getAttribute('data-article-url') || '',
      pool.getAttribute('data-article-handle') || articleProductHandleFromArticleUrl(pool.getAttribute('data-article-url') || '')
    ];
    if (includeTags !== false) {
      qsa('.article-page__tags a, .article-page__heading .ms-eyebrow', article).forEach(function (item) {
        parts.push(item.textContent || '');
      });
    }
    if (includeContentHeadings !== false) {
      qsa('.article-page__content h2, .article-page__content h3', article)
        .slice(0, 8)
        .forEach(function (heading) {
          parts.push(heading.textContent || '');
        });
    }
    return normalizeArticleProductText(parts.join(' '));
  }

  function parseArticleRecommendationGroupRules(pool) {
    const raw = pool.getAttribute('data-article-recommendation-group-rules') || '';
    return raw.split(/\n+/).map(function (line) {
      const parts = line.split('|').map(function (part) { return part.trim(); }).filter(Boolean);
      if (parts.length < 2) return null;
      const group = normalizeArticleRecommendationGroup(parts[0]);
      const keywords = parts.slice(1).join(',').split(',').map(function (keyword) {
        return normalizeArticleProductText(keyword);
      }).filter(Boolean);
      if (!group || !keywords.length) return null;
      return { group: group, keywords: keywords };
    }).filter(Boolean);
  }

  function resolveArticleRecommendationGroup(pool, queryTokens) {
    const explicitGroup = normalizeArticleRecommendationGroup(pool.getAttribute('data-article-recommendation-group') || '');
    if (explicitGroup) {
      return {
        group: explicitGroup,
        source: 'group_metafield',
        reason: 'custom.recommendation_group'
      };
    }

    const rules = parseArticleRecommendationGroupRules(pool);
    const matchRule = function (rule, text, tokenSet) {
      return rule.keywords.find(function (keyword) {
        if (!keyword) return false;
        if (text.includes(keyword)) return true;
        return articleProductTokens(keyword).some(function (token) {
          return tokenSet.has(token) || tokenSet.has(singularArticleProductToken(token));
        });
      });
    };

    const titleText = articleRecommendationArticleText(pool, false, false);
    const titleTokens = new Set(articleProductTokens(titleText));
    for (const rule of rules) {
      const matchedKeyword = matchRule(rule, titleText, titleTokens);
      if (matchedKeyword) {
        return {
          group: rule.group,
          source: 'group_rule',
          reason: matchedKeyword
        };
      }
    }

    const primaryText = articleRecommendationArticleText(pool, false, true);
    const primaryTokens = new Set(articleProductTokens(primaryText));
    for (const rule of rules) {
      const matchedKeyword = matchRule(rule, primaryText, primaryTokens);
      if (matchedKeyword) {
        return {
          group: rule.group,
          source: 'group_rule',
          reason: matchedKeyword
        };
      }
    }

    const fullText = articleRecommendationArticleText(pool, true, true);
    const tokenSet = new Set(queryTokens || []);
    for (const rule of rules) {
      const matchedKeyword = matchRule(rule, fullText, tokenSet);
      if (matchedKeyword) {
        return {
          group: rule.group,
          source: 'group_rule',
          reason: matchedKeyword
        };
      }
    }

    return { group: '', source: 'none', reason: 'no_group' };
  }

  function articleProductText(product) {
    return normalizeArticleProductText([
      product.title,
      product.handle,
      product.vendor,
      product.product_type,
      Array.isArray(product.tags) ? product.tags.join(' ') : product.tags
    ].filter(Boolean).join(' '));
  }

  function articleProductSkus(product) {
    const skus = [];
    if (product && product.sku) skus.push(product.sku);
    if (product && Array.isArray(product.variants)) {
      product.variants.forEach(function (variant) {
        if (variant && variant.sku) skus.push(variant.sku);
      });
    }
    return skus.map(function (sku) {
      return String(sku || '').trim().toUpperCase();
    }).filter(Boolean);
  }


  function articleProductHasWallIntent(queryTokens) {
    return queryTokens.some(function (token) {
      return articleWallQueryTokens.has(token) || articleWallQueryTokens.has(singularArticleProductToken(token));
    });
  }

  function articleProductRotated(products, limit, seed) {
    if (!products.length || products.length <= limit) return products.slice(0, limit);
    const safeSeed = Math.abs(Number(seed) || 0);
    const start = safeSeed % products.length;
    return products.slice(start).concat(products.slice(0, start)).slice(0, limit);
  }

  async function fetchArticleProductCollection(handle) {
    const collectionHandle = handle || 'google-shopping';
    if (articleProductCollectionCache.has(collectionHandle)) {
      return articleProductCollectionCache.get(collectionHandle);
    }

    const promise = (async function () {
      const products = [];
      for (let page = 1; page <= 4; page += 1) {
        const response = await fetch('/collections/' + encodeURIComponent(collectionHandle) + '/products.json?limit=250&page=' + page, {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        });
        if (!response.ok) break;
        const payload = await response.json();
        const pageProducts = Array.isArray(payload.products) ? payload.products : [];
        products.push.apply(products, pageProducts);
        if (pageProducts.length < 250) break;
      }
      return products.filter(function (product) {
        return product && product.handle;
      });
    })();

    articleProductCollectionCache.set(collectionHandle, promise);
    return promise;
  }

  function pickArticleWallProducts(products, queryTokens, limit) {
    if (!articleProductHasWallIntent(queryTokens)) return [];

    const bySku = new Map();
    products.forEach(function (product) {
      articleProductSkus(product).forEach(function (sku) {
        if (articleWallPrimarySkuSet.has(sku) && !bySku.has(sku)) {
          bySku.set(sku, product);
        }
      });
    });

    const ordered = articleWallPrimarySkus.map(function (sku) {
      return bySku.get(sku);
    }).filter(Boolean);

    const seed = Math.floor(Date.now() / 86400000);
    return articleProductRotated(ordered, limit, seed);
  }

  function scoreArticleProduct(product, queryTokens) {
    if (!queryTokens.length) return 0;

    const title = normalizeArticleProductText(product.title);
    const handle = normalizeArticleProductText(product.handle);
    const productText = articleProductText(product);
    let score = 0;

    queryTokens.forEach(function (token) {
      if (!token) return;
      const tokenPattern = new RegExp('(^| )' + token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      if (tokenPattern.test(title)) score += 7;
      else if (title.includes(token)) score += 5;
      if (tokenPattern.test(handle)) score += 4;
      if (productText.includes(token)) score += 2;
    });

    if (product.available === false) score -= 4;
    return score;
  }

  function articleProductAllowsAccessory(queryTokens) {
    return queryTokens.some(function (token) {
      return articleProductAccessoryTokens.has(token) || articleProductAccessoryTokens.has(singularArticleProductToken(token));
    });
  }

  function articleProductIsAccessory(product) {
    const text = articleProductText(product);
    return Array.from(articleProductAccessoryTokens).some(function (token) {
      return text.includes(token);
    });
  }

  function parseArticleMatrixProductToken(value) {
    const raw = String(value || '').trim();
    if (!raw) return null;
    const parts = raw.split('@').map(function (part) { return part.trim(); }).filter(Boolean);
    let handle = '';
    let sku = '';
    if (parts.length > 1) {
      handle = parts[0];
      sku = parts.slice(1).join('@');
    } else if (/^[A-Z0-9._-]{4,}$/i.test(raw) && /\d/.test(raw) && raw.toUpperCase() === raw) {
      sku = raw;
    } else {
      handle = raw;
    }
    return {
      raw: raw,
      handle: normalizeArticleProductHandle(handle),
      sku: String(sku || '').trim().toUpperCase(),
      text: normalizeArticleProductText(raw)
    };
  }

  function normalizeArticleProductHandle(value) {
    return String(value || '').trim().toLowerCase().replace(/^\/products\//, '').replace(/^products\//, '').replace(/[?#].*$/, '');
  }

  function parseArticleProductMatrixSegment(part) {
    const value = String(part || '').trim();
    const match = value.match(/^([^:]+):(.+)$/);
    if (!match) return { key: '', value: value };
    const keyText = normalizeArticleProductText(match[1]);
    let key = '';
    if (keyText === 'a' || keyText === 'primary' || keyText === 'hoved' || keyText === 'hovedprodukt') key = 'a';
    if (keyText === 'b' || keyText === 'secondary' || keyText === 'sekundaer' || keyText === 'sekundar' || keyText === 'stotte') key = 'b';
    if (keyText === 'exclude' || keyText === 'excluded' || keyText === 'ekskludert' || keyText === 'ikke bruk' || keyText === 'ikke') key = 'exclude';
    if (keyText === 'limit' || keyText === 'antall') key = 'limit';
    return { key: key, value: match[2].trim() };
  }

  function parseArticleProductRecommendationMatrix(pool) {
    const raw = pool.getAttribute('data-article-product-matrix') || '';
    const matrix = new Map();
    raw.split(/\n+/).forEach(function (line) {
      const parts = line.split('|').map(function (part) { return part.trim(); }).filter(Boolean);
      if (!parts.length) return;
      const group = normalizeArticleRecommendationGroup(parts[0]);
      if (!group) return;
      const entry = matrix.get(group) || { a: [], b: [], exclude: [], limit: 0 };
      parts.slice(1).forEach(function (part, index) {
        const segment = parseArticleProductMatrixSegment(part);
        const key = segment.key || (index === 0 ? 'a' : '');
        if (key === 'limit') {
          const parsedLimit = Number.parseInt(segment.value, 10);
          if (Number.isFinite(parsedLimit) && parsedLimit >= 0) entry.limit = Math.min(parsedLimit, 6);
          return;
        }
        const items = segment.value.split(',').map(parseArticleMatrixProductToken).filter(Boolean);
        if (key === 'exclude') entry.exclude = entry.exclude.concat(items);
        else if (key === 'b') entry.b = entry.b.concat(items);
        else entry.a = entry.a.concat(items);
      });
      matrix.set(group, entry);
    });
    return matrix;
  }

  function articleProductMatchesMatrixToken(product, token) {
    if (!product || !token) return false;
    if (token.handle && normalizeArticleProductHandle(product.handle) === token.handle) return true;
    if (token.sku && articleProductSkus(product).includes(token.sku)) return true;
    if (token.text && !token.handle && !token.sku) {
      const text = articleProductText(product);
      return text.includes(token.text) || articleProductTokens(token.text).every(function (item) {
        return text.includes(item);
      });
    }
    return false;
  }

  function findArticleMatrixProduct(products, token) {
    if (!token) return null;
    if (token.handle) {
      const byHandle = products.find(function (product) {
        return normalizeArticleProductHandle(product.handle) === token.handle;
      });
      if (byHandle) return byHandle;
    }
    if (token.sku) {
      const bySku = products.find(function (product) {
        return articleProductSkus(product).includes(token.sku);
      });
      if (bySku) return bySku;
    }
    return products.find(function (product) {
      return articleProductMatchesMatrixToken(product, token);
    }) || null;
  }

  function articleProductExcludedByMatrix(product, entry) {
    if (!entry || !entry.exclude || !entry.exclude.length) return false;
    return entry.exclude.some(function (token) {
      return articleProductMatchesMatrixToken(product, token);
    });
  }

  function pickArticleMatrixProducts(pool, products, queryTokens, limit) {
    const groupInfo = resolveArticleRecommendationGroup(pool, queryTokens);
    if (!groupInfo.group) return { products: [], group: '', source: groupInfo.source, reason: groupInfo.reason };

    const matrix = parseArticleProductRecommendationMatrix(pool);
    const entry = matrix.get(groupInfo.group);
    if (!entry) return { products: [], group: groupInfo.group, source: groupInfo.source, reason: 'missing_matrix_group' };

    const effectiveLimit = Math.max(0, Math.min(entry.limit || limit, limit, 6));
    if (effectiveLimit <= 0) {
      return { products: [], group: groupInfo.group, source: groupInfo.source, reason: groupInfo.reason || 'group_limit_zero' };
    }

    const selected = [];
    const seen = new Set();
    entry.a.concat(entry.b).forEach(function (token) {
      if (selected.length >= effectiveLimit) return;
      const product = findArticleMatrixProduct(products, token);
      if (!product || !product.handle || product.available === false) return;
      if (articleProductExcludedByMatrix(product, entry)) return;
      const handle = normalizeArticleProductHandle(product.handle);
      if (seen.has(handle)) return;
      seen.add(handle);
      selected.push(product);
    });

    return {
      products: selected,
      group: groupInfo.group,
      source: groupInfo.source,
      reason: groupInfo.reason
    };
  }

  function articleProductBooleanSetting(value) {
    return String(value || '').trim().toLowerCase() === 'true';
  }

  function setArticleProductSpotMetadata(spot, metadata) {
    if (!spot || !metadata) return spot;
    if (metadata.articleHandle) spot.setAttribute('data-article-handle', metadata.articleHandle);
    if (metadata.position) spot.setAttribute('data-product-position', String(metadata.position));
    if (metadata.group) spot.setAttribute('data-recommendation-group', metadata.group);
    if (metadata.source) spot.setAttribute('data-recommendation-source', metadata.source);
    if (metadata.reason) spot.setAttribute('data-recommendation-reason', metadata.reason);
    return spot;
  }

  function setArticleProductContext(spot, isVisible) {
    const anchor = spot && spot.msArticleProductAnchor;
    spot.classList.toggle('is-visible', !!isVisible);
    if (anchor) anchor.classList.toggle('ms-article-product-context', !!isVisible);
  }

  function pickArticleProducts(products, queryTokens, limit) {
    const scored = products
      .map(function (product, index) {
        return { product: product, index: index, score: scoreArticleProduct(product, queryTokens) };
      })
      .filter(function (entry) {
        return entry.product && entry.product.handle;
      });

    const matches = scored
      .filter(function (entry) { return entry.score >= 7; })
      .sort(function (a, b) {
        return b.score - a.score || a.index - b.index;
      });

    if (matches.length) {
      const relevant = !articleProductAllowsAccessory(queryTokens)
        ? matches.filter(function (entry) { return !articleProductIsAccessory(entry.product); })
        : matches;
      return (relevant.length ? relevant : matches).slice(0, limit).map(function (entry) { return entry.product; });
    }

    const available = scored.filter(function (entry) {
      return entry.product.available !== false;
    });
    const fallback = available.length ? available : scored;
    const availableFallback = !articleProductAllowsAccessory(queryTokens)
      ? fallback.filter(function (entry) { return !articleProductIsAccessory(entry.product); })
      : fallback;
    const finalFallback = availableFallback.length ? availableFallback : fallback;
    const fallbackStart = finalFallback.length > limit
      ? Math.floor((Date.now() / 86400000) % Math.max(finalFallback.length - limit, 1))
      : 0;
    return finalFallback.slice(fallbackStart, fallbackStart + limit).map(function (entry) { return entry.product; });
  }

  function createArticleProductSpot(product, metadata) {
    const spot = document.createElement('aside');
    spot.className = 'article-product-spot';
    spot.setAttribute('data-article-product-spot', '');
    spot.setAttribute('data-article-product-title', product.title || '');
    spot.setAttribute('data-article-product-handle', product.handle || '');
    spot.setAttribute('data-article-product-id', articleProductPrimaryId(product));
    spot.setAttribute('aria-label', 'Aktuelt produkt');
    setArticleProductSpotMetadata(spot, metadata);

    let productUrl = product.url || ('/products/' + product.handle);
    try {
      productUrl = new URL(productUrl, window.location.origin).pathname;
    } catch (error) {
      productUrl = '/products/' + product.handle;
    }
    const image = (product.images && product.images[0]) || product.featured_image || product.image;
    const imageSrc = typeof image === 'string' ? image : image && (image.src || image.url);
    const imageAlt = typeof image === 'string' ? product.title : image && image.alt;
    if (imageSrc) {
      const mediaLink = document.createElement('a');
      mediaLink.className = 'article-product-spot__media';
      mediaLink.href = productUrl;
      mediaLink.setAttribute('aria-label', product.title || 'Produkt');
      mediaLink.setAttribute('data-article-product-link', '');
      mediaLink.setAttribute('data-article-product-title', product.title || '');
      mediaLink.setAttribute('data-article-product-handle', product.handle || '');
      mediaLink.setAttribute('data-article-product-id', articleProductPrimaryId(product));

      const img = document.createElement('img');
      img.src = articleProductImageSrc(imageSrc, 360);
      img.srcset = [
        articleProductImageSrc(imageSrc, 160) + ' 160w',
        articleProductImageSrc(imageSrc, 240) + ' 240w',
        articleProductImageSrc(imageSrc, 320) + ' 320w',
        articleProductImageSrc(imageSrc, 420) + ' 420w'
      ].join(', ');
      img.sizes = '(min-width: 720px) 150px, 104px';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = imageAlt || product.title || '';
      mediaLink.appendChild(img);
      spot.appendChild(mediaLink);
    }

    const body = document.createElement('div');
    body.className = 'article-product-spot__body';

    const eyebrow = document.createElement('span');
    eyebrow.className = 'article-product-spot__eyebrow';
    eyebrow.textContent = metadata && metadata.eyebrow ? metadata.eyebrow : 'Materialer i guiden';
    body.appendChild(eyebrow);

    const title = document.createElement('h2');
    title.className = 'article-product-spot__title';
    const titleLink = document.createElement('a');
    titleLink.href = productUrl;
    titleLink.textContent = product.title || 'Produkt';
    titleLink.setAttribute('data-article-product-link', '');
    titleLink.setAttribute('data-article-product-title', product.title || '');
    titleLink.setAttribute('data-article-product-handle', product.handle || '');
    titleLink.setAttribute('data-article-product-id', articleProductPrimaryId(product));
    title.appendChild(titleLink);
    body.appendChild(title);

    const price = articleProductPrice(product);
    if (price) {
      const priceNode = document.createElement('p');
      priceNode.className = 'article-product-spot__price';
      priceNode.textContent = 'Fra ' + price;
      body.appendChild(priceNode);
    }

    const button = document.createElement('button');
    button.className = 'article-product-spot__button';
    button.type = 'button';
    button.textContent = product.available === false ? 'Utsolgt' : ((metadata && metadata.buttonLabel) || 'Se raskt');
    if (product.available === false) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.setAttribute('data-quick-shop-url', productUrl + '?view=quick-shop');
      button.setAttribute('data-quick-shop-title', product.title || 'Produkt');
    }
    button.setAttribute('data-article-product-source', '');
    button.setAttribute('data-article-product-title', product.title || '');
    button.setAttribute('data-article-product-handle', product.handle || '');
    button.setAttribute('data-article-product-id', articleProductPrimaryId(product));
    body.appendChild(button);

    spot.appendChild(body);
    return spot;
  }




  function parseArticleProductPriorityRules(pool) {
    const raw = pool.getAttribute('data-article-product-priority-rules') || '';
    return raw.split(/\n+/).map(function (line) {
      const parts = line.split('|').map(function (part) { return part.trim(); }).filter(Boolean);
      if (parts.length < 2) return null;
      const rule = {
        keywords: articleProductTokens(parts[0]),
        tiers: {
          a: [],
          b: [],
          c: [],
          exclude: []
        }
      };

      parts.slice(1).forEach(function (part, index) {
        const parsed = parseArticleProductPrioritySegment(part, index === 0 ? 'a' : '');
        if (!parsed.tier || !parsed.products.length) return;
        rule.tiers[parsed.tier] = rule.tiers[parsed.tier].concat(parsed.products);
      });

      return rule;
    }).filter(function (rule) {
      return rule
        && rule.keywords.length
        && (rule.tiers.a.length || rule.tiers.b.length || rule.tiers.c.length);
    });
  }

  function parseArticleProductPrioritySegment(part, fallbackTier) {
    let tier = fallbackTier || '';
    let value = String(part || '').trim();
    const match = value.match(/^([^:]+):(.+)$/);
    if (match) {
      const detectedTier = normalizeArticleProductPriorityTier(match[1]);
      if (detectedTier) {
        tier = detectedTier;
        value = match[2].trim();
      }
    }

    return {
      tier: tier || 'a',
      products: value.split(',').map(function (item) { return item.trim(); }).filter(Boolean)
    };
  }

  function normalizeArticleProductPriorityTier(value) {
    const normalized = normalizeArticleProductText(value);
    if (normalized === 'a' || normalized === 'push' || normalized === 'hoved' || normalized === 'hovedprodukt' || normalized === 'hovedprodukter') return 'a';
    if (normalized === 'b' || normalized === 'stotte' || normalized === 'stotteprodukt' || normalized === 'stotteprodukter') return 'b';
    if (normalized === 'c' || normalized === 'lav' || normalized === 'bare relevant' || normalized === 'bare hvis relevant') return 'c';
    if (normalized === 'exclude' || normalized === 'excluded' || normalized === 'ekskludert' || normalized === 'utelatt' || normalized === 'ikke vis') return 'exclude';
    return '';
  }

  function articleProductRuleMatches(rule, queryTokens) {
    const query = new Set(queryTokens);
    return rule.keywords.some(function (keyword) {
      return query.has(keyword) || query.has(singularArticleProductToken(keyword));
    });
  }

  function findArticleProductInCollection(products, productQuery) {
    const queryTokens = articleProductTokens(productQuery);
    if (!queryTokens.length) return null;

    const exactQuery = normalizeArticleProductText(productQuery);
    const exact = products.find(function (product) {
      return normalizeArticleProductText(product.title) === exactQuery || normalizeArticleProductText(product.handle) === exactQuery;
    });
    if (exact) return exact;

    const scored = products.map(function (product, index) {
      const title = normalizeArticleProductText(product.title);
      const handle = normalizeArticleProductText(product.handle);
      const productText = articleProductText(product);
      let score = 0;

      if (title.includes(exactQuery)) score += 80;
      if (handle.includes(exactQuery)) score += 60;
      if (title.indexOf(exactQuery) === 0) score += 25;
      queryTokens.forEach(function (token) {
        if (title.includes(token)) score += 12;
        else if (productText.includes(token)) score += 6;
      });

      if (queryTokens.every(function (token) { return productText.includes(token); })) score += 25;
      if (!articleProductAllowsAccessory(queryTokens) && articleProductIsAccessory(product)) score -= 60;
      if (articleProductHasWallIntent(queryTokens) && (title.includes('helblokk') || title.includes('normalblokk'))) score += 25;
      if (product.available === false) score -= 5;

      return { product: product, index: index, score: score };
    }).filter(function (entry) {
      return entry.score > 0;
    }).sort(function (a, b) {
      return b.score - a.score || a.index - b.index;
    });

    return (scored[0] && scored[0].product) || null;
  }

  function articleProductMatchesProductQuery(product, productQuery) {
    const queryTokens = articleProductTokens(productQuery);
    if (!queryTokens.length) return false;
    const exactQuery = normalizeArticleProductText(productQuery);
    const productText = articleProductText(product);
    return productText.includes(exactQuery) || queryTokens.every(function (token) {
      return productText.includes(token);
    });
  }

  function articleProductExcludedByRule(product, rule) {
    return rule.tiers.exclude.some(function (productQuery) {
      return articleProductMatchesProductQuery(product, productQuery);
    });
  }

  async function priorityArticleProducts(pool, queryTokens, limit, collectionProducts) {
    const rules = parseArticleProductPriorityRules(pool).filter(function (rule) {
      return articleProductRuleMatches(rule, queryTokens);
    });
    if (!rules.length) return [];

    const selected = [];
    const seen = new Set();
    for (const rule of rules) {
      ['a', 'b', 'c'].forEach(function (tier) {
        for (const productQuery of rule.tiers[tier]) {
          if (selected.length >= limit) break;
          const product = findArticleProductInCollection(collectionProducts, productQuery);
          if (
            product
            && product.handle
            && !seen.has(product.handle)
            && !articleProductExcludedByRule(product, rule)
          ) {
            seen.add(product.handle);
            selected.push(product);
          }
        }
      });
    }
    return selected;
  }

  async function loadArticleProductSpots(pool) {
    let spots = qsa('[data-article-product-spot]', pool);
    if (spots.length) {
      spots.forEach(function (spot, index) {
        setArticleProductSpotMetadata(spot, {
          articleHandle: pool.getAttribute('data-article-handle') || articleProductHandleFromArticleUrl(pool.getAttribute('data-article-url') || ''),
          position: Number.parseInt(spot.getAttribute('data-product-position') || '', 10) || index + 1,
          group: spot.getAttribute('data-recommendation-group') || pool.getAttribute('data-article-recommendation-group') || '',
          source: spot.getAttribute('data-recommendation-source') || 'manual_metafield',
          reason: spot.getAttribute('data-recommendation-reason') || 'custom.article_products'
        });
      });
      return spots;
    }

    const handle = pool.getAttribute('data-article-product-collection') || 'google-shopping';
    const limit = Math.max(1, Math.min(Number.parseInt(pool.getAttribute('data-article-product-limit') || '3', 10) || 3, 6));
    const queryTokens = articleProductQuery(pool);
    const collectionProducts = await fetchArticleProductCollection(handle).catch(function () { return []; });
    if (!collectionProducts.length) return [];

    const articleHandle = pool.getAttribute('data-article-handle') || articleProductHandleFromArticleUrl(pool.getAttribute('data-article-url') || '');
    const configuredEyebrow = pool.getAttribute('data-article-product-eyebrow') || 'Materialer i guiden';
    const configuredButtonLabel = pool.getAttribute('data-article-product-button-label') || 'Se raskt';
    const matrixResult = pickArticleMatrixProducts(pool, collectionProducts, queryTokens, limit);
    if (matrixResult.products.length) {
      matrixResult.products.slice(0, limit).forEach(function (product, index) {
        pool.appendChild(createArticleProductSpot(product, {
          articleHandle: articleHandle,
          position: index + 1,
          group: matrixResult.group,
          source: matrixResult.source || 'group_rule',
          reason: matrixResult.reason || 'product_matrix',
          eyebrow: configuredEyebrow,
          buttonLabel: configuredButtonLabel
        }));
      });
      return qsa('[data-article-product-spot]', pool);
    }

    if (!articleProductBooleanSetting(pool.getAttribute('data-article-legacy-fallback'))) {
      return [];
    }

    const priorityProducts = await priorityArticleProducts(pool, queryTokens, limit, collectionProducts).catch(function () { return []; });
    if (priorityProducts.length) {
      priorityProducts.slice(0, limit).forEach(function (product) {
        pool.appendChild(createArticleProductSpot(product, {
          articleHandle: articleHandle,
          group: matrixResult.group || '',
          source: 'legacy_priority_rules',
          reason: 'legacy_fuzzy_fallback',
          eyebrow: configuredEyebrow,
          buttonLabel: configuredButtonLabel
        }));
      });
      return qsa('[data-article-product-spot]', pool);
    }

    const wallProducts = pickArticleWallProducts(collectionProducts, queryTokens, limit);
    if (wallProducts.length) {
      wallProducts.forEach(function (product, index) {
        pool.appendChild(createArticleProductSpot(product, {
          articleHandle: articleHandle,
          position: index + 1,
          group: 'stottemur',
          source: 'legacy_wall_rules',
          reason: 'legacy_fuzzy_fallback',
          eyebrow: configuredEyebrow,
          buttonLabel: configuredButtonLabel
        }));
      });
      return qsa('[data-article-product-spot]', pool);
    }

    const strongSearchProducts = pickArticleProducts(collectionProducts, queryTokens, limit);
    if (strongSearchProducts.length) {
      strongSearchProducts.forEach(function (product, index) {
        pool.appendChild(createArticleProductSpot(product, {
          articleHandle: articleHandle,
          position: index + 1,
          group: matrixResult.group || '',
          source: 'legacy_text_match',
          reason: 'legacy_fuzzy_fallback',
          eyebrow: configuredEyebrow,
          buttonLabel: configuredButtonLabel
        }));
      });
      return qsa('[data-article-product-spot]', pool);
    }

    spots = qsa('[data-article-product-spot]', pool);
    return spots;
  }

  function bindArticleProductSpots(root) {
    qsa('[data-article-product-spots]:not([data-article-product-spots-bound])', root).forEach(function (pool) {
      const article = pool.closest('.article-page');
      const content = article ? qs('.article-page__content', article) : null;
      if (!content) return;

      pool.setAttribute('data-article-product-spots-bound', 'true');

      loadArticleProductSpots(pool).then(function (spots) {
        if (!spots.length) {
          pool.remove();
          return;
        }

        const articleTitle = pool.getAttribute('data-article-title') || '';
        const articleUrl = pool.getAttribute('data-article-url') || window.location.pathname;
        const productEyebrow = pool.getAttribute('data-article-product-eyebrow') || 'Materialer i guiden';
        const productButtonLabel = pool.getAttribute('data-article-product-button-label') || 'Se raskt';
        const anchors = qsa('p, h2, h3', content).filter(function (item) {
          return item.textContent && item.textContent.trim().length > 40;
        });
        const positions = [3, 8, 13, 18, 23, 28];

        spots.forEach(function (spot, index) {
          const anchorIndex = Math.min(positions[index] || (3 + (index * 5)), Math.max(anchors.length - 1, 0));
          const anchor = anchors[anchorIndex];

          spot.setAttribute('data-article-title', articleTitle);
          spot.setAttribute('data-article-url', articleUrl);
          setArticleProductSpotMetadata(spot, {
            articleHandle: spot.getAttribute('data-article-handle') || pool.getAttribute('data-article-handle') || articleProductHandleFromArticleUrl(articleUrl),
            position: Number.parseInt(spot.getAttribute('data-product-position') || '', 10) || index + 1,
            group: spot.getAttribute('data-recommendation-group') || pool.getAttribute('data-article-recommendation-group') || '',
            source: spot.getAttribute('data-recommendation-source') || 'unknown',
            reason: spot.getAttribute('data-recommendation-reason') || '',
            eyebrow: productEyebrow,
            buttonLabel: productButtonLabel
          });
          spot.classList.add('article-product-spot--pending');
          spot.msArticleProductAnchor = anchor || null;
          if (anchor) {
            anchor.insertAdjacentElement('afterend', spot);
          } else {
            content.appendChild(spot);
          }
        });

        pool.remove();
        bindQuickShop(content);
        bindArticleProductAttribution(content);

        const insertedSpots = qsa('.article-product-spot--pending', content);
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                revealArticleProductSpot(entry.target, observer);
              } else {
                setArticleProductContext(entry.target, false);
              }
            });
          }, { rootMargin: '-12% 0px -18% 0px', threshold: 0.18 });

          insertedSpots.forEach(function (spot) {
            observer.observe(spot);
          });
        } else {
          insertedSpots.forEach(function (spot) {
            revealArticleProductSpot(spot);
          });
        }
      }).catch(function () {
        pool.remove();
      });
    });
  }

  function articleProductHandleFromUrl(url) {
    if (!url) return '';
    try {
      const parsed = new URL(url, window.location.origin);
      const match = parsed.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      const match = String(url).match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    }
  }

  function articleProductDetails(trigger) {
    const spot = trigger && trigger.closest ? trigger.closest('[data-article-product-spot]') : trigger;
    const article = trigger && trigger.closest ? trigger.closest('.article-page') : (spot && spot.closest ? spot.closest('.article-page') : null);
    const pool = article ? qs('[data-article-product-spots]', article) : null;
    const heading = article ? qs('.article-page__heading h1', article) : null;
    const title = (
      (spot && spot.getAttribute('data-article-title'))
      || (pool && pool.getAttribute('data-article-title'))
      || (heading && heading.textContent)
      || document.title
      || ''
    ).trim();
    const articleUrl = (
      (spot && spot.getAttribute('data-article-url'))
      || (pool && pool.getAttribute('data-article-url'))
      || window.location.pathname
    ).trim();
    const productTitle = (
      (trigger && trigger.getAttribute && trigger.getAttribute('data-article-product-title'))
      || (trigger && trigger.getAttribute && trigger.getAttribute('data-quick-shop-title'))
      || (spot && spot.getAttribute('data-article-product-title'))
      || (qs('.article-product-spot__title', spot || document) || {}).textContent
      || ''
    ).trim();
    const productHandle = (
      (trigger && trigger.getAttribute && trigger.getAttribute('data-article-product-handle'))
      || (spot && spot.getAttribute('data-article-product-handle'))
      || articleProductHandleFromUrl(trigger && trigger.href)
      || ''
    ).trim();
    const productId = (
      (trigger && trigger.getAttribute && trigger.getAttribute('data-article-product-id'))
      || (spot && spot.getAttribute('data-article-product-id'))
      || productHandle
      || productTitle
    ).trim();
    const articleHandle = (
      (spot && spot.getAttribute('data-article-handle'))
      || (pool && pool.getAttribute('data-article-handle'))
      || articleProductHandleFromArticleUrl(articleUrl)
      || ''
    ).trim();
    const productPosition = Number.parseInt((spot && spot.getAttribute('data-product-position')) || '', 10) || 0;
    const recommendationGroup = (
      (spot && spot.getAttribute('data-recommendation-group'))
      || (pool && pool.getAttribute('data-article-recommendation-group'))
      || ''
    ).trim();
    const recommendationSource = ((spot && spot.getAttribute('data-recommendation-source')) || '').trim();
    const recommendationReason = ((spot && spot.getAttribute('data-recommendation-reason')) || '').trim();

    return {
      source: 'Blogg+artikkel',
      ms_source: 'blog_article',
      article: title,
      articleUrl: articleUrl,
      articleHandle: articleHandle,
      product: productTitle,
      productHandle: productHandle,
      productId: productId,
      productPosition: productPosition,
      recommendationGroup: recommendationGroup,
      recommendationReason: recommendationReason,
      recommendationSource: recommendationSource,
      ms_article: title,
      ms_article_url: articleUrl,
      ms_article_handle: articleHandle,
      ms_blog_product: productTitle,
      ms_blog_product_handle: productHandle,
      ms_blog_product_position: productPosition,
      ms_recommendation_group: recommendationGroup,
      ms_recommendation_reason: recommendationReason,
      ms_recommendation_source: recommendationSource
    };
  }

  function articleProductCartAttributes(details) {
    return {
      'Kilde': 'Blogg+artikkel',
      'Bloggartikkel': details.article,
      'Bloggartikkel URL': details.articleUrl,
      'Bloggprodukt': details.product,
      'Bloggprodukt handle': details.productHandle,
      'ms_source': 'blog_article',
      'ms_article': details.article,
      'ms_article_url': details.articleUrl,
      'ms_article_handle': details.articleHandle,
      'ms_blog_product': details.product,
      'ms_blog_product_handle': details.productHandle,
      'ms_blog_product_position': details.productPosition ? String(details.productPosition) : '',
      'ms_recommendation_group': details.recommendationGroup || '',
      'ms_recommendation_reason': details.recommendationReason || '',
      'ms_recommendation_source': details.recommendationSource || ''
    };
  }

  function syncArticleProductAttribution(details, options) {
    const updatedAt = options && options.preserveTimestamp && details.updatedAt
      ? details.updatedAt
      : new Date().toISOString();
    const storedDetails = Object.assign({}, details, {
      ms_source: 'blog_article',
      ms_article: details.ms_article || details.article || '',
      ms_article_url: details.ms_article_url || details.articleUrl || '',
      ms_article_handle: details.ms_article_handle || details.articleHandle || '',
      ms_blog_product: details.ms_blog_product || details.product || '',
      ms_blog_product_handle: details.ms_blog_product_handle || details.productHandle || '',
      ms_blog_product_position: details.ms_blog_product_position || details.productPosition || '',
      ms_recommendation_group: details.ms_recommendation_group || details.recommendationGroup || '',
      ms_recommendation_reason: details.ms_recommendation_reason || details.recommendationReason || '',
      ms_recommendation_source: details.ms_recommendation_source || details.recommendationSource || '',
      updatedAt: updatedAt
    });
    try {
      window.sessionStorage.setItem('ms_blog_attribution', JSON.stringify(storedDetails));
    } catch (error) {}

    const body = JSON.stringify({
      attributes: articleProductCartAttributes(details)
    });
    const route = (window.MSTheme && window.MSTheme.routes && window.MSTheme.routes.cartUpdate) || '/cart/update.js';

    const request = {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    };

    if (options && options.keepalive) {
      request.keepalive = true;
    }

    return aaRunCartWrite('ATTRIBUTION', async function (lease) {
      const currentCart = await quickShopFetchCart();
      const currentAttributes = currentCart && currentCart.attributes && typeof currentCart.attributes === 'object'
        ? currentCart.attributes
        : {};
      const expectedAttributes = articleProductCartAttributes(details);
      const alreadyMaterialized = Object.keys(expectedAttributes).every(function (key) {
        return String(currentAttributes[key] || '') === String(expectedAttributes[key] || '');
      });
      if (alreadyMaterialized) return true;
      await lease.markMutation(route);
      await aaMarkCartRequestSent(lease);
      const response = await quickShopFetch(route, request);
      await aaMarkCartResponseReceived(lease);
      if (!response.ok) throw new Error(`Kunne ikke lagre attribusjon (${response.status}).`);
      return true;
    }).catch(function () { return false; });
  }

  function articleProductAnalyticsItem(details) {
    return {
      item_name: details.product,
      item_id: details.productId || details.productHandle || details.product,
      item_list_id: 'blog_article',
      item_list_name: 'Blogg artikkel',
      item_list_position: details.productPosition || undefined,
      index: details.productPosition || undefined,
      recommendation_group: details.recommendationGroup || '',
      recommendation_source: details.recommendationSource || '',
      recommendation_reason: details.recommendationReason || ''
    };
  }

  function articleProductCleanAnalyticsParams(params) {
    const cleaned = {};
    Object.keys(params || {}).forEach(function (key) {
      const value = params[key];
      if (value == null || value === '') return;
      cleaned[key] = value;
    });
    return cleaned;
  }

  function articleProductGa4Destination() {
    return OWN_ANALYTICS_DESTINATION;
  }

  function articleProductGtagParams(details, interaction, item) {
    const params = articleProductCleanAnalyticsParams({
      source: 'miljostein_blog_article',
      ms_source: 'blog_article',
      ms_article: details.article,
      ms_article_url: details.articleUrl,
      article_handle: details.articleHandle || '',
      ms_article_handle: details.articleHandle || '',
      ms_blog_product: details.product,
      ms_blog_product_handle: details.productHandle,
      product_position: details.productPosition || 0,
      recommendation_group: details.recommendationGroup || '',
      recommendation_reason: details.recommendationReason || '',
      recommendation_source: details.recommendationSource || '',
      article_product_interaction: interaction || '',
      item_list_id: 'blog_article',
      item_list_name: 'Blogg artikkel',
      items: [item]
    });
    const destination = articleProductGa4Destination();
    if (destination) params.send_to = destination;
    return params;
  }

  function sendArticleProductAnalytics(eventName, details, interaction, viewElement) {
    const item = articleProductAnalyticsItem(details);
    const payload = {
      event: eventName,
      source: 'miljostein_blog_article',
      ms_source: 'blog_article',
      ms_article: details.article,
      ms_article_url: details.articleUrl,
      article_handle: details.articleHandle || '',
      ms_article_handle: details.articleHandle || '',
      ms_blog_product: details.product,
      ms_blog_product_handle: details.productHandle,
      product_position: details.productPosition || 0,
      recommendation_group: details.recommendationGroup || '',
      recommendation_reason: details.recommendationReason || '',
      recommendation_source: details.recommendationSource || '',
      article_product_interaction: interaction || '',
      ecommerce: {
        item_list_id: 'blog_article',
        item_list_name: 'Blogg artikkel',
        items: [item]
      }
    };

    const events = [{ name: eventName, params: articleProductGtagParams(details, interaction, item), payload: payload }];
    if (eventName === 'ms_article_product_click') {
      events.push({
        name: 'select_item',
        params: articleProductGtagParams(details, interaction, item),
        payload: Object.assign({}, payload, { event: 'select_item' })
      });
    }
    try {
      document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    } catch (error) {}
    return queueOwnAnalytics(events, viewElement, 'data-article-product-view-tracked');
  }

  function trackArticleProductView(spot) {
    const attribute = 'data-article-product-view-tracked';
    if (!ownAnalyticsAllowed() || !ownAnalyticsVisible(spot) || ownAnalyticsViewPending(spot, attribute)) return;
    sendArticleProductAnalytics('ms_article_product_view', articleProductDetails(spot), 'view', spot);
  }

  function readBlogArticleAttribution() {
    try {
      const attribution = JSON.parse(window.sessionStorage.getItem('ms_blog_attribution') || '{}');
      if (!attribution || (attribution.ms_source !== 'blog_article' && attribution.source !== 'Blogg+artikkel')) return null;
      return {
        ms_source: 'blog_article',
        ms_article: attribution.ms_article || attribution.article || '',
        ms_article_url: attribution.ms_article_url || attribution.articleUrl || '',
        ms_article_handle: attribution.ms_article_handle || attribution.articleHandle || '',
        ms_blog_product: attribution.ms_blog_product || attribution.product || '',
        ms_blog_product_handle: attribution.ms_blog_product_handle || attribution.productHandle || '',
        ms_blog_product_position: attribution.ms_blog_product_position || attribution.productPosition || '',
        ms_recommendation_group: attribution.ms_recommendation_group || attribution.recommendationGroup || '',
        ms_recommendation_reason: attribution.ms_recommendation_reason || attribution.recommendationReason || '',
        ms_recommendation_source: attribution.ms_recommendation_source || attribution.recommendationSource || ''
      };
    } catch (error) {
      return null;
    }
  }

  function readStoredBlogArticleDetails() {
    try {
      const attribution = JSON.parse(window.sessionStorage.getItem('ms_blog_attribution') || '{}');
      if (!attribution || (attribution.ms_source !== 'blog_article' && attribution.source !== 'Blogg+artikkel')) return null;
      return {
        source: 'Blogg+artikkel',
        ms_source: 'blog_article',
        article: attribution.article || attribution.ms_article || '',
        articleUrl: attribution.articleUrl || attribution.ms_article_url || '',
        articleHandle: attribution.articleHandle || attribution.ms_article_handle || '',
        product: attribution.product || attribution.ms_blog_product || '',
        productHandle: attribution.productHandle || attribution.ms_blog_product_handle || '',
        productId: attribution.productId || attribution.productHandle || attribution.ms_blog_product_handle || '',
        productPosition: Number.parseInt(attribution.productPosition || attribution.ms_blog_product_position || '', 10) || 0,
        recommendationGroup: attribution.recommendationGroup || attribution.ms_recommendation_group || '',
        recommendationReason: attribution.recommendationReason || attribution.ms_recommendation_reason || '',
        recommendationSource: attribution.recommendationSource || attribution.ms_recommendation_source || '',
        updatedAt: attribution.updatedAt || ''
      };
    } catch (error) {
      return null;
    }
  }

  function syncStoredBlogArticleAttributionToCart() {
    const details = readStoredBlogArticleDetails();
    if (!details || !details.article || !details.product) return;

    try {
      const key = 'ms_blog_attribution_cart_synced_at';
      if (details.updatedAt && window.sessionStorage.getItem(key) === details.updatedAt) return;
      syncArticleProductAttribution(details, { preserveTimestamp: true }).then(function (materialized) {
        if (materialized === true && details.updatedAt) window.sessionStorage.setItem(key, details.updatedAt);
      });
    } catch (error) {}
  }

  function shouldEnrichBlogAttributionEvent(eventName) {
    return eventName === 'add_to_cart'
      || eventName === 'begin_checkout'
      || eventName === 'purchase'
      || eventName === 'checkout'
      || eventName === 'ms_cart_checkout_clicked'
      || eventName === 'ms_cart_offer_clicked'
      || eventName === 'ms_cart_offer_revealed'
      || eventName === 'ms_cart_offer_form_open'
      || /^ms_cart_/.test(eventName || '');
  }

  function enrichBlogAttributionPayload(payload) {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload) || !payload.event) return payload;
    if (!shouldEnrichBlogAttributionEvent(payload.event)) return payload;
    const attribution = readBlogArticleAttribution();
    if (!attribution) return payload;

    const enriched = Object.assign({}, payload);
    Object.keys(attribution).forEach(function (key) {
      if (enriched[key] == null || enriched[key] === '') {
        enriched[key] = attribution[key];
      }
    });
    return enriched;
  }

  function installBlogAttributionDataLayerBridge() {
    if (window.__msBlogAttributionDataLayerBridge) return;
    window.__msBlogAttributionDataLayerBridge = true;
    window.dataLayer = window.dataLayer || [];
    const originalPush = window.dataLayer.push.bind(window.dataLayer);
    window.dataLayer.push = function () {
      const args = Array.prototype.map.call(arguments, enrichBlogAttributionPayload);
      return originalPush.apply(window.dataLayer, args);
    };
  }

  function bindArticleProductAttribution(root) {
    qsa('[data-article-product-spot]:not([data-article-product-attribution-bound])', root).forEach(function (spot) {
      spot.setAttribute('data-article-product-attribution-bound', 'true');
      spot.addEventListener('click', function (event) {
        const target = event.target && event.target.closest
          ? event.target.closest('[data-article-product-source], [data-article-product-link], a[href*="/products/"]')
          : null;
        if (!target || !spot.contains(target)) return;
        if (target.disabled || target.getAttribute('aria-disabled') === 'true') return;

        const details = articleProductDetails(target);
        const isProductLink = target.tagName === 'A' && target.href;
        const interaction = isProductLink ? 'product_link' : 'quick_shop';
        sendArticleProductAnalytics('ms_article_product_click', details, interaction);

        if (!isProductLink) {
          syncArticleProductAttribution(details, { keepalive: true });
          return;
        }

        syncArticleProductAttribution(details, { keepalive: true });

        if (
          event.defaultPrevented
          || event.metaKey
          || event.ctrlKey
          || event.shiftKey
          || event.altKey
          || (target.target && target.target !== '_self')
        ) {
          return;
        }

        // Normal navigation continues after attribution has been saved locally.
      });
    });
  }


  function init(root) {
    bindOwnAnalyticsConsent();
    installBlogAttributionDataLayerBridge();
    syncStoredBlogArticleAttributionToCart();
    bindDrawers(root);
    bindProductDescriptionAccordions(root);
    bindGallery(root);
    bindStickyHeader();
    bindCustomerHelpGuide(root);
    bindProductMediaReveal(root);
    bindFilterToggle(root);
    bindExclusiveDetails(root);
    bindPredictiveSearch(root);
    bindQuickShop(root);
    bindProductPurchaseSurfaces(root);
    bindProductFlow(root);
    bindAaCartIntegration(root);
    bindProductSendLink(root);
    bindQuickShopActions();
    primeProductCalculatorFlow(root);
    bindProductCalculatorState(root);
    bindReviewNavigation(root);
    bindSmartPagePrefetch(root);
    bindProductCardHoverImages(root);
    bindReadingMode(root);
    bindArticleGuide(root);
    bindReadingFocusContainers(root);
    bindArticleFaqSummary(root);
    bindArticleProductSpots(root);
    bindArticleProductAttribution(root);
    bindPandectesPreferences(root);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (
      qs('.drawer.is-open:not([hidden])')
      || qs('[data-product-media-modal]:not([hidden])')
      || qs('[data-quick-shop-root].is-open:not([hidden])')
      || qs('[data-customer-help-guide].is-open:not([hidden])')
    ) {
      return;
    }
    qsa('.drawer.is-open').forEach(function (drawer) {
      closeDrawer(drawer.id);
    });
    qsa('[data-smart-search-panel]').forEach(function (panel) {
      panel.setAttribute('hidden', '');
    });
    closeProductMediaModals();
    closeQuickShop();
  });

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-smart-search]')) return;
    qsa('[data-smart-search-panel]').forEach(function (panel) {
      panel.setAttribute('hidden', '');
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('cartModal:done', closeQuickShopAfterCart);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const root = event.target;
    if (stickyHeaderController && (root === stickyHeaderController.header || root.contains(stickyHeaderController.header))) {
      stickyHeaderController.destroy();
      stickyHeaderController = null;
    }
    customerHelpControllers.forEach(function (controller, guide) {
      if (root === guide || root.contains(guide)) controller.destroy();
    });
  });

  window.MSTheme = window.MSTheme || {};
  window.MSTheme.version = VERSION;
  document.documentElement.setAttribute('data-ms-theme-runtime-identity', RUNTIME_IDENTITY);
  window.MSTheme.init = init;
})();
/* ms-theme build: customer-help-delivery-status-20260517 */
